const nm = "이미지영역2";
const h = 430;
const w = 362;
const meta = {
	g: "@lottiefiles/toolkit-js 0.71.8"
};
const layers = [
	{
		ty: 0,
		nm: "잔액모으기",
		sr: 1,
		st: 0,
		op: 300,
		ip: 0,
		ln: "796",
		hasMask: false,
		ao: 0,
		ks: {
			a: {
				a: 0,
				k: [
					181,
					215
				]
			},
			s: {
				a: 0,
				k: [
					125,
					125
				]
			},
			p: {
				a: 0,
				k: [
					181,
					283.997
				]
			},
			r: {
				a: 0,
				k: 0
			},
			sa: {
				a: 0,
				k: 0
			},
			o: {
				a: 0,
				k: 100
			}
		},
		w: 362,
		h: 430,
		refId: "1",
		ind: 1
	}
];
const v = "5.7.0";
const fr = 29.97;
const op = 200.122;
const ip = 0;
const fonts = {
	list: [
		{
			ascent: 74.1,
			fClass: "",
			fFamily: "Noto Sans KR",
			fStyle: "Bold",
			fName: "NotoSansKR-Bold",
			fPath: "",
			fWeight: "",
			origin: 0
		}
	]
};
const chars = [
	{
		ch: "잔",
		fFamily: "Noto Sans KR",
		size: 10,
		style: "Bold",
		w: 92,
		data: {
			shapes: [
				{
					ty: "gr",
					nm: "",
					it: [
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											1.9,
											-5.267
										],
										[
											3.833,
											-3.933
										],
										[
											5.933,
											-2
										],
										[
											0,
											0
										],
										[
											-2.767,
											2.033
										],
										[
											-1.8,
											2.6
										],
										[
											-0.833,
											2.9
										],
										[
											0,
											2.933
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											5.867
										],
										[
											-1.9,
											5.267
										],
										[
											-3.833,
											3.933
										],
										[
											0,
											0
										],
										[
											3.867,
											-1.267
										],
										[
											2.767,
											-2.033
										],
										[
											1.8,
											-2.6
										],
										[
											0.833,
											-2.9
										],
										[
											0,
											0
										]
									],
									v: [
										[
											24.7,
											-66.3
										],
										[
											24.7,
											-72.1
										],
										[
											35.6,
											-72.1
										],
										[
											35.6,
											-66.3
										],
										[
											32.75,
											-49.6
										],
										[
											24.15,
											-35.8
										],
										[
											9.5,
											-26.9
										],
										[
											2.7,
											-37.4
										],
										[
											12.65,
											-42.35
										],
										[
											19.5,
											-49.3
										],
										[
											23.45,
											-57.55
										],
										[
											24.7,
											-66.3
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-1.467,
											-3.567
										],
										[
											-3.167,
											-2.833
										],
										[
											-4.933,
											-1.667
										],
										[
											0,
											0
										],
										[
											3.733,
											3.733
										],
										[
											1.833,
											4.933
										],
										[
											0,
											5.533
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											3.6
										],
										[
											1.467,
											3.567
										],
										[
											3.167,
											2.833
										],
										[
											0,
											0
										],
										[
											-5.533,
											-1.867
										],
										[
											-3.733,
											-3.733
										],
										[
											-1.833,
											-4.933
										],
										[
											0,
											0
										]
									],
									v: [
										[
											27.3,
											-66.3
										],
										[
											27.3,
											-72.1
										],
										[
											38.1,
											-72.1
										],
										[
											38.1,
											-66.3
										],
										[
											40.3,
											-55.55
										],
										[
											47.25,
											-45.95
										],
										[
											59.4,
											-39.2
										],
										[
											52.3,
											-29.2
										],
										[
											38.4,
											-37.6
										],
										[
											30.05,
											-50.6
										],
										[
											27.3,
											-66.3
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											6.5,
											-66.4
										],
										[
											6.5,
											-77
										],
										[
											56.3,
											-77
										],
										[
											56.3,
											-66.4
										],
										[
											6.5,
											-66.4
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											63.6,
											-15.9
										],
										[
											63.6,
											-83.7
										],
										[
											76.9,
											-83.7
										],
										[
											76.9,
											-15.9
										],
										[
											63.6,
											-15.9
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											73.2,
											-45.9
										],
										[
											73.2,
											-56.9
										],
										[
											89.2,
											-56.9
										],
										[
											89.2,
											-45.9
										],
										[
											73.2,
											-45.9
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											17.2,
											7.3
										],
										[
											17.2,
											-3.4
										],
										[
											80.2,
											-3.4
										],
										[
											80.2,
											7.3
										],
										[
											17.2,
											7.3
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											17.2,
											2.3
										],
										[
											17.2,
											-22.5
										],
										[
											30.6,
											-22.5
										],
										[
											30.6,
											2.3
										]
									]
								}
							}
						}
					]
				}
			]
		}
	},
	{
		ch: "액",
		fFamily: "Noto Sans KR",
		size: 10,
		style: "Bold",
		w: 92,
		data: {
			shapes: [
				{
					ty: "gr",
					nm: "",
					it: [
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											-3.167,
											-1.9
										],
										[
											-1.833,
											-3.4
										],
										[
											0,
											-4.467
										],
										[
											1.833,
											-3.433
										],
										[
											3.167,
											-1.9
										],
										[
											4.133,
											0
										],
										[
											3.2,
											1.9
										],
										[
											1.8,
											3.433
										],
										[
											0,
											4.4
										],
										[
											-1.8,
											3.4
										],
										[
											-3.2,
											1.9
										],
										[
											-4.067,
											0
										]
									],
									o: [
										[
											4.133,
											0
										],
										[
											3.167,
											1.9
										],
										[
											1.833,
											3.4
										],
										[
											0,
											4.4
										],
										[
											-1.833,
											3.433
										],
										[
											-3.167,
											1.9
										],
										[
											-4.067,
											0
										],
										[
											-3.2,
											-1.9
										],
										[
											-1.8,
											-3.433
										],
										[
											0,
											-4.467
										],
										[
											1.8,
											-3.4
										],
										[
											3.2,
											-1.9
										],
										[
											0,
											0
										]
									],
									v: [
										[
											25.5,
											-78.1
										],
										[
											36.45,
											-75.25
										],
										[
											43.95,
											-67.3
										],
										[
											46.7,
											-55.5
										],
										[
											43.95,
											-43.75
										],
										[
											36.45,
											-35.75
										],
										[
											25.5,
											-32.9
										],
										[
											14.6,
											-35.75
										],
										[
											7.1,
											-43.75
										],
										[
											4.4,
											-55.5
										],
										[
											7.1,
											-67.3
										],
										[
											14.6,
											-75.25
										],
										[
											25.5,
											-78.1
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											1.4,
											-0.933
										],
										[
											0.733,
											-1.667
										],
										[
											0,
											-2.467
										],
										[
											-0.733,
											-1.733
										],
										[
											-1.4,
											-0.9
										],
										[
											-1.8,
											0
										],
										[
											-1.4,
											0.9
										],
										[
											-0.767,
											1.733
										],
										[
											0,
											2.4
										],
										[
											0.767,
											1.667
										],
										[
											1.4,
											0.933
										],
										[
											1.8,
											0
										]
									],
									o: [
										[
											-1.8,
											0
										],
										[
											-1.4,
											0.933
										],
										[
											-0.733,
											1.667
										],
										[
											0,
											2.4
										],
										[
											0.733,
											1.733
										],
										[
											1.4,
											0.9
										],
										[
											1.8,
											0
										],
										[
											1.4,
											-0.9
										],
										[
											0.767,
											-1.733
										],
										[
											0,
											-2.467
										],
										[
											-0.767,
											-1.667
										],
										[
											-1.4,
											-0.933
										],
										[
											0,
											0
										]
									],
									v: [
										[
											25.5,
											-67
										],
										[
											20.7,
											-65.6
										],
										[
											17.5,
											-61.7
										],
										[
											16.4,
											-55.5
										],
										[
											17.5,
											-49.3
										],
										[
											20.7,
											-45.35
										],
										[
											25.5,
											-44
										],
										[
											30.3,
											-45.35
										],
										[
											33.55,
											-49.3
										],
										[
											34.7,
											-55.5
										],
										[
											33.55,
											-61.7
										],
										[
											30.3,
											-65.6
										],
										[
											25.5,
											-67
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											70.3,
											-28.5
										],
										[
											70.3,
											-83.7
										],
										[
											83,
											-83.7
										],
										[
											83,
											-28.5
										],
										[
											70.3,
											-28.5
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											59.3,
											-50.6
										],
										[
											59.3,
											-61.3
										],
										[
											74,
											-61.3
										],
										[
											74,
											-50.6
										],
										[
											59.3,
											-50.6
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											50.9,
											-28.8
										],
										[
											50.9,
											-82.1
										],
										[
											63.3,
											-82.1
										],
										[
											63.3,
											-28.8
										],
										[
											50.9,
											-28.8
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											19.3,
											-13.7
										],
										[
											19.3,
											-24.3
										],
										[
											83,
											-24.3
										],
										[
											83,
											8.9
										],
										[
											69.7,
											8.9
										],
										[
											69.7,
											-13.7
										]
									]
								}
							}
						}
					]
				}
			]
		}
	},
	{
		ch: "모",
		fFamily: "Noto Sans KR",
		size: 10,
		style: "Bold",
		w: 92,
		data: {
			shapes: [
				{
					ty: "gr",
					nm: "",
					it: [
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											4.1,
											-1.9
										],
										[
											4.1,
											-12.7
										],
										[
											88,
											-12.7
										],
										[
											88,
											-1.9
										],
										[
											4.1,
											-1.9
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											39.3,
											-10.1
										],
										[
											39.3,
											-33.1
										],
										[
											52.5,
											-33.1
										],
										[
											52.5,
											-10.1
										],
										[
											39.3,
											-10.1
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											12.9,
											-31.4
										],
										[
											12.9,
											-76.9
										],
										[
											78.8,
											-76.9
										],
										[
											78.8,
											-31.4
										],
										[
											12.9,
											-31.4
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											65.7,
											-42
										],
										[
											65.7,
											-66.4
										],
										[
											26,
											-66.4
										],
										[
											26,
											-42
										]
									]
								}
							}
						}
					]
				}
			]
		}
	},
	{
		ch: "으",
		fFamily: "Noto Sans KR",
		size: 10,
		style: "Bold",
		w: 92,
		data: {
			shapes: [
				{
					ty: "gr",
					nm: "",
					it: [
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											-5.233,
											-2.2
										],
										[
											-3.033,
											-4
										],
										[
											0,
											-5.4
										],
										[
											3.033,
											-4.033
										],
										[
											5.233,
											-2.2
										],
										[
											6.533,
											0
										],
										[
											5.233,
											2.2
										],
										[
											3.067,
											4.033
										],
										[
											0,
											5.4
										],
										[
											-3.067,
											4
										],
										[
											-5.233,
											2.2
										],
										[
											-6.467,
											0
										]
									],
									o: [
										[
											6.533,
											0
										],
										[
											5.233,
											2.2
										],
										[
											3.033,
											4
										],
										[
											0,
											5.4
										],
										[
											-3.033,
											4.033
										],
										[
											-5.233,
											2.2
										],
										[
											-6.467,
											0
										],
										[
											-5.233,
											-2.2
										],
										[
											-3.067,
											-4.033
										],
										[
											0,
											-5.4
										],
										[
											3.067,
											-4
										],
										[
											5.233,
											-2.2
										],
										[
											0,
											0
										]
									],
									v: [
										[
											45.9,
											-79.1
										],
										[
											63.55,
											-75.8
										],
										[
											75.95,
											-66.5
										],
										[
											80.5,
											-52.4
										],
										[
											75.95,
											-38.25
										],
										[
											63.55,
											-28.9
										],
										[
											45.9,
											-25.6
										],
										[
											28.35,
											-28.9
										],
										[
											15.9,
											-38.25
										],
										[
											11.3,
											-52.4
										],
										[
											15.9,
											-66.5
										],
										[
											28.35,
											-75.8
										],
										[
											45.9,
											-79.1
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											3.267,
											-1.267
										],
										[
											1.833,
											-2.367
										],
										[
											0,
											-3.333
										],
										[
											-1.833,
											-2.367
										],
										[
											-3.267,
											-1.267
										],
										[
											-4.133,
											0
										],
										[
											-3.233,
											1.267
										],
										[
											-1.833,
											2.367
										],
										[
											0,
											3.333
										],
										[
											1.833,
											2.367
										],
										[
											3.233,
											1.267
										],
										[
											4.267,
											0
										]
									],
									o: [
										[
											-4.133,
											0
										],
										[
											-3.267,
											1.267
										],
										[
											-1.833,
											2.367
										],
										[
											0,
											3.333
										],
										[
											1.833,
											2.367
										],
										[
											3.267,
											1.267
										],
										[
											4.267,
											0
										],
										[
											3.233,
											-1.267
										],
										[
											1.833,
											-2.367
										],
										[
											0,
											-3.333
										],
										[
											-1.833,
											-2.367
										],
										[
											-3.233,
											-1.267
										],
										[
											0,
											0
										]
									],
									v: [
										[
											45.9,
											-68.3
										],
										[
											34.8,
											-66.4
										],
										[
											27.15,
											-60.95
										],
										[
											24.4,
											-52.4
										],
										[
											27.15,
											-43.85
										],
										[
											34.8,
											-38.4
										],
										[
											45.9,
											-36.5
										],
										[
											57.15,
											-38.4
										],
										[
											64.75,
											-43.85
										],
										[
											67.5,
											-52.4
										],
										[
											64.75,
											-60.95
										],
										[
											57.15,
											-66.4
										],
										[
											45.9,
											-68.3
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											4.1,
											-2.3
										],
										[
											4.1,
											-13.2
										],
										[
											88,
											-13.2
										],
										[
											88,
											-2.3
										]
									]
								}
							}
						}
					]
				}
			]
		}
	},
	{
		ch: "기",
		fFamily: "Noto Sans KR",
		size: 10,
		style: "Bold",
		w: 92,
		data: {
			shapes: [
				{
					ty: "gr",
					nm: "",
					it: [
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											67.9,
											8.8
										],
										[
											67.9,
											-83.8
										],
										[
											81.2,
											-83.8
										],
										[
											81.2,
											8.8
										],
										[
											67.9,
											8.8
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											1.367,
											-6.433
										],
										[
											3.167,
											-5.667
										],
										[
											5.5,
											-4.833
										],
										[
											8.2,
											-4
										],
										[
											0,
											0
										],
										[
											-5.3,
											5.233
										],
										[
											-2.333,
											6.633
										],
										[
											0,
											8.267
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											7.067
										],
										[
											-1.367,
											6.433
										],
										[
											-3.167,
											5.667
										],
										[
											-5.5,
											4.833
										],
										[
											0,
											0
										],
										[
											8.933,
											-4.333
										],
										[
											5.3,
											-5.233
										],
										[
											2.333,
											-6.633
										],
										[
											0,
											0
										]
									],
									v: [
										[
											40.6,
											-71.8
										],
										[
											40.6,
											-74.2
										],
										[
											53.7,
											-74.2
										],
										[
											51.65,
											-53.95
										],
										[
											44.85,
											-35.8
										],
										[
											31.85,
											-20.05
										],
										[
											11.3,
											-6.8
										],
										[
											4.3,
											-17.3
										],
										[
											25.65,
											-31.65
										],
										[
											37.1,
											-49.45
										],
										[
											40.6,
											-71.8
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											9.3,
											-63.6
										],
										[
											9.3,
											-74.2
										],
										[
											46.8,
											-74.2
										],
										[
											46.8,
											-63.6
										]
									]
								}
							}
						}
					]
				}
			]
		}
	},
	{
		ch: " ",
		fFamily: "Noto Sans KR",
		size: 10,
		style: "Bold",
		w: 22.7,
		data: {
			shapes: [
				{
					ty: "gr",
					nm: "",
					it: [
					]
				}
			]
		}
	},
	{
		ch: "완",
		fFamily: "Noto Sans KR",
		size: 10,
		style: "Bold",
		w: 92,
		data: {
			shapes: [
				{
					ty: "gr",
					nm: "",
					it: [
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											25.1,
											-32.2
										],
										[
											25.1,
											-46.3
										],
										[
											38.4,
											-46.3
										],
										[
											38.4,
											-32.2
										],
										[
											25.1,
											-32.2
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											-3.467,
											-1.567
										],
										[
											-2,
											-2.833
										],
										[
											0,
											-3.733
										],
										[
											2,
											-2.833
										],
										[
											3.467,
											-1.6
										],
										[
											4.467,
											0
										],
										[
											3.5,
											1.6
										],
										[
											2,
											2.833
										],
										[
											0,
											3.667
										],
										[
											-2,
											2.833
										],
										[
											-3.5,
											1.567
										],
										[
											-4.467,
											0
										]
									],
									o: [
										[
											4.467,
											0
										],
										[
											3.467,
											1.567
										],
										[
											2,
											2.833
										],
										[
											0,
											3.667
										],
										[
											-2,
											2.833
										],
										[
											-3.467,
											1.6
										],
										[
											-4.467,
											0
										],
										[
											-3.5,
											-1.6
										],
										[
											-2,
											-2.833
										],
										[
											0,
											-3.733
										],
										[
											2,
											-2.833
										],
										[
											3.5,
											-1.567
										],
										[
											0,
											0
										]
									],
									v: [
										[
											31.7,
											-80
										],
										[
											43.6,
											-77.65
										],
										[
											51.8,
											-71.05
										],
										[
											54.8,
											-61.2
										],
										[
											51.8,
											-51.45
										],
										[
											43.6,
											-44.8
										],
										[
											31.7,
											-42.4
										],
										[
											19.75,
											-44.8
										],
										[
											11.5,
											-51.45
										],
										[
											8.5,
											-61.2
										],
										[
											11.5,
											-71.05
										],
										[
											19.75,
											-77.65
										],
										[
											31.7,
											-80
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											1.633,
											-0.7
										],
										[
											0.933,
											-1.333
										],
										[
											0,
											-1.867
										],
										[
											-0.933,
											-1.3
										],
										[
											-1.633,
											-0.7
										],
										[
											-2.067,
											0
										],
										[
											-1.6,
											0.7
										],
										[
											-0.9,
											1.3
										],
										[
											0,
											1.867
										],
										[
											0.9,
											1.333
										],
										[
											1.6,
											0.7
										],
										[
											2.133,
											0
										]
									],
									o: [
										[
											-2.067,
											0
										],
										[
											-1.633,
											0.7
										],
										[
											-0.933,
											1.333
										],
										[
											0,
											1.867
										],
										[
											0.933,
											1.3
										],
										[
											1.633,
											0.7
										],
										[
											2.133,
											0
										],
										[
											1.6,
											-0.7
										],
										[
											0.9,
											-1.3
										],
										[
											0,
											-1.867
										],
										[
											-0.9,
											-1.333
										],
										[
											-1.6,
											-0.7
										],
										[
											0,
											0
										]
									],
									v: [
										[
											31.7,
											-70.1
										],
										[
											26.15,
											-69.05
										],
										[
											22.3,
											-66
										],
										[
											20.9,
											-61.2
										],
										[
											22.3,
											-56.45
										],
										[
											26.15,
											-53.45
										],
										[
											31.7,
											-52.4
										],
										[
											37.3,
											-53.45
										],
										[
											41.05,
											-56.45
										],
										[
											42.4,
											-61.2
										],
										[
											41.05,
											-66
										],
										[
											37.3,
											-69.05
										],
										[
											31.7,
											-70.1
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											64.2,
											-13.1
										],
										[
											64.2,
											-83.7
										],
										[
											77.5,
											-83.7
										],
										[
											77.5,
											-13.1
										],
										[
											64.2,
											-13.1
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											72.9,
											-43.8
										],
										[
											72.9,
											-54.6
										],
										[
											89.2,
											-54.6
										],
										[
											89.2,
											-43.8
										],
										[
											72.9,
											-43.8
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											15.8,
											7.2
										],
										[
											15.8,
											-3.4
										],
										[
											80.7,
											-3.4
										],
										[
											80.7,
											7.2
										],
										[
											15.8,
											7.2
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											15.8,
											1.2
										],
										[
											15.8,
											-19.1
										],
										[
											29.1,
											-19.1
										],
										[
											29.1,
											1.2
										],
										[
											15.8,
											1.2
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-6.3,
											0.1
										],
										[
											-6.567,
											0.4
										],
										[
											-6.067,
											0.867
										],
										[
											0,
											0
										],
										[
											6.533,
											-0.567
										],
										[
											6.133,
											-0.133
										],
										[
											5.067,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											5.267,
											0
										],
										[
											6.3,
											-0.1
										],
										[
											6.567,
											-0.4
										],
										[
											0,
											0
										],
										[
											-6.2,
											1.133
										],
										[
											-6.533,
											0.567
										],
										[
											-6.133,
											0.133
										],
										[
											0,
											0
										]
									],
									v: [
										[
											5.3,
											-25.1
										],
										[
											3.7,
											-35.6
										],
										[
											21.05,
											-35.75
										],
										[
											40.35,
											-36.5
										],
										[
											59.3,
											-38.4
										],
										[
											60.2,
											-28.9
										],
										[
											41.1,
											-26.35
										],
										[
											22.1,
											-25.3
										],
										[
											5.3,
											-25.1
										]
									]
								}
							}
						}
					]
				}
			]
		}
	},
	{
		ch: "료",
		fFamily: "Noto Sans KR",
		size: 10,
		style: "Bold",
		w: 92,
		data: {
			shapes: [
				{
					ty: "gr",
					nm: "",
					it: [
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											25.3,
											-7.9
										],
										[
											25.3,
											-29.8
										],
										[
											38.4,
											-29.8
										],
										[
											38.4,
											-7.9
										],
										[
											25.3,
											-7.9
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											54.6,
											-8
										],
										[
											54.6,
											-29.8
										],
										[
											67.6,
											-29.8
										],
										[
											67.6,
											-8
										],
										[
											54.6,
											-8
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											4.1,
											-1.3
										],
										[
											4.1,
											-12.1
										],
										[
											88,
											-12.1
										],
										[
											88,
											-1.3
										],
										[
											4.1,
											-1.3
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											13.6,
											-67.2
										],
										[
											13.6,
											-77.8
										],
										[
											78.5,
											-77.8
										],
										[
											78.5,
											-47.1
										],
										[
											26.9,
											-47.1
										],
										[
											26.9,
											-31.4
										],
										[
											13.7,
											-31.4
										],
										[
											13.7,
											-57.5
										],
										[
											65.3,
											-57.5
										],
										[
											65.3,
											-67.2
										],
										[
											13.6,
											-67.2
										]
									]
								}
							}
						},
						{
							ty: "sh",
							nm: "",
							d: 1,
							ks: {
								a: 0,
								k: {
									c: false,
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											13.7,
											-26.3
										],
										[
											13.7,
											-36.9
										],
										[
											80.6,
											-36.9
										],
										[
											80.6,
											-26.3
										]
									]
								}
							}
						}
					]
				}
			]
		}
	}
];
const assets = [
	{
		nm: "잔액모으기",
		id: "1",
		fr: 29.97,
		layers: [
			{
				ty: 0,
				nm: "Untitled file",
				sr: 1,
				st: 111,
				op: 260.85,
				ip: 111,
				ln: "6964",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							256,
							256
						]
					},
					s: {
						a: 1,
						k: [
							{
								s: [
									0,
									0,
									0
								],
								i: {
									x: [
										0.667,
										0.667,
										0.667
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.333,
										0.333,
										0.333
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 114
							},
							{
								s: [
									54,
									54,
									98.182
								],
								i: {
									x: [
										0.667,
										0.667,
										0.667
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.333,
										0.333,
										0.333
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 130
							}
						]
					},
					p: {
						a: 0,
						k: [
							187.425,
							160.751
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 0,
						k: 100
					}
				},
				w: 512,
				h: 512,
				refId: "2",
				ind: 1
			},
			{
				ty: 0,
				nm: "마지막페이지",
				sr: 1,
				st: 104,
				op: 284,
				ip: 104,
				ln: "3826",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							76,
							124.5
						]
					},
					s: {
						a: 0,
						k: [
							100,
							100
						]
					},
					p: {
						a: 0,
						k: [
							181,
							176.295
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 0,
						k: 100
					}
				},
				w: 152,
				h: 249,
				refId: "4",
				ind: 2
			},
			{
				ty: 4,
				nm: "Body Text 윤곽선",
				sr: 1,
				st: 0,
				op: 210,
				ip: 0,
				ln: "3860",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							36.5,
							12
						]
					},
					s: {
						a: 0,
						k: [
							75,
							75
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									181,
									84.07
								],
								t: 0
							},
							{
								s: [
									181,
									71.07
								],
								t: 10
							}
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									0
								],
								t: 0
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									100
								],
								t: 10
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									100
								],
								t: 99.999
							},
							{
								s: [
									0
								],
								t: 103.999
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "그룹 1",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												23.613,
												-5.88
											],
											[
												29.613,
												-5.88
											],
											[
												29.613,
												-4.184
											],
											[
												23.613,
												-4.184
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 2",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.223,
												-1.035
											],
											[
												0.512,
												-0.907
											],
											[
												0.884,
												-0.779
											],
											[
												1.311,
												-0.64
											],
											[
												0,
												0
											],
											[
												-0.843,
												0.832
											],
											[
												-0.374,
												1.056
											],
											[
												0,
												1.323
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												1.131
											],
											[
												-0.213,
												1.024
											],
											[
												-0.501,
												0.907
											],
											[
												-0.875,
												0.768
											],
											[
												0,
												0
											],
											[
												1.43,
												-0.693
											],
											[
												0.853,
												-0.843
											],
											[
												0.373,
												-1.067
											],
											[
												0,
												0
											]
										],
										v: [
											[
												28.621,
												-5.88
											],
											[
												30.717,
												-5.88
											],
											[
												30.382,
												-2.632
											],
											[
												29.294,
												0.264
											],
											[
												27.214,
												2.792
											],
											[
												23.934,
												4.904
											],
											[
												22.813,
												3.224
											],
											[
												26.222,
												0.936
											],
											[
												28.062,
												-1.912
											],
											[
												28.621,
												-5.496
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 3",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												32.99,
												-7.416
											],
											[
												35.118,
												-7.416
											],
											[
												35.118,
												7.4
											],
											[
												32.99,
												7.4
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 4",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												8.362,
												3.88
											],
											[
												21.786,
												3.88
											],
											[
												21.786,
												5.624
											],
											[
												8.362,
												5.624
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 5",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0.684,
												0
											],
											[
												0.523,
												-0.203
											],
											[
												0.299,
												-0.384
											],
											[
												0,
												-0.533
											],
											[
												-0.287,
												-0.384
											],
											[
												-0.523,
												-0.203
											],
											[
												-0.661,
												0
											],
											[
												-0.511,
												0.203
											],
											[
												-0.288,
												0.373
											],
											[
												0,
												0.533
											],
											[
												0.299,
												0.373
											],
											[
												0.524,
												0.203
											]
										],
										o: [
											[
												-0.661,
												0
											],
											[
												-0.523,
												0.203
											],
											[
												-0.287,
												0.373
											],
											[
												0,
												0.533
											],
											[
												0.299,
												0.373
											],
											[
												0.523,
												0.203
											],
											[
												0.684,
												0
											],
											[
												0.524,
												-0.203
											],
											[
												0.299,
												-0.384
											],
											[
												0,
												-0.533
											],
											[
												-0.288,
												-0.384
											],
											[
												-0.511,
												-0.203
											]
										],
										v: [
											[
												15.05,
												-4.936
											],
											[
												13.275,
												-4.632
											],
											[
												12.042,
												-3.752
											],
											[
												11.611,
												-2.392
											],
											[
												12.042,
												-1.016
											],
											[
												13.275,
												-0.152
											],
											[
												15.05,
												0.152
											],
											[
												16.842,
												-0.152
											],
											[
												18.059,
												-1.016
											],
											[
												18.507,
												-2.392
											],
											[
												18.059,
												-3.752
											],
											[
												16.842,
												-4.632
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 6",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.033,
												0
											],
											[
												-0.832,
												-0.352
											],
											[
												-0.481,
												-0.64
											],
											[
												0,
												-0.864
											],
											[
												0.49,
												-0.651
											],
											[
												0.842,
												-0.352
											],
											[
												1.047,
												0
											],
											[
												0.842,
												0.352
											],
											[
												0.492,
												0.64
											],
											[
												0,
												0.864
											],
											[
												-0.489,
												0.64
											],
											[
												-0.832,
												0.352
											]
										],
										o: [
											[
												1.047,
												0
											],
											[
												0.842,
												0.352
											],
											[
												0.49,
												0.64
											],
											[
												0,
												0.864
											],
											[
												-0.481,
												0.64
											],
											[
												-0.832,
												0.352
											],
											[
												-1.033,
												0
											],
											[
												-0.832,
												-0.352
											],
											[
												-0.489,
												-0.651
											],
											[
												0,
												-0.864
											],
											[
												0.492,
												-0.64
											],
											[
												0.842,
												-0.352
											]
										],
										v: [
											[
												15.05,
												-6.664
											],
											[
												17.867,
												-6.136
											],
											[
												19.851,
												-4.648
											],
											[
												20.587,
												-2.392
											],
											[
												19.851,
												-0.12
											],
											[
												17.867,
												1.368
											],
											[
												15.05,
												1.896
											],
											[
												12.235,
												1.368
											],
											[
												10.25,
												-0.12
											],
											[
												9.514,
												-2.392
											],
											[
												10.25,
												-4.648
											],
											[
												12.235,
												-6.136
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 7",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												3.8,
												-4.632
											],
											[
												-2.552,
												-4.632
											],
											[
												-2.552,
												-0.728
											],
											[
												3.8,
												-0.728
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 8",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-4.647,
												-6.312
											],
											[
												5.896,
												-6.312
											],
											[
												5.896,
												0.968
											],
											[
												-4.647,
												0.968
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 9",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-0.424,
												0.696
											],
											[
												1.688,
												0.696
											],
											[
												1.688,
												4.376
											],
											[
												-0.424,
												4.376
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 10",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-6.056,
												3.96
											],
											[
												7.368,
												3.96
											],
											[
												7.368,
												5.688
											],
											[
												-6.056,
												5.688
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 11",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-18.042,
												2.104
											],
											[
												-7.851,
												2.104
											],
											[
												-7.851,
												7.416
											],
											[
												-9.979,
												7.416
											],
											[
												-9.979,
												3.8
											],
											[
												-18.042,
												3.8
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 12",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-12.986,
												-7.144
											],
											[
												-11.003,
												-7.144
											],
											[
												-11.003,
												1.384
											],
											[
												-12.986,
												1.384
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 13",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-11.642,
												-3.816
											],
											[
												-9.291,
												-3.816
											],
											[
												-9.291,
												-2.104
											],
											[
												-11.642,
												-2.104
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 14",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-9.882,
												-7.4
											],
											[
												-7.851,
												-7.4
											],
											[
												-7.851,
												1.432
											],
											[
												-9.882,
												1.432
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 15",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0.288,
												0
											],
											[
												0.224,
												-0.149
											],
											[
												0.117,
												-0.267
											],
											[
												0,
												-0.395
											],
											[
												-0.118,
												-0.277
											],
											[
												-0.224,
												-0.149
											],
											[
												-0.288,
												0
											],
											[
												-0.225,
												0.139
											],
											[
												-0.118,
												0.277
											],
											[
												0,
												0.384
											],
											[
												0.129,
												0.267
											],
											[
												0.223,
												0.149
											]
										],
										o: [
											[
												-0.288,
												0
											],
											[
												-0.224,
												0.149
											],
											[
												-0.118,
												0.267
											],
											[
												0,
												0.384
											],
											[
												0.117,
												0.277
											],
											[
												0.224,
												0.139
											],
											[
												0.288,
												0
											],
											[
												0.223,
												-0.149
											],
											[
												0.129,
												-0.277
											],
											[
												0,
												-0.395
											],
											[
												-0.118,
												-0.267
											],
											[
												-0.225,
												-0.149
											]
										],
										v: [
											[
												-17.05,
												-4.728
											],
											[
												-17.818,
												-4.504
											],
											[
												-18.33,
												-3.88
											],
											[
												-18.507,
												-2.888
											],
											[
												-18.33,
												-1.896
											],
											[
												-17.818,
												-1.256
											],
											[
												-17.05,
												-1.048
											],
											[
												-16.282,
												-1.256
											],
											[
												-15.771,
												-1.896
											],
											[
												-15.578,
												-2.888
											],
											[
												-15.771,
												-3.88
											],
											[
												-16.282,
												-4.504
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 16",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-0.651,
												0
											],
											[
												-0.503,
												-0.309
											],
											[
												-0.288,
												-0.544
											],
											[
												0,
												-0.715
											],
											[
												0.297,
												-0.555
											],
											[
												0.511,
												-0.309
											],
											[
												0.661,
												0
											],
											[
												0.513,
												0.299
											],
											[
												0.288,
												0.544
											],
											[
												0,
												0.704
											],
											[
												-0.288,
												0.544
											],
											[
												-0.511,
												0.299
											]
										],
										o: [
											[
												0.661,
												0
											],
											[
												0.511,
												0.299
											],
											[
												0.297,
												0.544
											],
											[
												0,
												0.704
											],
											[
												-0.288,
												0.544
											],
											[
												-0.503,
												0.299
											],
											[
												-0.651,
												0
											],
											[
												-0.511,
												-0.309
											],
											[
												-0.288,
												-0.555
											],
											[
												0,
												-0.715
											],
											[
												0.288,
												-0.544
											],
											[
												0.513,
												-0.309
											]
										],
										v: [
											[
												-17.05,
												-6.504
											],
											[
												-15.306,
												-6.04
											],
											[
												-14.106,
												-4.776
											],
											[
												-13.658,
												-2.888
											],
											[
												-14.106,
												-1
											],
											[
												-15.306,
												0.28
											],
											[
												-17.05,
												0.728
											],
											[
												-18.795,
												0.28
											],
											[
												-19.994,
												-1
											],
											[
												-20.426,
												-2.888
											],
											[
												-19.994,
												-4.776
											],
											[
												-18.795,
												-6.04
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 17",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-32.798,
												2.392
											],
											[
												-30.653,
												2.392
											],
											[
												-30.653,
												6.36
											],
											[
												-32.798,
												6.36
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 18",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-32.798,
												5.448
											],
											[
												-22.717,
												5.448
											],
											[
												-22.717,
												7.16
											],
											[
												-32.798,
												7.16
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 19",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-23.837,
												-3.112
											],
											[
												-21.278,
												-3.112
											],
											[
												-21.278,
												-1.352
											],
											[
												-23.837,
												-1.352
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 20",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-25.374,
												-7.4
											],
											[
												-23.245,
												-7.4
											],
											[
												-23.245,
												3.448
											],
											[
												-25.374,
												3.448
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 21",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-34.509,
												-6.328
											],
											[
												-26.542,
												-6.328
											],
											[
												-26.542,
												-4.632
											],
											[
												-34.509,
												-4.632
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 22",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.236,
												-0.576
											],
											[
												-0.501,
												-0.459
											],
											[
												-0.789,
												-0.267
											],
											[
												0,
												0
											],
											[
												0.597,
												0.597
											],
											[
												0.299,
												0.789
											],
											[
												0,
												0.885
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.576
											],
											[
												0.235,
												0.565
											],
											[
												0.511,
												0.448
											],
											[
												0,
												0
											],
											[
												-0.885,
												-0.299
											],
											[
												-0.597,
												-0.597
											],
											[
												-0.287,
												-0.789
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-31.181,
												-5.544
											],
											[
												-29.453,
												-5.544
											],
											[
												-29.453,
												-4.616
											],
											[
												-29.101,
												-2.888
											],
											[
												-27.997,
												-1.352
											],
											[
												-26.045,
												-0.28
											],
											[
												-27.181,
												1.32
											],
											[
												-29.405,
												-0.024
											],
											[
												-30.75,
												-2.104
											],
											[
												-31.181,
												-4.616
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 23",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.309,
												-0.843
											],
											[
												0.62,
												-0.629
											],
											[
												0.949,
												-0.32
											],
											[
												0,
												0
											],
											[
												-0.437,
												0.32
											],
											[
												-0.287,
												0.416
											],
											[
												-0.129,
												0.459
											],
											[
												0,
												0.469
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.939
											],
											[
												-0.299,
												0.843
											],
											[
												-0.607,
												0.629
											],
											[
												0,
												0
											],
											[
												0.619,
												-0.203
											],
											[
												0.449,
												-0.331
											],
											[
												0.289,
												-0.416
											],
											[
												0.138,
												-0.469
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-31.597,
												-5.544
											],
											[
												-29.854,
												-5.544
											],
											[
												-29.854,
												-4.616
											],
											[
												-30.317,
												-1.944
											],
											[
												-31.694,
												0.264
											],
											[
												-34.029,
												1.688
											],
											[
												-35.118,
												0.008
											],
											[
												-33.534,
												-0.776
											],
											[
												-32.43,
												-1.896
											],
											[
												-31.805,
												-3.208
											],
											[
												-31.597,
												-4.616
											]
										]
									}
								}
							},
							{
								ty: "mm",
								nm: "패스 병합 1",
								mm: 1
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.047,
										0.228,
										0.4
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										35.549,
										13.008
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 3
			},
			{
				ty: 2,
				nm: "자산 4@3x.png",
				sr: 1,
				st: 7,
				op: 217,
				ip: 67,
				ln: "9777",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							222.5,
							64.5
						]
					},
					s: {
						a: 1,
						k: [
							{
								s: [
									42,
									42,
									102.439
								],
								i: {
									x: [
										0.667,
										0.667,
										0.667
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.333,
										0.333,
										0.333
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 66.999
							},
							{
								s: [
									33,
									33,
									91.667
								],
								i: {
									x: [
										0.833,
										0.833,
										0.833
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.167,
										0.167,
										0.167
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 84.999
							}
						]
					},
					p: {
						a: 0,
						k: [
							181.499,
							258.531
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									100
								],
								t: 99.999
							},
							{
								s: [
									0
								],
								t: 103.999
							}
						]
					}
				},
				ef: [
					{
						ty: 25,
						nm: "그림자 효과",
						en: 1,
						ef: [
							{
								ty: 2,
								nm: "그림자 색상",
								v: {
									a: 0,
									k: [
										0,
										0,
										0
									]
								}
							},
							{
								ty: 0,
								nm: "불투명도",
								v: {
									a: 1,
									k: [
										{
											o: {
												x: 0.167,
												y: 0.167
											},
											i: {
												x: 0.833,
												y: 0.833
											},
											s: [
												35
											],
											t: 66.999
										},
										{
											s: [
												0
											],
											t: 75.999
										}
									]
								}
							},
							{
								ty: 1,
								nm: "방향",
								v: {
									a: 0,
									k: 135
								}
							},
							{
								ty: 0,
								nm: "거리",
								v: {
									a: 0,
									k: 5
								}
							},
							{
								ty: 0,
								nm: "부드러움",
								v: {
									a: 0,
									k: 0
								}
							},
							{
								ty: 7,
								nm: "그림자만",
								v: {
									a: 0,
									k: 0
								}
							}
						]
					}
				],
				refId: "13",
				ind: 4
			},
			{
				ty: 4,
				nm: "카카오 윤곽선 2",
				sr: 1,
				st: 48,
				op: 172,
				ip: 48,
				ln: "9772",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							74.4,
							21.4
						]
					},
					s: {
						a: 1,
						k: [
							{
								s: [
									130,
									130,
									100
								],
								i: {
									x: [
										0.747,
										0.747,
										0.667
									],
									y: [
										0.995,
										0.995,
										1
									]
								},
								o: {
									x: [
										0.333,
										0.333,
										0.333
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 48
							},
							{
								s: [
									100,
									100,
									100
								],
								i: {
									x: [
										0.833,
										0.833,
										0.833
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.167,
										0.167,
										0.167
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 58
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									181.499,
									236.5
								],
								t: 48
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									181.499,
									236.5
								],
								t: 58
							},
							{
								s: [
									181.499,
									210.531
								],
								t: 67
							}
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									100
								],
								t: 99.999
							},
							{
								s: [
									0
								],
								t: 103.999
							}
						]
					}
				},
				ef: [
					{
						ty: 25,
						nm: "그림자 효과",
						en: 1,
						ef: [
							{
								ty: 2,
								nm: "그림자 색상",
								v: {
									a: 0,
									k: [
										0,
										0,
										0
									]
								}
							},
							{
								ty: 0,
								nm: "불투명도",
								v: {
									a: 1,
									k: [
										{
											o: {
												x: 0.167,
												y: 0.167
											},
											i: {
												x: 0.833,
												y: 0.833
											},
											s: [
												35
											],
											t: 48
										},
										{
											s: [
												0
											],
											t: 58
										}
									]
								}
							},
							{
								ty: 1,
								nm: "방향",
								v: {
									a: 0,
									k: 135
								}
							},
							{
								ty: 0,
								nm: "거리",
								v: {
									a: 0,
									k: 5
								}
							},
							{
								ty: 0,
								nm: "부드러움",
								v: {
									a: 0,
									k: 0
								}
							},
							{
								ty: 7,
								nm: "그림자만",
								v: {
									a: 0,
									k: 0
								}
							}
						]
					}
				],
				shapes: [
					{
						ty: "gr",
						nm: "그룹 1",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0.213,
												0
											],
											[
												0.2,
												-0.114
											],
											[
												0,
												-0.234
											],
											[
												-0.194,
												-0.12
											],
											[
												-0.307,
												0
											],
											[
												-0.186,
												0.113
											],
											[
												0,
												0.22
											],
											[
												0.086,
												0.1
											],
											[
												0.153,
												0.053
											]
										],
										o: [
											[
												-0.307,
												0
											],
											[
												-0.194,
												0.113
											],
											[
												0,
												0.22
											],
											[
												0.2,
												0.113
											],
											[
												0.314,
												0
											],
											[
												0.193,
												-0.12
											],
											[
												0,
												-0.154
											],
											[
												-0.088,
												-0.1
											],
											[
												-0.153,
												-0.054
											]
										],
										v: [
											[
												12.718,
												-3.71
											],
											[
												11.959,
												-3.54
											],
											[
												11.668,
												-3.02
											],
											[
												11.959,
												-2.51
											],
											[
												12.718,
												-2.34
											],
											[
												13.468,
												-2.51
											],
											[
												13.758,
												-3.02
											],
											[
												13.629,
												-3.4
											],
											[
												13.269,
												-3.63
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 2",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-0.453,
												0
											],
											[
												-0.347,
												-0.14
											],
											[
												-0.193,
												-0.247
											],
											[
												0,
												-0.334
											],
											[
												0.201,
												-0.254
											],
											[
												0.347,
												-0.134
											],
											[
												0.454,
												0
											],
											[
												0.354,
												0.133
											],
											[
												0.194,
												0.246
											],
											[
												0,
												0.326
											],
											[
												-0.192,
												0.246
											],
											[
												-0.347,
												0.14
											]
										],
										o: [
											[
												0.454,
												0
											],
											[
												0.347,
												0.14
											],
											[
												0.201,
												0.246
											],
											[
												0,
												0.326
											],
											[
												-0.193,
												0.246
											],
											[
												-0.347,
												0.133
											],
											[
												-0.453,
												0
											],
											[
												-0.347,
												-0.134
											],
											[
												-0.192,
												-0.254
											],
											[
												0,
												-0.334
											],
											[
												0.194,
												-0.247
											],
											[
												0.354,
												-0.14
											]
										],
										v: [
											[
												12.718,
												-4.68
											],
											[
												13.918,
												-4.47
											],
											[
												14.728,
												-3.89
											],
											[
												15.028,
												-3.02
											],
											[
												14.728,
												-2.15
											],
											[
												13.918,
												-1.58
											],
											[
												12.718,
												-1.38
											],
											[
												11.508,
												-1.58
											],
											[
												10.698,
												-2.15
											],
											[
												10.409,
												-3.02
											],
											[
												10.698,
												-3.89
											],
											[
												11.508,
												-4.47
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 3",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												14.498,
												0.38
											],
											[
												16.539,
												0.38
											],
											[
												16.539,
												1.29
											],
											[
												14.498,
												1.29
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 4",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0.552,
												-7e-3
											],
											[
												0,
												0
											],
											[
												-0.666,
												0.006
											],
											[
												-0.694,
												0.04
											],
											[
												-0.64,
												0.08
											],
											[
												0,
												0
											],
											[
												0.688,
												-0.06
											],
											[
												0.646,
												-0.014
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0.567,
												-7e-3
											],
											[
												0.668,
												-0.014
											],
											[
												0.692,
												-0.04
											],
											[
												0,
												0
											],
											[
												-0.66,
												0.113
											],
											[
												-0.679,
												0.053
											],
											[
												-0.647,
												0.013
											]
										],
										v: [
											[
												9.909,
												0.16
											],
											[
												9.739,
												-0.9
											],
											[
												11.588,
												-0.92
											],
											[
												13.629,
												-1
											],
											[
												15.629,
												-1.18
											],
											[
												15.718,
												-0.23
											],
											[
												13.698,
												0.03
											],
											[
												11.709,
												0.13
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 5",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.898,
												1.35
											],
											[
												12.228,
												1.35
											],
											[
												12.228,
												3.33
											],
											[
												10.898,
												3.33
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 6",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.898,
												3.04
											],
											[
												17.778,
												3.04
											],
											[
												17.778,
												4.11
											],
											[
												10.898,
												4.11
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 7",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												16.239,
												-5
											],
											[
												17.569,
												-5
											],
											[
												17.569,
												2.02
											],
											[
												16.239,
												2.02
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 8",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												12.188,
												-0.24
											],
											[
												13.519,
												-0.24
											],
											[
												13.519,
												1.78
											],
											[
												12.188,
												1.78
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 9",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.06,
												0
											],
											[
												0,
												1.41
											],
											[
												1.041,
												0
											],
											[
												0,
												-1.39
											]
										],
										o: [
											[
												1.05,
												0
											],
											[
												0,
												-1.39
											],
											[
												-1.05,
												0
											],
											[
												0,
												1.41
											]
										],
										v: [
											[
												6.028,
												2.14
											],
											[
												7.468,
												-0.39
											],
											[
												6.028,
												-2.88
											],
											[
												4.588,
												-0.39
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 10",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												-2.08
											],
											[
												1.95,
												0
											],
											[
												0,
												2.09
											],
											[
												-1.94,
												0
											]
										],
										o: [
											[
												0,
												2.09
											],
											[
												-1.95,
												0
											],
											[
												0,
												-2.08
											],
											[
												1.94,
												0
											]
										],
										v: [
											[
												8.998,
												-0.39
											],
											[
												6.028,
												3.48
											],
											[
												3.069,
												-0.39
											],
											[
												6.028,
												-4.22
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 11",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.06,
												0
											],
											[
												0,
												1.41
											],
											[
												1.041,
												0
											],
											[
												0,
												-1.39
											]
										],
										o: [
											[
												1.05,
												0
											],
											[
												0,
												-1.39
											],
											[
												-1.05,
												0
											],
											[
												0,
												1.41
											]
										],
										v: [
											[
												-0.651,
												2.14
											],
											[
												0.789,
												-0.39
											],
											[
												-0.651,
												-2.88
											],
											[
												-2.091,
												-0.39
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 12",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												-2.08
											],
											[
												1.95,
												0
											],
											[
												0,
												2.09
											],
											[
												-1.94,
												0
											]
										],
										o: [
											[
												0,
												2.09
											],
											[
												-1.95,
												0
											],
											[
												0,
												-2.08
											],
											[
												1.94,
												0
											]
										],
										v: [
											[
												2.319,
												-0.39
											],
											[
												-0.651,
												3.48
											],
											[
												-3.61,
												-0.39
											],
											[
												-0.651,
												-4.22
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 13",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												-0.79
											],
											[
												1.52,
												0
											],
											[
												0.639,
												0.36
											],
											[
												0,
												0
											],
											[
												-0.759,
												0
											],
											[
												0,
												0.7
											],
											[
												0.7,
												0
											],
											[
												0.311,
												-0.05
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.58
											],
											[
												0.54,
												0
											],
											[
												0.53,
												-0.48
											],
											[
												0,
												0
											],
											[
												-0.78,
												0
											],
											[
												0,
												-1.26
											],
											[
												0.61,
												-0.4
											]
										],
										o: [
											[
												0,
												1.53
											],
											[
												-0.739,
												0
											],
											[
												0,
												0
											],
											[
												0.609,
												0.44
											],
											[
												0.72,
												0
											],
											[
												0,
												-0.73
											],
											[
												-0.31,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.599,
												-0.11
											],
											[
												0,
												-0.54
											],
											[
												-0.73,
												0
											],
											[
												0,
												0
											],
											[
												0.619,
												-0.48
											],
											[
												1.25,
												0
											],
											[
												0,
												0.63
											],
											[
												0.811,
												0.39
											]
										],
										v: [
											[
												-4.298,
												1.18
											],
											[
												-7.188,
												3.48
											],
											[
												-9.267,
												2.91
											],
											[
												-9.267,
												1.49
											],
											[
												-7.168,
												2.21
											],
											[
												-5.838,
												1.16
											],
											[
												-7.168,
												0.12
											],
											[
												-8.078,
												0.2
											],
											[
												-8.078,
												-0.95
											],
											[
												-7.177,
												-1.1
											],
											[
												-6.138,
												-2.09
											],
											[
												-7.128,
												-2.93
											],
											[
												-9.037,
												-2.15
											],
											[
												-9.037,
												-3.51
											],
											[
												-6.897,
												-4.22
											],
											[
												-4.638,
												-2.2
											],
											[
												-5.548,
												-0.64
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 14",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.37
											],
											[
												-0.51,
												0
											],
											[
												0,
												-0.51
											],
											[
												0.151,
												-0.25
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.399,
												-0.16
											],
											[
												0,
												-0.53
											],
											[
												0.561,
												0
											],
											[
												0,
												0.27
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-11.063,
												5
											],
											[
												-11.983,
												5
											],
											[
												-11.174,
												3.47
											],
											[
												-11.754,
												2.64
											],
											[
												-10.854,
												1.78
											],
											[
												-9.944,
												2.67
											],
											[
												-10.194,
												3.48
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 15",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.62
											],
											[
												0.67,
												0
											],
											[
												0.53,
												-0.5
											],
											[
												0,
												0
											],
											[
												-0.78,
												0
											],
											[
												0,
												-1.35
											],
											[
												0.7,
												-0.93
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.48,
												-0.64
											],
											[
												0,
												-0.68
											],
											[
												-0.67,
												0
											],
											[
												0,
												0
											],
											[
												0.621,
												-0.44
											],
											[
												1.39,
												0
											],
											[
												0,
												0.91
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-12.418,
												2.1
											],
											[
												-12.418,
												3.38
											],
											[
												-17.778,
												3.38
											],
											[
												-15.168,
												-0.06
											],
											[
												-14.299,
												-1.78
											],
											[
												-15.509,
												-2.89
											],
											[
												-17.319,
												-2.02
											],
											[
												-17.319,
												-3.53
											],
											[
												-15.209,
												-4.22
											],
											[
												-12.759,
												-1.98
											],
											[
												-13.929,
												0.62
											],
											[
												-15.108,
												2.1
											]
										]
									}
								}
							},
							{
								ty: "mm",
								nm: "패스 병합 1",
								mm: 1
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.4,
										0.4,
										0.4
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										117.239,
										21.02
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 2",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-3e-3,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0.179,
												1.652
											],
											[
												-0.488,
												1.652
											],
											[
												-0.488,
												-1.644
											],
											[
												0.173,
												-1.644
											],
											[
												0.173,
												-1.647
											],
											[
												0.173,
												-1.644
											],
											[
												0.179,
												-1.644
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 2",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0.05,
												0.327
											],
											[
												0.431,
												0.333
											],
											[
												0.074,
												0.055
											],
											[
												-0.047,
												0.036
											],
											[
												-0.147,
												0.335
											],
											[
												0.05,
												0.329
											],
											[
												0.315,
												0.305
											],
											[
												0.309,
												0.111
											],
											[
												0.328,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.003,
												-0.078
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-3e-3,
												-0.033
											],
											[
												-0.069,
												-8e-3
											],
											[
												-0.025,
												0
											],
											[
												0,
												0
											],
											[
												-0.327,
												0.167
											],
											[
												-0.199,
												0.455
											]
										],
										o: [
											[
												-0.078,
												-0.5
											],
											[
												-0.062,
												-0.05
											],
											[
												0.062,
												-0.042
											],
											[
												0.305,
												-0.229
											],
											[
												0.14,
												-0.318
											],
											[
												-0.062,
												-0.408
											],
											[
												-0.225,
												-0.221
											],
											[
												-0.296,
												-0.109
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.088,
												0.009
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.034
											],
											[
												0.006,
												0.062
											],
											[
												0.025,
												0.003
											],
											[
												0,
												0
											],
											[
												0.38,
												0
											],
											[
												0.468,
												-0.241
											],
											[
												0.147,
												-0.313
											]
										],
										v: [
											[
												3.02,
												1.403
											],
											[
												2.256,
												0.149
											],
											[
												2.051,
												-1e-3
											],
											[
												2.213,
												-0.11
											],
											[
												2.893,
												-0.954
											],
											[
												3.017,
												-1.931
											],
											[
												2.45,
												-3.004
											],
											[
												1.651,
												-3.509
											],
											[
												0.722,
												-3.666
											],
											[
												-2.849,
												-3.666
											],
											[
												-2.923,
												-3.666
											],
											[
												-3.067,
												-3.529
											],
											[
												-3.067,
												-3.462
											],
											[
												-3.067,
												3.445
											],
											[
												-3.067,
												3.548
											],
											[
												-2.948,
												3.663
											],
											[
												-2.874,
												3.666
											],
											[
												0.822,
												3.666
											],
											[
												1.882,
												3.412
											],
											[
												2.886,
												2.37
											]
										]
									}
								}
							},
							{
								ty: "mm",
								nm: "패스 병합 1",
								mm: 1
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.118,
										0.09,
										0.098
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.668,
										21.399
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 3",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-2.555,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-2.555
											],
											[
												0,
												0
											],
											[
												2.555,
												0
											],
											[
												0,
												0
											],
											[
												0,
												2.555
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												2.555,
												0
											],
											[
												0,
												0
											],
											[
												0,
												2.555
											],
											[
												0,
												0
											],
											[
												-2.555,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-2.555
											]
										],
										v: [
											[
												-4.142,
												-8.768
											],
											[
												4.142,
												-8.768
											],
											[
												8.768,
												-4.142
											],
											[
												8.768,
												4.142
											],
											[
												4.142,
												8.768
											],
											[
												-4.142,
												8.768
											],
											[
												-8.768,
												4.142
											],
											[
												-8.768,
												-4.142
											]
										]
									}
								}
							},
							{
								ty: "st",
								nm: "선 1",
								lc: 1,
								lj: 1,
								ml: 4,
								o: {
									a: 0,
									k: 100
								},
								w: {
									a: 0,
									k: 0.464
								},
								c: {
									a: 0,
									k: [
										0.933,
										0.933,
										0.933
									]
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										1,
										0.894,
										0
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.4,
										21.4
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 4",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-3.588,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-3.588
											],
											[
												0,
												0
											],
											[
												3.588,
												0
											],
											[
												0,
												0
											],
											[
												0,
												3.588
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												3.588,
												0
											],
											[
												0,
												0
											],
											[
												0,
												3.588
											],
											[
												0,
												0
											],
											[
												-3.588,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-3.588
											]
										],
										v: [
											[
												-67.103,
												-20.6
											],
											[
												67.104,
												-20.6
											],
											[
												73.6,
												-14.103
											],
											[
												73.6,
												14.103
											],
											[
												67.104,
												20.6
											],
											[
												-67.103,
												20.6
											],
											[
												-73.6,
												14.103
											],
											[
												-73.6,
												-14.103
											]
										]
									}
								}
							},
							{
								ty: "st",
								nm: "선 1",
								lc: 1,
								lj: 1,
								ml: 4,
								o: {
									a: 0,
									k: 100
								},
								w: {
									a: 0,
									k: 0.8
								},
								c: {
									a: 0,
									k: [
										0.926,
										0.926,
										0.926
									]
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										1,
										1,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										74.4,
										21.4
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 5
			},
			{
				ty: 2,
				nm: "Frame 2117905954.png",
				sr: 1,
				st: 28,
				op: 238,
				ip: 28,
				ln: "10405",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							35,
							35
						]
					},
					s: {
						a: 0,
						k: [
							26,
							26
						]
					},
					p: {
						a: 0,
						k: [
							21.698,
							21.959
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									100
								],
								t: 99.999
							},
							{
								s: [
									0
								],
								t: 103.999
							}
						]
					}
				},
				refId: "18",
				ind: 6,
				parent: 9
			},
			{
				ty: 4,
				nm: "모양 레이어 2",
				sr: 1,
				st: 0,
				op: 210,
				ip: 80,
				ln: "10611",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 0,
						k: [
							100,
							100
						]
					},
					p: {
						a: 0,
						k: [
							181,
							215
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									100
								],
								t: 99.999
							},
							{
								s: [
									0
								],
								t: 103.999
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "사각형 1",
						it: [
							{
								ty: "rc",
								nm: "사각형 패스 1",
								d: 1,
								p: {
									a: 0,
									k: [
										0,
										0
									]
								},
								r: {
									a: 0,
									k: 0
								},
								s: {
									a: 0,
									k: [
										24.197,
										22.67
									]
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										1,
										1,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										84.047,
										100
									]
								},
								p: {
									a: 0,
									k: [
										-52.33,
										-52.231
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 7
			},
			{
				ty: 4,
				nm: "모양 레이어 1",
				sr: 1,
				st: 0,
				op: 210,
				ip: 80,
				ln: "10608",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 0,
						k: [
							100,
							100
						]
					},
					p: {
						a: 0,
						k: [
							181,
							215
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									100
								],
								t: 99.999
							},
							{
								s: [
									0
								],
								t: 103.999
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "사각형 1",
						it: [
							{
								ty: "rc",
								nm: "사각형 패스 1",
								d: 1,
								p: {
									a: 0,
									k: [
										0,
										0
									]
								},
								r: {
									a: 0,
									k: 0
								},
								s: {
									a: 0,
									k: [
										24.197,
										22.67
									]
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										1,
										1,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										84.047,
										100
									]
								},
								p: {
									a: 0,
									k: [
										-52.33,
										-52.231
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 8
			},
			{
				ty: 4,
				nm: "우리 윤곽선",
				sr: 1,
				st: 3,
				op: 175,
				ip: 28,
				ln: "782",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							74.4,
							21.9
						]
					},
					s: {
						a: 1,
						k: [
							{
								s: [
									150,
									150,
									107.143
								],
								i: {
									x: [
										0.667,
										0.667,
										0.667
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.333,
										0.333,
										0.333
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 28
							},
							{
								s: [
									100,
									100,
									100
								],
								i: {
									x: [
										0.833,
										0.833,
										0.833
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.167,
										0.167,
										0.167
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 38
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									181.499,
									229
								],
								t: 38
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									181.499,
									188.5
								],
								t: 48
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									181.499,
									188.5
								],
								t: 57.999
							},
							{
								s: [
									181.499,
									162.531
								],
								t: 66.999
							}
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									100
								],
								t: 99.999
							},
							{
								s: [
									0
								],
								t: 103.999
							}
						]
					}
				},
				ef: [
					{
						ty: 25,
						nm: "그림자 효과",
						en: 1,
						ef: [
							{
								ty: 2,
								nm: "그림자 색상",
								v: {
									a: 0,
									k: [
										0,
										0,
										0
									]
								}
							},
							{
								ty: 0,
								nm: "불투명도",
								v: {
									a: 1,
									k: [
										{
											o: {
												x: 0.167,
												y: 0.167
											},
											i: {
												x: 0.833,
												y: 0.833
											},
											s: [
												35
											],
											t: 28
										},
										{
											s: [
												0
											],
											t: 38
										}
									]
								}
							},
							{
								ty: 1,
								nm: "방향",
								v: {
									a: 0,
									k: 135
								}
							},
							{
								ty: 0,
								nm: "거리",
								v: {
									a: 0,
									k: 5
								}
							},
							{
								ty: 0,
								nm: "부드러움",
								v: {
									a: 0,
									k: 18
								}
							},
							{
								ty: 7,
								nm: "그림자만",
								v: {
									a: 0,
									k: 0
								}
							}
						]
					}
				],
				shapes: [
					{
						ty: "gr",
						nm: "그룹 1",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0.213,
												0
											],
											[
												0.2,
												-0.114
											],
											[
												0,
												-0.234
											],
											[
												-0.194,
												-0.12
											],
											[
												-0.307,
												0
											],
											[
												-0.186,
												0.113
											],
											[
												0,
												0.22
											],
											[
												0.086,
												0.1
											],
											[
												0.153,
												0.053
											]
										],
										o: [
											[
												-0.307,
												0
											],
											[
												-0.194,
												0.113
											],
											[
												0,
												0.22
											],
											[
												0.2,
												0.113
											],
											[
												0.314,
												0
											],
											[
												0.193,
												-0.12
											],
											[
												0,
												-0.154
											],
											[
												-0.088,
												-0.1
											],
											[
												-0.155,
												-0.054
											]
										],
										v: [
											[
												12.038,
												-3.71
											],
											[
												11.279,
												-3.54
											],
											[
												10.988,
												-3.02
											],
											[
												11.279,
												-2.51
											],
											[
												12.038,
												-2.34
											],
											[
												12.788,
												-2.51
											],
											[
												13.078,
												-3.02
											],
											[
												12.949,
												-3.4
											],
											[
												12.589,
												-3.63
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 2",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-0.453,
												0
											],
											[
												-0.347,
												-0.14
											],
											[
												-0.194,
												-0.247
											],
											[
												0,
												-0.334
											],
											[
												0.201,
												-0.254
											],
											[
												0.347,
												-0.134
											],
											[
												0.454,
												0
											],
											[
												0.354,
												0.133
											],
											[
												0.194,
												0.246
											],
											[
												0,
												0.326
											],
											[
												-0.194,
												0.246
											],
											[
												-0.347,
												0.14
											]
										],
										o: [
											[
												0.454,
												0
											],
											[
												0.347,
												0.14
											],
											[
												0.201,
												0.246
											],
											[
												0,
												0.326
											],
											[
												-0.194,
												0.246
											],
											[
												-0.347,
												0.133
											],
											[
												-0.453,
												0
											],
											[
												-0.347,
												-0.134
											],
											[
												-0.194,
												-0.254
											],
											[
												0,
												-0.334
											],
											[
												0.194,
												-0.247
											],
											[
												0.354,
												-0.14
											]
										],
										v: [
											[
												12.038,
												-4.68
											],
											[
												13.238,
												-4.47
											],
											[
												14.048,
												-3.89
											],
											[
												14.348,
												-3.02
											],
											[
												14.048,
												-2.15
											],
											[
												13.238,
												-1.58
											],
											[
												12.038,
												-1.38
											],
											[
												10.828,
												-1.58
											],
											[
												10.018,
												-2.15
											],
											[
												9.729,
												-3.02
											],
											[
												10.018,
												-3.89
											],
											[
												10.828,
												-4.47
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 3",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												13.818,
												0.38
											],
											[
												15.859,
												0.38
											],
											[
												15.859,
												1.29
											],
											[
												13.818,
												1.29
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 4",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0.552,
												-7e-3
											],
											[
												0,
												0
											],
											[
												-0.666,
												0.006
											],
											[
												-0.694,
												0.04
											],
											[
												-0.64,
												0.08
											],
											[
												0,
												0
											],
											[
												0.686,
												-0.06
											],
											[
												0.645,
												-0.014
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0.565,
												-7e-3
											],
											[
												0.666,
												-0.014
											],
											[
												0.692,
												-0.04
											],
											[
												0,
												0
											],
											[
												-0.66,
												0.113
											],
											[
												-0.679,
												0.053
											],
											[
												-0.647,
												0.013
											]
										],
										v: [
											[
												9.229,
												0.16
											],
											[
												9.059,
												-0.9
											],
											[
												10.908,
												-0.92
											],
											[
												12.949,
												-1
											],
											[
												14.949,
												-1.18
											],
											[
												15.038,
												-0.23
											],
											[
												13.018,
												0.03
											],
											[
												11.029,
												0.13
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 5",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.218,
												1.35
											],
											[
												11.548,
												1.35
											],
											[
												11.548,
												3.33
											],
											[
												10.218,
												3.33
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 6",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.218,
												3.04
											],
											[
												17.098,
												3.04
											],
											[
												17.098,
												4.11
											],
											[
												10.218,
												4.11
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 7",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												15.559,
												-5
											],
											[
												16.889,
												-5
											],
											[
												16.889,
												2.02
											],
											[
												15.559,
												2.02
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 8",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												11.508,
												-0.24
											],
											[
												12.839,
												-0.24
											],
											[
												12.839,
												1.78
											],
											[
												11.508,
												1.78
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 9",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.06,
												0
											],
											[
												0,
												1.41
											],
											[
												1.041,
												0
											],
											[
												0,
												-1.39
											]
										],
										o: [
											[
												1.05,
												0
											],
											[
												0,
												-1.39
											],
											[
												-1.05,
												0
											],
											[
												0,
												1.41
											]
										],
										v: [
											[
												5.348,
												2.14
											],
											[
												6.788,
												-0.39
											],
											[
												5.348,
												-2.88
											],
											[
												3.908,
												-0.39
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 10",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												-2.08
											],
											[
												1.95,
												0
											],
											[
												0,
												2.09
											],
											[
												-1.94,
												0
											]
										],
										o: [
											[
												0,
												2.09
											],
											[
												-1.95,
												0
											],
											[
												0,
												-2.08
											],
											[
												1.94,
												0
											]
										],
										v: [
											[
												8.318,
												-0.39
											],
											[
												5.348,
												3.48
											],
											[
												2.389,
												-0.39
											],
											[
												5.348,
												-4.22
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 11",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.06,
												0
											],
											[
												0,
												1.41
											],
											[
												1.039,
												0
											],
											[
												0,
												-1.39
											]
										],
										o: [
											[
												1.049,
												0
											],
											[
												0,
												-1.39
											],
											[
												-1.051,
												0
											],
											[
												0,
												1.41
											]
										],
										v: [
											[
												-1.331,
												2.14
											],
											[
												0.109,
												-0.39
											],
											[
												-1.331,
												-2.88
											],
											[
												-2.771,
												-0.39
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 12",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												-2.08
											],
											[
												1.949,
												0
											],
											[
												0,
												2.09
											],
											[
												-1.94,
												0
											]
										],
										o: [
											[
												0,
												2.09
											],
											[
												-1.951,
												0
											],
											[
												0,
												-2.08
											],
											[
												1.94,
												0
											]
										],
										v: [
											[
												1.639,
												-0.39
											],
											[
												-1.331,
												3.48
											],
											[
												-4.292,
												-0.39
											],
											[
												-1.331,
												-4.22
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 13",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0.72,
												0
											],
											[
												0,
												-0.74
											],
											[
												-0.72,
												0
											],
											[
												-0.231,
												0.27
											],
											[
												0,
												0.31
											]
										],
										o: [
											[
												-0.73,
												0
											],
											[
												0,
												0.71
											],
											[
												0.401,
												0
											],
											[
												0.17,
												-0.2
											],
											[
												0,
												-0.72
											]
										],
										v: [
											[
												-7.648,
												-2.91
											],
											[
												-8.908,
												-1.68
											],
											[
												-7.648,
												-0.49
											],
											[
												-6.667,
												-0.92
											],
											[
												-6.398,
												-1.7
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 14",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0.369,
												-0.54
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.159,
												0
											],
											[
												0,
												1.42
											],
											[
												-1.549,
												0
											],
											[
												0,
												-1.53
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.14,
												0.04
											],
											[
												-1.39,
												-0.04
											],
											[
												0,
												-1.54
											],
											[
												1.53,
												0
											],
											[
												0,
												0.66
											]
										],
										v: [
											[
												-5.527,
												0.06
											],
											[
												-7.717,
												3.38
											],
											[
												-9.348,
												3.38
											],
											[
												-7.508,
												0.63
											],
											[
												-7.967,
												0.68
											],
											[
												-10.408,
												-1.72
											],
											[
												-7.648,
												-4.22
											],
											[
												-4.928,
												-1.75
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 15",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.37
											],
											[
												-0.511,
												0
											],
											[
												0,
												-0.51
											],
											[
												0.151,
												-0.25
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.399,
												-0.16
											],
											[
												0,
												-0.53
											],
											[
												0.56,
												0
											],
											[
												0,
												0.27
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-12.184,
												5
											],
											[
												-13.104,
												5
											],
											[
												-12.294,
												3.47
											],
											[
												-12.874,
												2.64
											],
											[
												-11.973,
												1.78
											],
											[
												-11.064,
												2.67
											],
											[
												-11.314,
												3.48
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 16",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-15.499,
												3.38
											],
											[
												-15.499,
												-2.21
											],
											[
												-17.098,
												-1.5
											],
											[
												-17.098,
												-2.92
											],
											[
												-14.038,
												-4.33
											],
											[
												-14.038,
												3.38
											]
										]
									}
								}
							},
							{
								ty: "mm",
								nm: "패스 병합 1",
								mm: 1
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.4,
										0.4,
										0.4
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										117.689,
										21.52
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 2",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												1.573,
												0
											],
											[
												1.185,
												-0.444
											],
											[
												-1.887,
												0
											],
											[
												-0.722,
												1.61
											]
										],
										o: [
											[
												-1.555,
												0
											],
											[
												0.722,
												1.61
											],
											[
												1.869,
												0
											],
											[
												-1.203,
												-0.444
											]
										],
										v: [
											[
												-9e-3,
												-1.72
											],
											[
												-4.21,
												-1.017
											],
											[
												0.009,
												1.72
											],
											[
												4.21,
												-1.017
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.482,
										0.78
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.438,
										25.021
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 3",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.777,
												0
											],
											[
												-0.666,
												-0.481
											],
											[
												0,
												0.39
											],
											[
												2.387,
												0
											],
											[
												0,
												-1.572
											],
											[
												-0.222,
												-0.332
											]
										],
										o: [
											[
												1.776,
												0
											],
											[
												0.222,
												-0.35
											],
											[
												0,
												-1.59
											],
											[
												-2.387,
												0
											],
											[
												0,
												0.407
											],
											[
												0.666,
												-0.461
											]
										],
										v: [
											[
												0,
												1.277
											],
											[
												3.978,
												2.09
											],
											[
												4.312,
												0.98
											],
											[
												0,
												-2.09
											],
											[
												-4.312,
												0.98
											],
											[
												-3.979,
												2.09
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										1,
										1,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.437,
										23.603
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 4",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.777,
												0
											],
											[
												-0.666,
												-0.481
											],
											[
												0,
												0.408
											],
											[
												2.368,
												0
											],
											[
												0,
												-1.609
											],
											[
												-0.222,
												-0.35
											]
										],
										o: [
											[
												1.795,
												0
											],
											[
												0.222,
												-0.35
											],
											[
												0,
												-1.592
											],
											[
												-2.387,
												0
											],
											[
												0,
												0.408
											],
											[
												0.666,
												-0.481
											]
										],
										v: [
											[
												0,
												1.305
											],
											[
												3.978,
												2.118
											],
											[
												4.312,
												0.99
											],
											[
												0,
												-2.118
											],
											[
												-4.312,
												0.99
											],
											[
												-3.979,
												2.118
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.984,
										0.992,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.437,
										23.574
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 5",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.776,
												0
											],
											[
												-0.648,
												-0.481
											],
											[
												0,
												0.407
											],
											[
												2.387,
												0
											],
											[
												0,
												-1.609
											],
											[
												-0.222,
												-0.351
											]
										],
										o: [
											[
												1.795,
												0
											],
											[
												0.222,
												-0.351
											],
											[
												0,
												-1.609
											],
											[
												-2.387,
												0
											],
											[
												0,
												0.407
											],
											[
												0.666,
												-0.481
											]
										],
										v: [
											[
												0,
												1.295
											],
											[
												3.979,
												2.128
											],
											[
												4.33,
												0.999
											],
											[
												0,
												-2.128
											],
											[
												-4.33,
												0.999
											],
											[
												-3.997,
												2.128
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.969,
										0.984,
										0.996
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.431,
										23.567
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 6",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.795,
												0
											],
											[
												-0.648,
												-0.48
											],
											[
												0,
												0.407
											],
											[
												2.387,
												0
											],
											[
												0,
												-1.629
											],
											[
												-0.222,
												-0.351
											]
										],
										o: [
											[
												1.795,
												0
											],
											[
												0.222,
												-0.351
											],
											[
												0,
												-1.629
											],
											[
												-2.387,
												0
											],
											[
												0,
												0.407
											],
											[
												0.666,
												-0.48
											]
										],
										v: [
											[
												0,
												1.314
											],
											[
												3.979,
												2.146
											],
											[
												4.33,
												1
											],
											[
												0,
												-2.146
											],
											[
												-4.33,
												1
											],
											[
												-3.997,
												2.146
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.949,
										0.977,
										0.992
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.431,
										23.531
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 7",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.795,
												0
											],
											[
												-0.666,
												-0.499
											],
											[
												0,
												0.407
											],
											[
												2.387,
												0
											],
											[
												0,
												-1.627
											],
											[
												-0.222,
												-0.351
											]
										],
										o: [
											[
												1.794,
												0
											],
											[
												0.223,
												-0.351
											],
											[
												0,
												-1.646
											],
											[
												-2.405,
												0
											],
											[
												0,
												0.407
											],
											[
												0.648,
												-0.499
											]
										],
										v: [
											[
												-0.018,
												1.305
											],
											[
												3.978,
												2.156
											],
											[
												4.33,
												1.008
											],
											[
												0,
												-2.156
											],
											[
												-4.33,
												1.008
											],
											[
												-3.997,
												2.156
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.929,
										0.969,
										0.992
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.455,
										23.54
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 8",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.795,
												0
											],
											[
												-0.667,
												-0.5
											],
											[
												0,
												0.425
											],
											[
												2.405,
												0
											],
											[
												0,
												-1.665
											],
											[
												-0.203,
												-0.37
											]
										],
										o: [
											[
												1.795,
												0
											],
											[
												0.222,
												-0.353
											],
											[
												0,
												-1.648
											],
											[
												-2.406,
												0
											],
											[
												0,
												0.406
											],
											[
												0.685,
												-0.5
											]
										],
										v: [
											[
												0,
												1.333
											],
											[
												3.997,
												2.184
											],
											[
												4.349,
												1.018
											],
											[
												0,
												-2.184
											],
											[
												-4.349,
												1.018
											],
											[
												-4.016,
												2.184
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.914,
										0.961,
										0.988
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.437,
										23.492
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 9",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.795,
												0
											],
											[
												-0.648,
												-0.5
											],
											[
												0,
												0.407
											],
											[
												2.405,
												0
											],
											[
												0,
												-1.666
											],
											[
												-0.203,
												-0.352
											]
										],
										o: [
											[
												1.795,
												0
											],
											[
												0.222,
												-0.352
											],
											[
												0,
												-1.666
											],
											[
												-2.406,
												0
											],
											[
												0,
												0.425
											],
											[
												0.666,
												-0.5
											]
										],
										v: [
											[
												0,
												1.341
											],
											[
												3.997,
												2.193
											],
											[
												4.349,
												1.027
											],
											[
												0,
												-2.193
											],
											[
												-4.349,
												1.027
											],
											[
												-4.016,
												2.193
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.894,
										0.953,
										0.988
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.437,
										23.483
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 10",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.794,
												0
											],
											[
												-0.668,
												-0.519
											],
											[
												0,
												0.426
											],
											[
												2.405,
												0
											],
											[
												0,
												-1.664
											],
											[
												-0.222,
												-0.371
											]
										],
										o: [
											[
												1.795,
												0
											],
											[
												0.222,
												-0.371
											],
											[
												0,
												-1.683
											],
											[
												-2.406,
												0
											],
											[
												0,
												0.426
											],
											[
												0.628,
												-0.519
											]
										],
										v: [
											[
												-0.019,
												1.341
											],
											[
												3.998,
												2.211
											],
											[
												4.349,
												1.026
											],
											[
												0,
												-2.211
											],
											[
												-4.349,
												1.026
											],
											[
												-3.996,
												2.211
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.875,
										0.945,
										0.984
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.45,
										23.463
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 11",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.795,
												0
											],
											[
												-0.667,
												-0.517
											],
											[
												0,
												0.424
											],
											[
												2.406,
												0
											],
											[
												0,
												-1.684
											],
											[
												-0.222,
												-0.351
											]
										],
										o: [
											[
												1.814,
												0
											],
											[
												0.222,
												-0.369
											],
											[
												0,
												-1.684
											],
											[
												-2.405,
												0
											],
											[
												0,
												0.424
											],
											[
												0.666,
												-0.5
											]
										],
										v: [
											[
												0,
												1.351
											],
											[
												4.016,
												2.22
											],
											[
												4.367,
												1.037
											],
											[
												0,
												-2.22
											],
											[
												-4.367,
												1.037
											],
											[
												-4.015,
												2.22
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.855,
										0.937,
										0.98
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.436,
										23.439
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 12",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.795,
												0
											],
											[
												-0.648,
												-0.499
											],
											[
												0,
												0.425
											],
											[
												2.406,
												0
											],
											[
												0,
												-1.703
											],
											[
												-0.222,
												-0.37
											]
										],
										o: [
											[
												1.814,
												0
											],
											[
												0.222,
												-0.37
											],
											[
												0,
												-1.703
											],
											[
												-2.405,
												0
											],
											[
												0,
												0.425
											],
											[
												0.666,
												-0.518
											]
										],
										v: [
											[
												0,
												1.379
											],
											[
												4.016,
												2.248
											],
											[
												4.367,
												1.046
											],
											[
												0,
												-2.248
											],
											[
												-4.367,
												1.046
											],
											[
												-4.015,
												2.248
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.835,
										0.926,
										0.98
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.436,
										23.41
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 13",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.814,
												0
											],
											[
												-0.667,
												-0.518
											],
											[
												0,
												0.426
											],
											[
												2.406,
												0
											],
											[
												0,
												-1.72
											],
											[
												-0.222,
												-0.369
											]
										],
										o: [
											[
												1.813,
												0
											],
											[
												0.222,
												-0.369
											],
											[
												0,
												-1.72
											],
											[
												-2.424,
												0
											],
											[
												0,
												0.426
											],
											[
												0.629,
												-0.518
											]
										],
										v: [
											[
												-0.018,
												1.369
											],
											[
												4.016,
												2.257
											],
											[
												4.367,
												1.054
											],
											[
												0,
												-2.257
											],
											[
												-4.367,
												1.054
											],
											[
												-4.015,
												2.257
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.812,
										0.918,
										0.977
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.455,
										23.4
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 14",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.814,
												0
											],
											[
												-0.667,
												-0.52
											],
											[
												0,
												0.443
											],
											[
												2.423,
												0
											],
											[
												0,
												-1.722
											],
											[
												-0.222,
												-0.371
											]
										],
										o: [
											[
												1.813,
												0
											],
											[
												0.222,
												-0.371
											],
											[
												0,
												-1.722
											],
											[
												-2.425,
												0
											],
											[
												0,
												0.425
											],
											[
												0.666,
												-0.52
											]
										],
										v: [
											[
												0.001,
												1.387
											],
											[
												4.035,
												2.277
											],
											[
												4.385,
												1.055
											],
											[
												0.001,
												-2.277
											],
											[
												-4.385,
												1.055
											],
											[
												-4.033,
												2.277
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.792,
										0.91,
										0.973
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.436,
										23.365
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 15",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.814,
												0
											],
											[
												-0.667,
												-0.518
											],
											[
												0,
												0.426
											],
											[
												2.423,
												0
											],
											[
												0,
												-1.738
											],
											[
												-0.222,
												-0.369
											]
										],
										o: [
											[
												1.813,
												0
											],
											[
												0.222,
												-0.369
											],
											[
												0,
												-1.738
											],
											[
												-2.425,
												0
											],
											[
												0,
												0.445
											],
											[
												0.666,
												-0.518
											]
										],
										v: [
											[
												0.001,
												1.397
											],
											[
												4.035,
												2.285
											],
											[
												4.385,
												1.063
											],
											[
												0.001,
												-2.285
											],
											[
												-4.385,
												1.063
											],
											[
												-4.033,
												2.285
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.773,
										0.902,
										0.969
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.436,
										23.357
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 16",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.813,
												0
											],
											[
												-0.667,
												-0.537
											],
											[
												0,
												0.444
											],
											[
												2.424,
												0
											],
											[
												0,
												-1.758
											],
											[
												-0.222,
												-0.389
											]
										],
										o: [
											[
												1.814,
												0
											],
											[
												0.222,
												-0.389
											],
											[
												0,
												-1.758
											],
											[
												-2.424,
												0
											],
											[
												0,
												0.444
											],
											[
												0.647,
												-0.537
											]
										],
										v: [
											[
												-0.019,
												1.406
											],
											[
												4.034,
												2.313
											],
											[
												4.386,
												1.073
											],
											[
												0,
												-2.313
											],
											[
												-4.386,
												1.073
											],
											[
												-4.034,
												2.313
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.749,
										0.89,
										0.965
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.455,
										23.331
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 17",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.814,
												0
											],
											[
												-0.666,
												-0.536
											],
											[
												0,
												0.444
											],
											[
												2.424,
												0
											],
											[
												0,
												-1.776
											],
											[
												-0.222,
												-0.37
											]
										],
										o: [
											[
												1.813,
												0
											],
											[
												0.222,
												-0.388
											],
											[
												0,
												-1.776
											],
											[
												-2.424,
												0
											],
											[
												0,
												0.444
											],
											[
												0.666,
												-0.518
											]
										],
										v: [
											[
												0,
												1.415
											],
											[
												4.052,
												2.322
											],
											[
												4.404,
												1.082
											],
											[
												0,
												-2.322
											],
											[
												-4.404,
												1.082
											],
											[
												-4.053,
												2.322
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.729,
										0.882,
										0.965
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.436,
										23.302
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 18",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.814,
												0
											],
											[
												-0.666,
												-0.555
											],
											[
												0,
												0.443
											],
											[
												2.424,
												0
											],
											[
												0,
												-1.776
											],
											[
												-0.222,
												-0.388
											]
										],
										o: [
											[
												1.813,
												0
											],
											[
												0.222,
												-0.388
											],
											[
												0,
												-1.776
											],
											[
												-2.424,
												0
											],
											[
												0,
												0.443
											],
											[
												0.666,
												-0.555
											]
										],
										v: [
											[
												0,
												1.415
											],
											[
												4.052,
												2.34
											],
											[
												4.404,
												1.083
											],
											[
												0,
												-2.34
											],
											[
												-4.404,
												1.083
											],
											[
												-4.053,
												2.34
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.706,
										0.875,
										0.961
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.436,
										23.301
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 19",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.814,
												0
											],
											[
												-0.666,
												-0.537
											],
											[
												0,
												0.444
											],
											[
												2.424,
												0
											],
											[
												0,
												-1.777
											],
											[
												-0.222,
												-0.389
											]
										],
										o: [
											[
												1.832,
												0
											],
											[
												0.222,
												-0.389
											],
											[
												0,
												-1.795
											],
											[
												-2.443,
												0
											],
											[
												0,
												0.444
											],
											[
												0.666,
												-0.537
											]
										],
										v: [
											[
												0,
												1.425
											],
											[
												4.052,
												2.35
											],
											[
												4.404,
												1.092
											],
											[
												0,
												-2.35
											],
											[
												-4.404,
												1.092
											],
											[
												-4.053,
												2.35
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.686,
										0.863,
										0.957
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.436,
										23.273
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 20",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.832,
												0
											],
											[
												-0.666,
												-0.538
											],
											[
												0,
												0.463
											],
											[
												2.443,
												0
											],
											[
												0,
												-1.812
											],
											[
												-0.222,
												-0.39
											]
										],
										o: [
											[
												1.833,
												0
											],
											[
												0.222,
												-0.39
											],
											[
												0,
												-1.812
											],
											[
												-2.443,
												0
											],
											[
												0,
												0.444
											],
											[
												0.684,
												-0.556
											]
										],
										v: [
											[
												0,
												1.452
											],
											[
												4.071,
												2.378
											],
											[
												4.422,
												1.1
											],
											[
												0,
												-2.378
											],
											[
												-4.422,
												1.1
											],
											[
												-4.07,
												2.378
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.663,
										0.855,
										0.953
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.435,
										23.246
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 21",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.832,
												0
											],
											[
												-0.666,
												-0.555
											],
											[
												0,
												0.445
											],
											[
												2.443,
												0
											],
											[
												0,
												-1.813
											],
											[
												-0.222,
												-0.388
											]
										],
										o: [
											[
												1.833,
												0
											],
											[
												0.222,
												-0.388
											],
											[
												0,
												-1.813
											],
											[
												-2.443,
												0
											],
											[
												0,
												0.463
											],
											[
												0.666,
												-0.555
											]
										],
										v: [
											[
												0,
												1.444
											],
											[
												4.071,
												2.387
											],
											[
												4.422,
												1.11
											],
											[
												0,
												-2.387
											],
											[
												-4.422,
												1.11
											],
											[
												-4.07,
												2.387
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.639,
										0.843,
										0.949
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.435,
										23.234
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 22",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.832,
												0
											],
											[
												-0.666,
												-0.555
											],
											[
												0,
												0.463
											],
											[
												2.443,
												0
											],
											[
												0,
												-1.832
											],
											[
												-0.222,
												-0.407
											]
										],
										o: [
											[
												1.833,
												0
											],
											[
												0.222,
												-0.39
											],
											[
												0,
												-1.832
											],
											[
												-2.443,
												0
											],
											[
												0,
												0.463
											],
											[
												0.666,
												-0.555
											]
										],
										v: [
											[
												0,
												1.462
											],
											[
												4.071,
												2.406
											],
											[
												4.422,
												1.109
											],
											[
												0,
												-2.406
											],
											[
												-4.422,
												1.109
											],
											[
												-4.07,
												2.406
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.612,
										0.835,
										0.945
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.435,
										23.198
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 23",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.832,
												0
											],
											[
												-0.685,
												-0.555
											],
											[
												0,
												0.462
											],
											[
												2.461,
												0
											],
											[
												0,
												-1.851
											],
											[
												-0.222,
												-0.389
											]
										],
										o: [
											[
												1.832,
												0
											],
											[
												0.222,
												-0.407
											],
											[
												0,
												-1.851
											],
											[
												-2.442,
												0
											],
											[
												0,
												0.462
											],
											[
												0.684,
												-0.555
											]
										],
										v: [
											[
												0,
												1.48
											],
											[
												4.09,
												2.424
											],
											[
												4.441,
												1.129
											],
											[
												0,
												-2.424
											],
											[
												-4.441,
												1.129
											],
											[
												-4.089,
												2.424
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.588,
										0.828,
										0.945
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.439,
										23.179
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 24",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.832,
												0
											],
											[
												-0.667,
												-0.575
											],
											[
												0,
												0.463
											],
											[
												2.443,
												0
											],
											[
												0,
												-1.868
											],
											[
												-0.222,
												-0.408
											]
										],
										o: [
											[
												1.832,
												0
											],
											[
												0.222,
												-0.408
											],
											[
												0,
												-1.849
											],
											[
												-2.442,
												0
											],
											[
												0,
												0.463
											],
											[
												0.684,
												-0.575
											]
										],
										v: [
											[
												0,
												1.48
											],
											[
												4.09,
												2.443
											],
											[
												4.441,
												1.128
											],
											[
												0,
												-2.443
											],
											[
												-4.441,
												1.128
											],
											[
												-4.089,
												2.443
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.561,
										0.816,
										0.941
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.439,
										23.16
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 25",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.832,
												0
											],
											[
												-0.667,
												-0.574
											],
											[
												0,
												0.462
											],
											[
												2.443,
												0
											],
											[
												0,
												-1.869
											],
											[
												-0.222,
												-0.408
											]
										],
										o: [
											[
												1.832,
												0
											],
											[
												0.222,
												-0.408
											],
											[
												0,
												-1.869
											],
											[
												-2.461,
												0
											],
											[
												0,
												0.462
											],
											[
												0.666,
												-0.556
											]
										],
										v: [
											[
												0,
												1.489
											],
											[
												4.09,
												2.452
											],
											[
												4.441,
												1.138
											],
											[
												0,
												-2.452
											],
											[
												-4.441,
												1.138
											],
											[
												-4.089,
												2.452
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.533,
										0.808,
										0.937
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.439,
										23.131
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 26",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.832,
												0
											],
											[
												-0.685,
												-0.556
											],
											[
												0,
												0.48
											],
											[
												2.461,
												0
											],
											[
												0,
												-1.869
											],
											[
												-0.222,
												-0.408
											]
										],
										o: [
											[
												1.833,
												0
											],
											[
												0.222,
												-0.408
											],
											[
												0,
												-1.888
											],
											[
												-2.46,
												0
											],
											[
												0,
												0.461
											],
											[
												0.686,
												-0.575
											]
										],
										v: [
											[
												0,
												1.508
											],
											[
												4.109,
												2.471
											],
											[
												4.459,
												1.139
											],
											[
												0,
												-2.471
											],
											[
												-4.459,
												1.139
											],
											[
												-4.108,
												2.471
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.506,
										0.796,
										0.933
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.439,
										23.113
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 27",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.85,
												0
											],
											[
												-0.685,
												-0.574
											],
											[
												0,
												0.462
											],
											[
												2.461,
												0
											],
											[
												0,
												-1.906
											],
											[
												-0.222,
												-0.407
											]
										],
										o: [
											[
												1.851,
												0
											],
											[
												0.222,
												-0.407
											],
											[
												0,
												-1.888
											],
											[
												-2.46,
												0
											],
											[
												0,
												0.481
											],
											[
												0.686,
												-0.574
											]
										],
										v: [
											[
												0,
												1.508
											],
											[
												4.109,
												2.489
											],
											[
												4.459,
												1.157
											],
											[
												0,
												-2.489
											],
											[
												-4.459,
												1.157
											],
											[
												-4.108,
												2.489
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.475,
										0.788,
										0.929
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.439,
										23.094
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 28",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.85,
												0
											],
											[
												-0.666,
												-0.574
											],
											[
												0,
												0.48
											],
											[
												2.461,
												0
											],
											[
												0,
												-1.907
											],
											[
												-0.222,
												-0.425
											]
										],
										o: [
											[
												1.851,
												0
											],
											[
												0.222,
												-0.406
											],
											[
												0,
												-1.907
											],
											[
												-2.46,
												0
											],
											[
												0,
												0.48
											],
											[
												0.686,
												-0.591
											]
										],
										v: [
											[
												0,
												1.526
											],
											[
												4.109,
												2.507
											],
											[
												4.459,
												1.157
											],
											[
												0,
												-2.507
											],
											[
												-4.459,
												1.157
											],
											[
												-4.108,
												2.507
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.443,
										0.777,
										0.926
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.439,
										23.079
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 29",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.85,
												0
											],
											[
												-0.666,
												-0.592
											],
											[
												0,
												0.483
											],
											[
												2.479,
												0
											],
											[
												0,
												-1.923
											],
											[
												-0.222,
												-0.407
											]
										],
										o: [
											[
												1.85,
												0
											],
											[
												0.222,
												-0.407
											],
											[
												0,
												-1.923
											],
											[
												-2.462,
												0
											],
											[
												0,
												0.483
											],
											[
												0.703,
												-0.592
											]
										],
										v: [
											[
												0.018,
												1.518
											],
											[
												4.126,
												2.516
											],
											[
												4.478,
												1.165
											],
											[
												0,
												-2.516
											],
											[
												-4.478,
												1.165
											],
											[
												-4.127,
												2.516
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.412,
										0.769,
										0.922
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.42,
										23.067
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 30",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.85,
												0
											],
											[
												-0.685,
												-0.592
											],
											[
												0,
												0.5
											],
											[
												2.48,
												0
											],
											[
												0,
												-1.924
											],
											[
												-0.222,
												-0.426
											]
										],
										o: [
											[
												1.851,
												0
											],
											[
												0.222,
												-0.426
											],
											[
												0,
												-1.943
											],
											[
												-2.479,
												0
											],
											[
												0,
												0.482
											],
											[
												0.685,
												-0.574
											]
										],
										v: [
											[
												0,
												1.535
											],
											[
												4.127,
												2.535
											],
											[
												4.478,
												1.165
											],
											[
												0,
												-2.535
											],
											[
												-4.478,
												1.165
											],
											[
												-4.126,
												2.535
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.377,
										0.757,
										0.918
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.438,
										23.032
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 31",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.85,
												0
											],
											[
												-0.685,
												-0.591
											],
											[
												0,
												0.481
											],
											[
												2.461,
												0
											],
											[
												0,
												-1.961
											],
											[
												-0.222,
												-0.425
											]
										],
										o: [
											[
												1.851,
												0
											],
											[
												0.222,
												-0.425
											],
											[
												0,
												-1.943
											],
											[
												-2.479,
												0
											],
											[
												0,
												0.481
											],
											[
												0.685,
												-0.591
											]
										],
										v: [
											[
												0,
												1.555
											],
											[
												4.127,
												2.553
											],
											[
												4.478,
												1.184
											],
											[
												0,
												-2.553
											],
											[
												-4.478,
												1.184
											],
											[
												-4.126,
												2.553
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.337,
										0.749,
										0.918
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.438,
										23.012
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 32",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.851,
												0
											],
											[
												-0.666,
												-0.592
											],
											[
												0,
												0.5
											],
											[
												2.479,
												0
											],
											[
												0,
												-1.961
											],
											[
												-0.222,
												-0.425
											]
										],
										o: [
											[
												1.85,
												0
											],
											[
												0.222,
												-0.425
											],
											[
												0,
												-1.961
											],
											[
												-2.479,
												0
											],
											[
												0,
												0.5
											],
											[
												0.722,
												-0.592
											]
										],
										v: [
											[
												0.019,
												1.555
											],
											[
												4.145,
												2.572
											],
											[
												4.496,
												1.184
											],
											[
												0,
												-2.572
											],
											[
												-4.496,
												1.184
											],
											[
												-4.146,
												2.572
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.298,
										0.741,
										0.914
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.42,
										22.995
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 33",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.85,
												0
											],
											[
												-0.685,
												-0.593
											],
											[
												0,
												0.5
											],
											[
												2.479,
												0
											],
											[
												0,
												-1.981
											],
											[
												-0.222,
												-0.427
											]
										],
										o: [
											[
												1.85,
												0
											],
											[
												0.222,
												-0.427
											],
											[
												0,
												-1.981
											],
											[
												-2.48,
												0
											],
											[
												0,
												0.5
											],
											[
												0.685,
												-0.593
											]
										],
										v: [
											[
												0,
												1.563
											],
											[
												4.145,
												2.582
											],
											[
												4.496,
												1.194
											],
											[
												0,
												-2.582
											],
											[
												-4.496,
												1.194
											],
											[
												-4.145,
												2.582
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.247,
										0.729,
										0.91
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.439,
										22.966
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 34",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.869,
												0
											],
											[
												-0.685,
												-0.592
											],
											[
												0,
												0.499
											],
											[
												2.479,
												0
											],
											[
												0,
												-1.98
											],
											[
												-0.222,
												-0.426
											]
										],
										o: [
											[
												1.869,
												0
											],
											[
												0.222,
												-0.426
											],
											[
												0,
												-1.98
											],
											[
												-2.48,
												0
											],
											[
												0,
												0.499
											],
											[
												0.685,
												-0.592
											]
										],
										v: [
											[
												0,
												1.582
											],
											[
												4.145,
												2.6
											],
											[
												4.496,
												1.194
											],
											[
												0,
												-2.6
											],
											[
												-4.496,
												1.194
											],
											[
												-4.145,
												2.6
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.188,
										0.722,
										0.906
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.439,
										22.947
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 35",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.869,
												0
											],
											[
												-0.684,
												-0.61
											],
											[
												0,
												0.499
											],
											[
												2.498,
												0
											],
											[
												0,
												-1.999
											],
											[
												-0.222,
												-0.425
											]
										],
										o: [
											[
												1.869,
												0
											],
											[
												0.222,
												-0.425
											],
											[
												0,
												-2.017
											],
											[
												-2.498,
												0
											],
											[
												0,
												0.499
											],
											[
												0.703,
												-0.591
											]
										],
										v: [
											[
												0,
												1.583
											],
											[
												4.163,
												2.618
											],
											[
												4.515,
												1.213
											],
											[
												0,
												-2.618
											],
											[
												-4.515,
												1.213
											],
											[
												-4.164,
												2.618
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.157,
										0.714,
										0.902
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.438,
										22.927
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 36",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.87,
												0
											],
											[
												-0.685,
												-0.611
											],
											[
												0,
												0.5
											],
											[
												2.498,
												0
											],
											[
												0,
												-2.035
											],
											[
												-0.222,
												-0.426
											]
										],
										o: [
											[
												1.869,
												0
											],
											[
												0.222,
												-0.444
											],
											[
												0,
												-2.035
											],
											[
												-2.497,
												0
											],
											[
												0,
												0.5
											],
											[
												0.722,
												-0.592
											]
										],
										v: [
											[
												0.019,
												1.61
											],
											[
												4.183,
												2.646
											],
											[
												4.534,
												1.221
											],
											[
												0,
												-2.646
											],
											[
												-4.534,
												1.221
											],
											[
												-4.181,
												2.646
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.126,
										0.706,
										0.898
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.423,
										22.901
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 37",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.869,
												0
											],
											[
												-0.686,
												-0.611
											],
											[
												0,
												0.518
											],
											[
												2.498,
												0
											],
											[
												0,
												-2.054
											],
											[
												-0.222,
												-0.444
											]
										],
										o: [
											[
												1.869,
												0
											],
											[
												0.239,
												-0.444
											],
											[
												0,
												-2.054
											],
											[
												-2.498,
												0
											],
											[
												0,
												0.518
											],
											[
												0.703,
												-0.629
											]
										],
										v: [
											[
												0,
												1.619
											],
											[
												4.183,
												2.674
											],
											[
												4.534,
												1.231
											],
											[
												0,
												-2.674
											],
											[
												-4.534,
												1.231
											],
											[
												-4.182,
												2.674
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.078,
										0.694,
										0.894
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.437,
										22.893
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 38",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.887,
												0
											],
											[
												-0.703,
												-0.629
											],
											[
												0,
												0.518
											],
											[
												2.517,
												0
											],
											[
												0,
												-2.073
											],
											[
												-0.222,
												-0.444
											]
										],
										o: [
											[
												1.887,
												0
											],
											[
												0.241,
												-0.444
											],
											[
												0,
												-2.073
											],
											[
												-2.516,
												0
											],
											[
												0,
												0.518
											],
											[
												0.685,
												-0.647
											]
										],
										v: [
											[
												-0.018,
												1.619
											],
											[
												4.182,
												2.692
											],
											[
												4.552,
												1.231
											],
											[
												0,
												-2.692
											],
											[
												-4.552,
												1.231
											],
											[
												-4.2,
												2.692
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.004,
										0.686,
										0.89
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.455,
										22.895
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 39",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.888,
												0
											],
											[
												-0.685,
												-0.629
											],
											[
												0,
												0.537
											],
											[
												2.516,
												0
											],
											[
												0,
												-2.091
											],
											[
												-0.242,
												-0.462
											]
										],
										o: [
											[
												1.888,
												0
											],
											[
												0.239,
												-0.462
											],
											[
												0,
												-2.091
											],
											[
												-2.516,
												0
											],
											[
												0,
												0.518
											],
											[
												0.702,
												-0.629
											]
										],
										v: [
											[
												0,
												1.647
											],
											[
												4.201,
												2.72
											],
											[
												4.57,
												1.24
											],
											[
												0,
												-2.72
											],
											[
												-4.57,
												1.24
											],
											[
												-4.2,
												2.72
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.678,
										0.886
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.437,
										22.847
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 40",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.887,
												0
											],
											[
												-0.702,
												-0.647
											],
											[
												0,
												0.535
											],
											[
												2.517,
												0
											],
											[
												0,
												-2.129
											],
											[
												-0.239,
												-0.463
											]
										],
										o: [
											[
												1.888,
												0
											],
											[
												0.242,
												-0.463
											],
											[
												0,
												-2.11
											],
											[
												-2.517,
												0
											],
											[
												0,
												0.535
											],
											[
												0.666,
												-0.647
											]
										],
										v: [
											[
												-0.019,
												1.657
											],
											[
												4.2,
												2.748
											],
											[
												4.571,
												1.25
											],
											[
												0,
												-2.748
											],
											[
												-4.571,
												1.25
											],
											[
												-4.201,
												2.748
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.671,
										0.882
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.46,
										22.839
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 41",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.888,
												0
											],
											[
												-0.685,
												-0.628
											],
											[
												0,
												0.537
											],
											[
												2.535,
												0
											],
											[
												0,
												-2.128
											],
											[
												-0.241,
												-0.462
											]
										],
										o: [
											[
												1.906,
												0
											],
											[
												0.24,
												-0.462
											],
											[
												0,
												-2.128
											],
											[
												-2.536,
												0
											],
											[
												0,
												0.537
											],
											[
												0.703,
												-0.647
											]
										],
										v: [
											[
												0,
												1.666
											],
											[
												4.219,
												2.757
											],
											[
												4.589,
												1.259
											],
											[
												0,
												-2.757
											],
											[
												-4.589,
												1.259
											],
											[
												-4.219,
												2.757
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.663,
										0.878
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.436,
										22.829
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 42",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.905,
												0
											],
											[
												-0.703,
												-0.648
											],
											[
												0,
												0.537
											],
											[
												2.554,
												0
											],
											[
												0,
												-2.146
											],
											[
												-0.241,
												-0.463
											]
										],
										o: [
											[
												1.906,
												0
											],
											[
												0.241,
												-0.463
											],
											[
												0,
												-2.165
											],
											[
												-2.536,
												0
											],
											[
												0,
												0.537
											],
											[
												0.703,
												-0.667
											]
										],
										v: [
											[
												0,
												1.674
											],
											[
												4.238,
												2.785
											],
											[
												4.608,
												1.267
											],
											[
												0,
												-2.785
											],
											[
												-4.608,
												1.267
											],
											[
												-4.237,
												2.785
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.651,
										0.875
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.437,
										22.82
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 43",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.906,
												0
											],
											[
												-0.704,
												-0.667
											],
											[
												0,
												0.537
											],
											[
												2.534,
												0
											],
											[
												0,
												-2.183
											],
											[
												-0.241,
												-0.463
											]
										],
										o: [
											[
												1.907,
												0
											],
											[
												0.24,
												-0.482
											],
											[
												0,
												-2.183
											],
											[
												-2.555,
												0
											],
											[
												0,
												0.537
											],
											[
												0.684,
												-0.667
											]
										],
										v: [
											[
												-0.019,
												1.684
											],
											[
												4.237,
												2.813
											],
											[
												4.608,
												1.276
											],
											[
												0,
												-2.812
											],
											[
												-4.608,
												1.276
											],
											[
												-4.238,
												2.813
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.643,
										0.871
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.455,
										22.79
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 44",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.906,
												0
											],
											[
												-0.703,
												-0.666
											],
											[
												0,
												0.555
											],
											[
												2.554,
												0
											],
											[
												0,
												-2.203
											],
											[
												-0.241,
												-0.481
											]
										],
										o: [
											[
												1.906,
												0
											],
											[
												0.24,
												-0.481
											],
											[
												0,
												-2.203
											],
											[
												-2.554,
												0
											],
											[
												0,
												0.555
											],
											[
												0.703,
												-0.666
											]
										],
										v: [
											[
												0,
												1.712
											],
											[
												4.256,
												2.84
											],
											[
												4.626,
												1.286
											],
											[
												0,
												-2.84
											],
											[
												-4.626,
												1.286
											],
											[
												-4.256,
												2.84
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.635,
										0.867
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.436,
										22.766
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 45",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.924,
												0
											],
											[
												-0.702,
												-0.666
											],
											[
												0,
												0.555
											],
											[
												2.573,
												0
											],
											[
												0,
												-2.221
											],
											[
												-0.241,
												-0.481
											]
										],
										o: [
											[
												1.925,
												0
											],
											[
												0.24,
												-0.481
											],
											[
												0,
												-2.221
											],
											[
												-2.553,
												0
											],
											[
												0,
												0.555
											],
											[
												0.703,
												-0.685
											]
										],
										v: [
											[
												-1e-3,
												1.711
											],
											[
												4.274,
												2.859
											],
											[
												4.645,
												1.286
											],
											[
												-1e-3,
												-2.859
											],
											[
												-4.645,
												1.286
											],
											[
												-4.275,
												2.859
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.628,
										0.863
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.455,
										22.761
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 46",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.943,
												0
											],
											[
												-0.722,
												-0.666
											],
											[
												0,
												0.556
											],
											[
												2.554,
												0
											],
											[
												0,
												-2.239
											],
											[
												-0.241,
												-0.481
											]
										],
										o: [
											[
												1.923,
												0
											],
											[
												0.24,
												-0.481
											],
											[
												0,
												-2.239
											],
											[
												-2.572,
												0
											],
											[
												0,
												0.556
											],
											[
												0.666,
												-0.666
											]
										],
										v: [
											[
												-0.018,
												1.729
											],
											[
												4.275,
												2.877
											],
											[
												4.644,
												1.304
											],
											[
												0,
												-2.877
											],
											[
												-4.644,
												1.304
											],
											[
												-4.274,
												2.877
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.62,
										0.859
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.474,
										22.725
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 47",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.943,
												0
											],
											[
												-0.703,
												-0.684
											],
											[
												0,
												0.555
											],
											[
												2.572,
												0
											],
											[
												0,
												-2.276
											],
											[
												-0.24,
												-0.481
											]
										],
										o: [
											[
												1.925,
												0
											],
											[
												0.241,
												-0.499
											],
											[
												0,
												-2.258
											],
											[
												-2.572,
												0
											],
											[
												0,
												0.573
											],
											[
												0.703,
												-0.684
											]
										],
										v: [
											[
												0,
												1.739
											],
											[
												4.293,
												2.905
											],
											[
												4.663,
												1.314
											],
											[
												0,
												-2.905
											],
											[
												-4.663,
												1.314
											],
											[
												-4.293,
												2.905
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.612,
										0.855
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.454,
										22.717
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 48",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.943,
												0
											],
											[
												-0.722,
												-0.704
											],
											[
												0,
												0.574
											],
											[
												2.591,
												0
											],
											[
												0,
												-2.276
											],
											[
												-0.241,
												-0.501
											]
										],
										o: [
											[
												1.943,
												0
											],
											[
												0.24,
												-0.501
											],
											[
												0,
												-2.276
											],
											[
												-2.572,
												0
											],
											[
												0,
												0.574
											],
											[
												0.703,
												-0.704
											]
										],
										v: [
											[
												-1e-3,
												1.739
											],
											[
												4.311,
												2.924
											],
											[
												4.682,
												1.313
											],
											[
												-1e-3,
												-2.924
											],
											[
												-4.682,
												1.313
											],
											[
												-4.312,
												2.924
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.604,
										0.851
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.454,
										22.715
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 49",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.943,
												0
											],
											[
												-0.703,
												-0.685
											],
											[
												0,
												0.573
											],
											[
												2.573,
												0
											],
											[
												0,
												-2.295
											],
											[
												-0.241,
												-0.499
											]
										],
										o: [
											[
												1.943,
												0
											],
											[
												0.24,
												-0.499
											],
											[
												0,
												-2.313
											],
											[
												-2.589,
												0
											],
											[
												0,
												0.573
											],
											[
												0.703,
												-0.703
											]
										],
										v: [
											[
												-1e-3,
												1.767
											],
											[
												4.311,
												2.951
											],
											[
												4.682,
												1.323
											],
											[
												-1e-3,
												-2.951
											],
											[
												-4.682,
												1.323
											],
											[
												-4.312,
												2.951
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.596,
										0.847
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.454,
										22.687
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 50",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.961,
												0
											],
											[
												-0.722,
												-0.704
											],
											[
												0,
												0.592
											],
											[
												2.591,
												0
											],
											[
												0,
												-2.332
											],
											[
												-0.24,
												-0.518
											]
										],
										o: [
											[
												1.943,
												0
											],
											[
												0.241,
												-0.5
											],
											[
												0,
												-2.332
											],
											[
												-2.59,
												0
											],
											[
												0,
												0.592
											],
											[
												0.703,
												-0.704
											]
										],
										v: [
											[
												0,
												1.776
											],
											[
												4.33,
												2.979
											],
											[
												4.7,
												1.332
											],
											[
												0,
												-2.979
											],
											[
												-4.7,
												1.332
											],
											[
												-4.33,
												2.979
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.588,
										0.843
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.453,
										22.663
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 51",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.961,
												0
											],
											[
												-0.722,
												-0.704
											],
											[
												0,
												0.573
											],
											[
												2.608,
												0
											],
											[
												0,
												-2.35
											],
											[
												-0.241,
												-0.5
											]
										],
										o: [
											[
												1.942,
												0
											],
											[
												0.24,
												-0.519
											],
											[
												0,
												-2.35
											],
											[
												-2.609,
												0
											],
											[
												0,
												0.592
											],
											[
												0.721,
												-0.704
											]
										],
										v: [
											[
												0,
												1.795
											],
											[
												4.349,
												2.998
											],
											[
												4.718,
												1.351
											],
											[
												0,
												-2.998
											],
											[
												-4.718,
												1.351
											],
											[
												-4.348,
												2.998
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.58,
										0.839
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.457,
										22.644
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 52",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.961,
												0
											],
											[
												-0.722,
												-0.721
											],
											[
												0,
												0.592
											],
											[
												2.627,
												0
											],
											[
												0,
												-2.369
											],
											[
												-0.242,
												-0.499
											]
										],
										o: [
											[
												1.961,
												0
											],
											[
												0.241,
												-0.518
											],
											[
												0,
												-2.369
											],
											[
												-2.609,
												0
											],
											[
												0,
												0.592
											],
											[
												0.722,
												-0.721
											]
										],
										v: [
											[
												0.009,
												1.795
											],
											[
												4.358,
												3.016
											],
											[
												4.728,
												1.351
											],
											[
												-9e-3,
												-3.016
											],
											[
												-4.728,
												1.351
											],
											[
												-4.357,
												3.016
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.573,
										0.835
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.447,
										22.641
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 53",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.962,
												0
											],
											[
												-0.722,
												-0.722
											],
											[
												0,
												0.592
											],
											[
												2.609,
												0
											],
											[
												0,
												-2.387
											],
											[
												-0.241,
												-0.518
											]
										],
										o: [
											[
												1.961,
												0
											],
											[
												0.24,
												-0.518
											],
											[
												0,
												-2.387
											],
											[
												-2.609,
												0
											],
											[
												0,
												0.592
											],
											[
												0.722,
												-0.722
											]
										],
										v: [
											[
												0,
												1.804
											],
											[
												4.367,
												3.044
											],
											[
												4.737,
												1.36
											],
											[
												0,
												-3.044
											],
											[
												-4.737,
												1.36
											],
											[
												-4.367,
												3.044
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.565,
										0.831
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.456,
										22.612
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 54",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.981,
												0
											],
											[
												-0.722,
												-0.721
											],
											[
												0,
												0.61
											],
											[
												2.628,
												0
											],
											[
												0,
												-2.424
											],
											[
												-0.24,
												-0.519
											]
										],
										o: [
											[
												1.962,
												0
											],
											[
												0.24,
												-0.519
											],
											[
												0,
												-2.406
											],
											[
												-2.627,
												0
											],
											[
												0,
												0.61
											],
											[
												0.722,
												-0.721
											]
										],
										v: [
											[
												0,
												1.833
											],
											[
												4.386,
												3.072
											],
											[
												4.755,
												1.37
											],
											[
												0,
												-3.072
											],
											[
												-4.755,
												1.37
											],
											[
												-4.386,
												3.072
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.557,
										0.828
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.456,
										22.587
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 55",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.98,
												0
											],
											[
												-0.722,
												-0.74
											],
											[
												0,
												0.61
											],
											[
												2.646,
												0
											],
											[
												0,
												-2.424
											],
											[
												-0.24,
												-0.536
											]
										],
										o: [
											[
												1.98,
												0
											],
											[
												0.24,
												-0.518
											],
											[
												0,
												-2.424
											],
											[
												-2.628,
												0
											],
											[
												0,
												0.61
											],
											[
												0.74,
												-0.74
											]
										],
										v: [
											[
												0.009,
												1.832
											],
											[
												4.395,
												3.09
											],
											[
												4.765,
												1.37
											],
											[
												-9e-3,
												-3.09
											],
											[
												-4.765,
												1.37
											],
											[
												-4.395,
												3.09
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.549,
										0.824
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.446,
										22.587
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 56",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.98,
												0
											],
											[
												-0.722,
												-0.74
											],
											[
												0,
												0.629
											],
											[
												2.628,
												0
											],
											[
												0,
												-2.443
											],
											[
												-0.24,
												-0.536
											]
										],
										o: [
											[
												1.98,
												0
											],
											[
												0.241,
												-0.536
											],
											[
												0,
												-2.461
											],
											[
												-2.628,
												0
											],
											[
												0,
												0.61
											],
											[
												0.722,
												-0.74
											]
										],
										v: [
											[
												0,
												1.86
											],
											[
												4.404,
												3.118
											],
											[
												4.774,
												1.379
											],
											[
												0,
												-3.118
											],
											[
												-4.774,
												1.379
											],
											[
												-4.404,
												3.118
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.545,
										0.82
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.455,
										22.558
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 57",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.98,
												0
											],
											[
												-0.722,
												-0.74
											],
											[
												0,
												0.611
											],
											[
												2.645,
												0
											],
											[
												0,
												-2.48
											],
											[
												-0.241,
												-0.536
											]
										],
										o: [
											[
												1.979,
												0
											],
											[
												0.24,
												-0.536
											],
											[
												0,
												-2.48
											],
											[
												-2.647,
												0
											],
											[
												0,
												0.629
											],
											[
												0.74,
												-0.74
											]
										],
										v: [
											[
												0.001,
												1.86
											],
											[
												4.405,
												3.136
											],
											[
												4.792,
												1.397
											],
											[
												0.001,
												-3.136
											],
											[
												-4.792,
												1.397
											],
											[
												-4.422,
												3.136
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.537,
										0.816
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.455,
										22.541
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 58",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.999,
												0
											],
											[
												-0.722,
												-0.758
											],
											[
												0,
												0.629
											],
											[
												2.664,
												0
											],
											[
												0,
												-2.498
											],
											[
												-0.26,
												-0.536
											]
										],
										o: [
											[
												1.979,
												0
											],
											[
												0.241,
												-0.536
											],
											[
												0,
												-2.498
											],
											[
												-2.647,
												0
											],
											[
												0,
												0.629
											],
											[
												0.703,
												-0.758
											]
										],
										v: [
											[
												-9e-3,
												1.869
											],
											[
												4.413,
												3.164
											],
											[
												4.802,
												1.406
											],
											[
												-9e-3,
												-3.164
											],
											[
												-4.802,
												1.406
											],
											[
												-4.413,
												3.164
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.529,
										0.812
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.464,
										22.531
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 59",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.999,
												0
											],
											[
												-0.741,
												-0.759
											],
											[
												0,
												0.63
											],
											[
												2.646,
												0
											],
											[
												0,
												-2.516
											],
											[
												-0.26,
												-0.555
											]
										],
										o: [
											[
												1.998,
												0
											],
											[
												0.24,
												-0.555
											],
											[
												0,
												-2.516
											],
											[
												-2.665,
												0
											],
											[
												0,
												0.63
											],
											[
												0.703,
												-0.759
											]
										],
										v: [
											[
												-0.018,
												1.888
											],
											[
												4.423,
												3.183
											],
											[
												4.811,
												1.406
											],
											[
												0,
												-3.183
											],
											[
												-4.811,
												1.406
											],
											[
												-4.422,
												3.183
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.522,
										0.808
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.473,
										22.514
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 60",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.999,
												0
											],
											[
												-0.722,
												-0.776
											],
											[
												0,
												0.649
											],
											[
												2.664,
												0
											],
											[
												0,
												-2.535
											],
											[
												-0.259,
												-0.554
											]
										],
										o: [
											[
												1.998,
												0
											],
											[
												0.241,
												-0.554
											],
											[
												0,
												-2.535
											],
											[
												-2.665,
												0
											],
											[
												0,
												0.629
											],
											[
												0.721,
												-0.776
											]
										],
										v: [
											[
												0.001,
												1.896
											],
											[
												4.441,
												3.21
											],
											[
												4.829,
												1.415
											],
											[
												0.001,
												-3.21
											],
											[
												-4.829,
												1.415
											],
											[
												-4.44,
												3.21
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.514,
										0.8
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.454,
										22.503
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 61",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.999,
												0
											],
											[
												-0.74,
												-0.758
											],
											[
												0,
												0.648
											],
											[
												2.683,
												0
											],
											[
												0,
												-2.572
											],
											[
												-0.259,
												-0.555
											]
										],
										o: [
											[
												1.998,
												0
											],
											[
												0.241,
												-0.555
											],
											[
												0,
												-2.554
											],
											[
												-2.665,
												0
											],
											[
												0,
												0.648
											],
											[
												0.721,
												-0.758
											]
										],
										v: [
											[
												-9e-3,
												1.925
											],
											[
												4.45,
												3.238
											],
											[
												4.839,
												1.425
											],
											[
												-9e-3,
												-3.238
											],
											[
												-4.839,
												1.425
											],
											[
												-4.45,
												3.238
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.51,
										0.796
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.463,
										22.458
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 62",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.999,
												0
											],
											[
												-0.74,
												-0.777
											],
											[
												0,
												0.647
											],
											[
												2.665,
												0
											],
											[
												0,
												-2.573
											],
											[
												-0.259,
												-0.555
											]
										],
										o: [
											[
												2.017,
												0
											],
											[
												0.24,
												-0.555
											],
											[
												0,
												-2.573
											],
											[
												-2.683,
												0
											],
											[
												0,
												0.647
											],
											[
												0.703,
												-0.777
											]
										],
										v: [
											[
												-0.018,
												1.915
											],
											[
												4.46,
												3.247
											],
											[
												4.848,
												1.434
											],
											[
												0,
												-3.247
											],
											[
												-4.848,
												1.434
											],
											[
												-4.459,
												3.247
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.502,
										0.792
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.472,
										22.467
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 63",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-2.016,
												0
											],
											[
												-0.739,
												-0.795
											],
											[
												0,
												0.647
											],
											[
												2.683,
												0
											],
											[
												0,
												-2.591
											],
											[
												-0.259,
												-0.555
											]
										],
										o: [
											[
												2.017,
												0
											],
											[
												0.241,
												-0.555
											],
											[
												0,
												-2.61
											],
											[
												-2.682,
												0
											],
											[
												0,
												0.647
											],
											[
												0.74,
												-0.795
											]
										],
										v: [
											[
												0,
												1.925
											],
											[
												4.478,
												3.275
											],
											[
												4.866,
												1.444
											],
											[
												0,
												-3.275
											],
											[
												-4.866,
												1.444
											],
											[
												-4.477,
												3.275
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.494,
										0.788
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.454,
										22.457
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 64",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-2.017,
												0
											],
											[
												-0.74,
												-0.795
											],
											[
												0,
												0.648
											],
											[
												2.702,
												0
											],
											[
												0,
												-2.628
											],
											[
												-0.259,
												-0.573
											]
										],
										o: [
											[
												2.017,
												0
											],
											[
												0.24,
												-0.573
											],
											[
												0,
												-2.628
											],
											[
												-2.683,
												0
											],
											[
												0,
												0.666
											],
											[
												0.74,
												-0.777
											]
										],
										v: [
											[
												0,
												1.952
											],
											[
												4.497,
												3.303
											],
											[
												4.885,
												1.453
											],
											[
												0,
												-3.303
											],
											[
												-4.885,
												1.453
											],
											[
												-4.496,
												3.303
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.49,
										0.784
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.453,
										22.409
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 65",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-2.017,
												0
											],
											[
												-0.74,
												-0.814
											],
											[
												0,
												0.666
											],
											[
												2.702,
												0
											],
											[
												0,
												-2.646
											],
											[
												-0.259,
												-0.574
											]
										],
										o: [
											[
												2.017,
												0
											],
											[
												0.259,
												-0.574
											],
											[
												0,
												-2.646
											],
											[
												-2.701,
												0
											],
											[
												0,
												0.666
											],
											[
												0.74,
												-0.796
											]
										],
										v: [
											[
												0,
												1.962
											],
											[
												4.497,
												3.331
											],
											[
												4.885,
												1.462
											],
											[
												0,
												-3.331
											],
											[
												-4.885,
												1.462
											],
											[
												-4.496,
												3.331
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.482,
										0.78
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.453,
										22.399
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 66",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-2.536,
												0
											],
											[
												0,
												2.552
											],
											[
												2.535,
												0
											],
											[
												0,
												-2.536
											]
										],
										o: [
											[
												2.535,
												0
											],
											[
												0,
												-2.536
											],
											[
												-2.536,
												0
											],
											[
												0,
												2.534
											]
										],
										v: [
											[
												0.001,
												4.607
											],
											[
												4.607,
												0.001
											],
											[
												0.001,
												-4.607
											],
											[
												-4.607,
												0.001
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.482,
										0.78
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.425,
										22.132
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 67",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												-2.664
											],
											[
												2.664,
												0
											],
											[
												0,
												2.684
											],
											[
												-2.684,
												0
											]
										],
										o: [
											[
												0,
												2.665
											],
											[
												-2.684,
												0
											],
											[
												0,
												-2.664
											],
											[
												2.646,
												0
											]
										],
										v: [
											[
												4.839,
												-0.01
											],
											[
												0.01,
												4.839
											],
											[
												-4.839,
												-0.01
											],
											[
												0.01,
												-4.839
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										1,
										1,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.439,
										22.145
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 68",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-2.555,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-2.555
											],
											[
												0,
												0
											],
											[
												2.555,
												0
											],
											[
												0,
												0
											],
											[
												0,
												2.555
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												2.555,
												0
											],
											[
												0,
												0
											],
											[
												0,
												2.555
											],
											[
												0,
												0
											],
											[
												-2.555,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-2.555
											]
										],
										v: [
											[
												-4.142,
												-8.768
											],
											[
												4.142,
												-8.768
											],
											[
												8.768,
												-4.142
											],
											[
												8.768,
												4.142
											],
											[
												4.142,
												8.768
											],
											[
												-4.142,
												8.768
											],
											[
												-8.768,
												4.142
											],
											[
												-8.768,
												-4.142
											]
										]
									}
								}
							},
							{
								ty: "st",
								nm: "선 1",
								lc: 1,
								lj: 1,
								ml: 4,
								o: {
									a: 0,
									k: 100
								},
								w: {
									a: 0,
									k: 0.464
								},
								c: {
									a: 0,
									k: [
										0.933,
										0.933,
										0.933
									]
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.816,
										0.914,
										0.988
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.4,
										21.9
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 69",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-3.588,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-3.588
											],
											[
												0,
												0
											],
											[
												3.588,
												0
											],
											[
												0,
												0
											],
											[
												0,
												3.588
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												3.588,
												0
											],
											[
												0,
												0
											],
											[
												0,
												3.588
											],
											[
												0,
												0
											],
											[
												-3.588,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-3.588
											]
										],
										v: [
											[
												-67.103,
												-21.1
											],
											[
												67.104,
												-21.1
											],
											[
												73.6,
												-14.603
											],
											[
												73.6,
												14.603
											],
											[
												67.104,
												21.1
											],
											[
												-67.103,
												21.1
											],
											[
												-73.6,
												14.603
											],
											[
												-73.6,
												-14.603
											]
										]
									}
								}
							},
							{
								ty: "st",
								nm: "선 1",
								lc: 1,
								lj: 1,
								ml: 4,
								o: {
									a: 0,
									k: 100
								},
								w: {
									a: 0,
									k: 0.8
								},
								c: {
									a: 0,
									k: [
										0.926,
										0.926,
										0.926
									]
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										1,
										1,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										74.4,
										21.9
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 9
			},
			{
				ty: 4,
				nm: "하나 윤곽선",
				sr: 1,
				st: -6,
				op: 169,
				ip: 8,
				ln: "783",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							74.4,
							21.9
						]
					},
					s: {
						a: 1,
						k: [
							{
								s: [
									150,
									150,
									107.143
								],
								i: {
									x: [
										0.234,
										0.234,
										0.667
									],
									y: [
										0.995,
										0.995,
										1
									]
								},
								o: {
									x: [
										0.333,
										0.333,
										0.333
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 9
							},
							{
								s: [
									100,
									100,
									100
								],
								i: {
									x: [
										0.833,
										0.833,
										0.833
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.167,
										0.167,
										0.167
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 17
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									181.499,
									230
								],
								t: 17
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									181.499,
									180
								],
								t: 28
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									181.499,
									180
								],
								t: 38
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									181.499,
									140.5
								],
								t: 47.999
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									181.499,
									140.5
								],
								t: 57.999
							},
							{
								s: [
									181.499,
									113.939
								],
								t: 66.999
							}
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									100
								],
								t: 99.999
							},
							{
								s: [
									0
								],
								t: 103.999
							}
						]
					}
				},
				ef: [
					{
						ty: 25,
						nm: "그림자 효과",
						en: 1,
						ef: [
							{
								ty: 2,
								nm: "그림자 색상",
								v: {
									a: 0,
									k: [
										0,
										0,
										0
									]
								}
							},
							{
								ty: 0,
								nm: "불투명도",
								v: {
									a: 1,
									k: [
										{
											o: {
												x: 0.167,
												y: 0.167
											},
											i: {
												x: 0.833,
												y: 0.833
											},
											s: [
												35
											],
											t: 9
										},
										{
											s: [
												0
											],
											t: 17
										}
									]
								}
							},
							{
								ty: 1,
								nm: "방향",
								v: {
									a: 0,
									k: 135
								}
							},
							{
								ty: 0,
								nm: "거리",
								v: {
									a: 0,
									k: 5
								}
							},
							{
								ty: 0,
								nm: "부드러움",
								v: {
									a: 0,
									k: 18
								}
							},
							{
								ty: 7,
								nm: "그림자만",
								v: {
									a: 0,
									k: 0
								}
							}
						]
					}
				],
				shapes: [
					{
						ty: "gr",
						nm: "그룹 1",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0.213,
												0
											],
											[
												0.2,
												-0.114
											],
											[
												0,
												-0.234
											],
											[
												-0.194,
												-0.12
											],
											[
												-0.307,
												0
											],
											[
												-0.186,
												0.113
											],
											[
												0,
												0.22
											],
											[
												0.086,
												0.1
											],
											[
												0.153,
												0.053
											]
										],
										o: [
											[
												-0.307,
												0
											],
											[
												-0.194,
												0.113
											],
											[
												0,
												0.22
											],
											[
												0.2,
												0.113
											],
											[
												0.314,
												0
											],
											[
												0.193,
												-0.12
											],
											[
												0,
												-0.154
											],
											[
												-0.088,
												-0.1
											],
											[
												-0.153,
												-0.054
											]
										],
										v: [
											[
												12.718,
												-3.71
											],
											[
												11.959,
												-3.54
											],
											[
												11.668,
												-3.02
											],
											[
												11.959,
												-2.51
											],
											[
												12.718,
												-2.34
											],
											[
												13.468,
												-2.51
											],
											[
												13.758,
												-3.02
											],
											[
												13.629,
												-3.4
											],
											[
												13.269,
												-3.63
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 2",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-0.453,
												0
											],
											[
												-0.347,
												-0.14
											],
											[
												-0.193,
												-0.247
											],
											[
												0,
												-0.334
											],
											[
												0.201,
												-0.254
											],
											[
												0.347,
												-0.134
											],
											[
												0.454,
												0
											],
											[
												0.354,
												0.133
											],
											[
												0.194,
												0.246
											],
											[
												0,
												0.326
											],
											[
												-0.192,
												0.246
											],
											[
												-0.347,
												0.14
											]
										],
										o: [
											[
												0.454,
												0
											],
											[
												0.347,
												0.14
											],
											[
												0.201,
												0.246
											],
											[
												0,
												0.326
											],
											[
												-0.193,
												0.246
											],
											[
												-0.347,
												0.133
											],
											[
												-0.453,
												0
											],
											[
												-0.347,
												-0.134
											],
											[
												-0.192,
												-0.254
											],
											[
												0,
												-0.334
											],
											[
												0.194,
												-0.247
											],
											[
												0.354,
												-0.14
											]
										],
										v: [
											[
												12.718,
												-4.68
											],
											[
												13.918,
												-4.47
											],
											[
												14.728,
												-3.89
											],
											[
												15.028,
												-3.02
											],
											[
												14.728,
												-2.15
											],
											[
												13.918,
												-1.58
											],
											[
												12.718,
												-1.38
											],
											[
												11.508,
												-1.58
											],
											[
												10.698,
												-2.15
											],
											[
												10.409,
												-3.02
											],
											[
												10.698,
												-3.89
											],
											[
												11.508,
												-4.47
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 3",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												14.498,
												0.38
											],
											[
												16.539,
												0.38
											],
											[
												16.539,
												1.29
											],
											[
												14.498,
												1.29
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 4",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0.552,
												-7e-3
											],
											[
												0,
												0
											],
											[
												-0.666,
												0.006
											],
											[
												-0.694,
												0.04
											],
											[
												-0.64,
												0.08
											],
											[
												0,
												0
											],
											[
												0.688,
												-0.06
											],
											[
												0.646,
												-0.014
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0.567,
												-7e-3
											],
											[
												0.668,
												-0.014
											],
											[
												0.692,
												-0.04
											],
											[
												0,
												0
											],
											[
												-0.66,
												0.113
											],
											[
												-0.679,
												0.053
											],
											[
												-0.647,
												0.013
											]
										],
										v: [
											[
												9.909,
												0.16
											],
											[
												9.739,
												-0.9
											],
											[
												11.588,
												-0.92
											],
											[
												13.629,
												-1
											],
											[
												15.629,
												-1.18
											],
											[
												15.718,
												-0.23
											],
											[
												13.698,
												0.03
											],
											[
												11.709,
												0.13
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 5",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.898,
												1.35
											],
											[
												12.228,
												1.35
											],
											[
												12.228,
												3.33
											],
											[
												10.898,
												3.33
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 6",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												10.898,
												3.04
											],
											[
												17.778,
												3.04
											],
											[
												17.778,
												4.11
											],
											[
												10.898,
												4.11
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 7",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												16.239,
												-5
											],
											[
												17.569,
												-5
											],
											[
												17.569,
												2.02
											],
											[
												16.239,
												2.02
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 8",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												12.188,
												-0.24
											],
											[
												13.519,
												-0.24
											],
											[
												13.519,
												1.78
											],
											[
												12.188,
												1.78
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 9",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.06,
												0
											],
											[
												0,
												1.41
											],
											[
												1.041,
												0
											],
											[
												0,
												-1.39
											]
										],
										o: [
											[
												1.05,
												0
											],
											[
												0,
												-1.39
											],
											[
												-1.05,
												0
											],
											[
												0,
												1.41
											]
										],
										v: [
											[
												6.028,
												2.14
											],
											[
												7.468,
												-0.39
											],
											[
												6.028,
												-2.88
											],
											[
												4.588,
												-0.39
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 10",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												-2.08
											],
											[
												1.95,
												0
											],
											[
												0,
												2.09
											],
											[
												-1.94,
												0
											]
										],
										o: [
											[
												0,
												2.09
											],
											[
												-1.95,
												0
											],
											[
												0,
												-2.08
											],
											[
												1.94,
												0
											]
										],
										v: [
											[
												8.998,
												-0.39
											],
											[
												6.028,
												3.48
											],
											[
												3.069,
												-0.39
											],
											[
												6.028,
												-4.22
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 11",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-1.06,
												0
											],
											[
												0,
												1.41
											],
											[
												1.041,
												0
											],
											[
												0,
												-1.39
											]
										],
										o: [
											[
												1.05,
												0
											],
											[
												0,
												-1.39
											],
											[
												-1.05,
												0
											],
											[
												0,
												1.41
											]
										],
										v: [
											[
												-0.651,
												2.14
											],
											[
												0.789,
												-0.39
											],
											[
												-0.651,
												-2.88
											],
											[
												-2.091,
												-0.39
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 12",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												-2.08
											],
											[
												1.95,
												0
											],
											[
												0,
												2.09
											],
											[
												-1.94,
												0
											]
										],
										o: [
											[
												0,
												2.09
											],
											[
												-1.95,
												0
											],
											[
												0,
												-2.08
											],
											[
												1.94,
												0
											]
										],
										v: [
											[
												2.319,
												-0.39
											],
											[
												-0.651,
												3.48
											],
											[
												-3.61,
												-0.39
											],
											[
												-0.651,
												-4.22
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 13",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												-0.79
											],
											[
												1.52,
												0
											],
											[
												0.639,
												0.36
											],
											[
												0,
												0
											],
											[
												-0.759,
												0
											],
											[
												0,
												0.7
											],
											[
												0.7,
												0
											],
											[
												0.311,
												-0.05
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.58
											],
											[
												0.54,
												0
											],
											[
												0.53,
												-0.48
											],
											[
												0,
												0
											],
											[
												-0.78,
												0
											],
											[
												0,
												-1.26
											],
											[
												0.61,
												-0.4
											]
										],
										o: [
											[
												0,
												1.53
											],
											[
												-0.739,
												0
											],
											[
												0,
												0
											],
											[
												0.609,
												0.44
											],
											[
												0.72,
												0
											],
											[
												0,
												-0.73
											],
											[
												-0.31,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.599,
												-0.11
											],
											[
												0,
												-0.54
											],
											[
												-0.73,
												0
											],
											[
												0,
												0
											],
											[
												0.619,
												-0.48
											],
											[
												1.25,
												0
											],
											[
												0,
												0.63
											],
											[
												0.811,
												0.39
											]
										],
										v: [
											[
												-4.298,
												1.18
											],
											[
												-7.188,
												3.48
											],
											[
												-9.267,
												2.91
											],
											[
												-9.267,
												1.49
											],
											[
												-7.168,
												2.21
											],
											[
												-5.838,
												1.16
											],
											[
												-7.168,
												0.12
											],
											[
												-8.078,
												0.2
											],
											[
												-8.078,
												-0.95
											],
											[
												-7.177,
												-1.1
											],
											[
												-6.138,
												-2.09
											],
											[
												-7.128,
												-2.93
											],
											[
												-9.037,
												-2.15
											],
											[
												-9.037,
												-3.51
											],
											[
												-6.897,
												-4.22
											],
											[
												-4.638,
												-2.2
											],
											[
												-5.548,
												-0.64
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 14",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.37
											],
											[
												-0.51,
												0
											],
											[
												0,
												-0.51
											],
											[
												0.151,
												-0.25
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.399,
												-0.16
											],
											[
												0,
												-0.53
											],
											[
												0.561,
												0
											],
											[
												0,
												0.27
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-11.063,
												5
											],
											[
												-11.983,
												5
											],
											[
												-11.174,
												3.47
											],
											[
												-11.754,
												2.64
											],
											[
												-10.854,
												1.78
											],
											[
												-9.944,
												2.67
											],
											[
												-10.194,
												3.48
											]
										]
									}
								}
							},
							{
								ty: "sh",
								nm: "패스 15",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.62
											],
											[
												0.67,
												0
											],
											[
												0.53,
												-0.5
											],
											[
												0,
												0
											],
											[
												-0.78,
												0
											],
											[
												0,
												-1.35
											],
											[
												0.7,
												-0.93
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.48,
												-0.64
											],
											[
												0,
												-0.68
											],
											[
												-0.67,
												0
											],
											[
												0,
												0
											],
											[
												0.621,
												-0.44
											],
											[
												1.39,
												0
											],
											[
												0,
												0.91
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-12.418,
												2.1
											],
											[
												-12.418,
												3.38
											],
											[
												-17.778,
												3.38
											],
											[
												-15.168,
												-0.06
											],
											[
												-14.299,
												-1.78
											],
											[
												-15.509,
												-2.89
											],
											[
												-17.319,
												-2.02
											],
											[
												-17.319,
												-3.53
											],
											[
												-15.209,
												-4.22
											],
											[
												-12.759,
												-1.98
											],
											[
												-13.929,
												0.62
											],
											[
												-15.108,
												2.1
											]
										]
									}
								}
							},
							{
								ty: "mm",
								nm: "패스 병합 1",
								mm: 1
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.4,
										0.4,
										0.4
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										117.239,
										21.52
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 2",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												-0.177
											],
											[
												-0.464,
												0
											],
											[
												0,
												0.464
											],
											[
												0.022,
												0.067
											],
											[
												0,
												0.177
											],
											[
												0.177,
												0
											],
											[
												0.177,
												-0.089
											],
											[
												0.066,
												-0.133
											]
										],
										o: [
											[
												0,
												0.486
											],
											[
												0.486,
												0
											],
											[
												0,
												-0.066
											],
											[
												-0.067,
												-0.154
											],
											[
												0,
												-0.265
											],
											[
												-0.199,
												0
											],
											[
												-0.132,
												0.066
											],
											[
												-0.089,
												0.133
											]
										],
										v: [
											[
												-0.862,
												0.011
											],
											[
												0,
												0.873
											],
											[
												0.862,
												0.011
											],
											[
												0.818,
												-0.188
											],
											[
												0.663,
												-0.608
											],
											[
												0.177,
												-0.873
											],
											[
												-0.398,
												-0.762
											],
											[
												-0.729,
												-0.453
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										1,
										1,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.11,
										19.108
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 3",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0.109
											],
											[
												0.133,
												-0.023
											],
											[
												0.11,
												-0.044
											],
											[
												2.321,
												0.332
											],
											[
												0.398,
												0.066
											],
											[
												0.265,
												0.021
											],
											[
												0.177,
												-0.154
											],
											[
												-0.132,
												-0.244
											],
											[
												-0.287,
												-0.155
											],
											[
												-0.332,
												0.023
											],
											[
												-0.884,
												0.133
											],
											[
												-1.414,
												0.598
											],
											[
												-0.397,
												0.309
											]
										],
										o: [
											[
												0,
												-0.133
											],
											[
												-0.133,
												0
											],
											[
												-2.21,
												0.84
											],
											[
												-0.397,
												-0.066
											],
											[
												-0.243,
												-0.044
											],
											[
												-0.221,
												-0.022
											],
											[
												-0.221,
												0.199
											],
											[
												0.155,
												0.287
											],
											[
												0.288,
												0.154
											],
											[
												0.884,
												-0.066
											],
											[
												1.503,
												-0.199
											],
											[
												0.464,
												-0.198
											],
											[
												0.089,
												-0.044
											]
										],
										v: [
											[
												5.226,
												-1.005
											],
											[
												4.983,
												-1.204
											],
											[
												4.63,
												-1.094
											],
											[
												-2.398,
												-0.431
											],
											[
												-3.591,
												-0.63
											],
											[
												-4.342,
												-0.74
											],
											[
												-5.005,
												-0.608
											],
											[
												-5.094,
												0.21
											],
											[
												-4.387,
												0.895
											],
											[
												-3.458,
												1.204
											],
											[
												-0.807,
												0.939
											],
											[
												3.701,
												-0.034
											],
											[
												5.027,
												-0.762
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										1,
										1,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.341,
										20.876
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 4",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0.067,
												0.375
											],
											[
												0.045,
												0.133
											],
											[
												0.375,
												0.221
											],
											[
												0.596,
												-0.377
											],
											[
												0.133,
												-0.265
											],
											[
												0.022,
												-0.089
											],
											[
												-0.286,
												-0.441
											],
											[
												-0.155,
												-0.065
											],
											[
												-0.133,
												0.088
											],
											[
												0.044,
												0.199
											],
											[
												-0.111,
												0.267
											],
											[
												-0.065,
												0.066
											],
											[
												-0.043,
												0.023
											],
											[
												-0.11,
												-0.022
											],
											[
												-0.088,
												-0.176
											],
											[
												0,
												-0.2
											],
											[
												0.222,
												-0.816
											],
											[
												0.022,
												-0.067
											],
											[
												-0.045,
												-0.067
											],
											[
												-0.022,
												-0.022
											],
											[
												-0.088,
												0.088
											],
											[
												-0.222,
												0.685
											],
											[
												-0.043,
												0.264
											]
										],
										o: [
											[
												-0.022,
												-0.155
											],
											[
												-0.177,
												-0.397
											],
											[
												-0.597,
												-0.355
											],
											[
												-0.265,
												0.153
											],
											[
												-0.043,
												0.089
											],
											[
												-0.154,
												0.487
											],
											[
												0.089,
												0.155
											],
											[
												0.155,
												0.068
											],
											[
												0.177,
												-0.111
											],
											[
												-0.044,
												-0.266
											],
											[
												0.022,
												-0.087
											],
											[
												0.046,
												-0.044
											],
											[
												0.111,
												-0.044
											],
											[
												0.199,
												0.022
											],
											[
												0.089,
												0.177
											],
											[
												0.043,
												0.862
											],
											[
												-0.022,
												0.09
											],
											[
												-0.023,
												0.066
											],
											[
												0.022,
												0.022
											],
											[
												0.134,
												0.045
											],
											[
												0.509,
												-0.508
											],
											[
												0.088,
												-0.242
											],
											[
												0.089,
												-0.31
											]
										],
										v: [
											[
												1.822,
												-1.072
											],
											[
												1.712,
												-1.492
											],
											[
												0.895,
												-2.441
											],
											[
												-1.006,
												-2.419
											],
											[
												-1.625,
												-1.757
											],
											[
												-1.735,
												-1.47
											],
											[
												-1.603,
												0.121
											],
											[
												-1.227,
												0.452
											],
											[
												-0.741,
												0.409
											],
											[
												-0.564,
												-0.143
											],
											[
												-0.542,
												-0.918
											],
											[
												-0.41,
												-1.138
											],
											[
												-0.277,
												-1.227
											],
											[
												0.054,
												-1.271
											],
											[
												0.496,
												-0.918
											],
											[
												0.608,
												-0.342
											],
											[
												0.231,
												2.22
											],
											[
												0.166,
												2.464
											],
											[
												0.166,
												2.685
											],
											[
												0.231,
												2.751
											],
											[
												0.541,
												2.641
											],
											[
												1.58,
												0.806
											],
											[
												1.778,
												0.034
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										1,
										1,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.142,
										24.897
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 5",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-2.479,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-2.479
											],
											[
												0,
												0
											],
											[
												2.479,
												0
											],
											[
												0,
												0
											],
											[
												0,
												2.479
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												2.479,
												0
											],
											[
												0,
												0
											],
											[
												0,
												2.479
											],
											[
												0,
												0
											],
											[
												-2.479,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-2.479
											]
										],
										v: [
											[
												-4.287,
												-8.775
											],
											[
												4.287,
												-8.775
											],
											[
												8.775,
												-4.287
											],
											[
												8.775,
												4.287
											],
											[
												4.287,
												8.775
											],
											[
												-4.287,
												8.775
											],
											[
												-8.775,
												4.287
											],
											[
												-8.775,
												-4.287
											]
										]
									}
								}
							},
							{
								ty: "st",
								nm: "선 1",
								lc: 1,
								lj: 1,
								ml: 4,
								o: {
									a: 0,
									k: 100
								},
								w: {
									a: 0,
									k: 0.45
								},
								c: {
									a: 0,
									k: [
										0.933,
										0.933,
										0.933
									]
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0,
										0.514,
										0.459
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										21.4,
										21.9
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "그룹 6",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												-3.588,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-3.588
											],
											[
												0,
												0
											],
											[
												3.588,
												0
											],
											[
												0,
												0
											],
											[
												0,
												3.588
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												3.588,
												0
											],
											[
												0,
												0
											],
											[
												0,
												3.588
											],
											[
												0,
												0
											],
											[
												-3.588,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-3.588
											]
										],
										v: [
											[
												-67.103,
												-21.1
											],
											[
												67.104,
												-21.1
											],
											[
												73.6,
												-14.603
											],
											[
												73.6,
												14.603
											],
											[
												67.104,
												21.1
											],
											[
												-67.103,
												21.1
											],
											[
												-73.6,
												14.603
											],
											[
												-73.6,
												-14.603
											]
										]
									}
								}
							},
							{
								ty: "st",
								nm: "선 1",
								lc: 1,
								lj: 1,
								ml: 4,
								o: {
									a: 0,
									k: 100
								},
								w: {
									a: 0,
									k: 0.8
								},
								c: {
									a: 0,
									k: [
										0.926,
										0.926,
										0.926
									]
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										1,
										1,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										74.4,
										21.9
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 10
			},
			{
				ty: 2,
				nm: "폰",
				sr: 1,
				st: 0,
				op: 210,
				ip: 0,
				ln: "9592",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							87.5,
							181
						]
					},
					s: {
						a: 0,
						k: [
							100,
							100
						]
					},
					p: {
						a: 0,
						k: [
							181,
							215
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 0,
						k: 100
					}
				},
				refId: "20",
				ind: 11
			}
		]
	},
	{
		nm: "Untitled file",
		id: "2",
		fr: 30,
		layers: [
			{
				ty: 0,
				nm: "brillante",
				sr: 0.7,
				st: 0,
				op: 125.874,
				ip: 0,
				ln: "6963",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							256,
							256
						]
					},
					s: {
						a: 0,
						k: [
							100,
							100
						]
					},
					p: {
						a: 0,
						k: [
							256,
							256
						]
					},
					r: {
						a: 0,
						k: 180
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 0,
						k: 100
					}
				},
				w: 512,
				h: 512,
				refId: "3",
				ind: 1
			}
		]
	},
	{
		nm: "Scene_2",
		id: "3",
		fr: 30,
		layers: [
			{
				ty: 4,
				nm: "Shape Layer 71",
				sr: 1,
				st: 13.986,
				op: 149.85,
				ip: 13.986,
				ln: "6962",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 0,
						k: [
							70,
							70
						]
					},
					p: {
						a: 0,
						k: [
							256,
							256
						]
					},
					r: {
						a: 0,
						k: 187
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									0
								],
								t: 13.986
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 23.976
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 67.932
							},
							{
								s: [
									0
								],
								t: 99.899
							}
						]
					}
				},
				shapes: [
					{
						ty: "tm",
						nm: "Trim Paths 1",
						e: {
							a: 1,
							k: [
								{
									o: {
										x: 0.139,
										y: 0
									},
									i: {
										x: 0,
										y: 1
									},
									s: [
										0
									],
									t: 13.986
								},
								{
									s: [
										100
									],
									t: 83.915
								}
							]
						},
						o: {
							a: 0,
							k: 0
						},
						s: {
							a: 1,
							k: [
								{
									o: {
										x: 0.139,
										y: 0
									},
									i: {
										x: 0,
										y: 1
									},
									s: [
										0
									],
									t: 19.98
								},
								{
									s: [
										100
									],
									t: 93.905
								}
							]
						},
						m: 1
					}
				],
				ind: 1
			},
			{
				ty: 4,
				nm: "Shape Layer 69",
				sr: 1,
				st: 11.988,
				op: 149.85,
				ip: 11.988,
				ln: "6961",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									140.028,
									87.797
								],
								t: 11.988
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									149.724,
									81.426
								],
								t: 13.986
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									108.654,
									80.328
								],
								t: 15.984
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									122.85,
									125.952
								],
								t: 17.982
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									67.435,
									113.999
								],
								t: 19.98
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									77.828,
									139.764
								],
								t: 21.978
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									86.275,
									118.232
								],
								t: 23.976
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									132.517,
									84.447
								],
								t: 25.974
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									130.233,
									85.124
								],
								t: 27.972
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									104.061,
									104.576
								],
								t: 29.97
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									97.155,
									67.886
								],
								t: 31.968
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									131.988,
									124.186
								],
								t: 33.966
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									137.528,
									73.357
								],
								t: 35.964
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									88.621,
									106.456
								],
								t: 37.962
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									55.617,
									129.849
								],
								t: 39.96
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									102.914,
									93.756
								],
								t: 41.958
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									97.417,
									93.144
								],
								t: 43.956
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									54.264,
									122.898
								],
								t: 45.954
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									69.385,
									112.598
								],
								t: 47.952
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									108.191,
									60.937
								],
								t: 49.95
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									70.4,
									49.44
								],
								t: 51.948
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									84.854,
									97.16
								],
								t: 53.946
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									85.713,
									111.857
								],
								t: 55.944
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									89.136,
									97.385
								],
								t: 57.942
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									76.083,
									63.267
								],
								t: 59.94
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									85.219,
									64.136
								],
								t: 61.938
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									34.985,
									72.111
								],
								t: 63.936
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									97.846,
									83.275
								],
								t: 65.934
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									127.941,
									67.428
								],
								t: 67.932
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									103.695,
									66.821
								],
								t: 69.93
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									99.227,
									81.408
								],
								t: 71.928
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									79.727,
									70.137
								],
								t: 73.926
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									48.153,
									40.939
								],
								t: 75.923
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									26.225,
									1.63
								],
								t: 77.921
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									35.878,
									18.283
								],
								t: 79.919
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									45.795,
									60.473
								],
								t: 81.917
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									29.734,
									37.417
								],
								t: 83.915
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-23.828,
									13.866
								],
								t: 85.913
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									23.282,
									15.847
								],
								t: 87.911
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-4.081,
									51.66
								],
								t: 89.909
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-11.795,
									71.385
								],
								t: 91.907
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									48.641,
									43.137
								],
								t: 93.905
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									13.642,
									2.267
								],
								t: 95.903
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-18.389,
									32.951
								],
								t: 97.901
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									63.189,
									66.722
								],
								t: 99.899
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									2.261,
									24.31
								],
								t: 101.897
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									24.372,
									-2.358
								],
								t: 103.895
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									43.66,
									54.3
								],
								t: 105.893
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									39.61,
									13.352
								],
								t: 107.891
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									20.359,
									53.589
								],
								t: 109.889
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									23.988,
									18.274
								],
								t: 111.887
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									52.384,
									8.05
								],
								t: 113.885
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									84.408,
									-0.484
								],
								t: 115.883
							},
							{
								s: [
									26.091,
									14.017
								],
								t: 117.881
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									269.95,
									307.113
								],
								t: 11.988,
								ti: [
									1.346,
									1.541,
									0
								],
								to: [
									-0.323,
									-0.36,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									268.011,
									304.951
								],
								t: 13.986,
								ti: [
									2.46,
									3.542,
									0
								],
								to: [
									-1.346,
									-1.541,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									261.875,
									297.864
								],
								t: 15.984,
								ti: [
									2.232,
									5.312,
									0
								],
								to: [
									-2.46,
									-3.542,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									253.252,
									283.701
								],
								t: 17.982,
								ti: [
									0.637,
									5.627,
									0
								],
								to: [
									-2.232,
									-5.312,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									248.481,
									265.992
								],
								t: 19.98,
								ti: [
									-0.921,
									4.788,
									0
								],
								to: [
									-0.637,
									-5.627,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.007
								},
								i: {
									x: 0.833,
									y: 0.994
								},
								s: [
									249.431,
									249.939
								],
								t: 21.978,
								ti: [
									-1.796,
									3.705,
									0
								],
								to: [
									0.921,
									-4.788,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.029
								},
								i: {
									x: 0.833,
									y: 0.975
								},
								s: [
									254.007,
									237.262
								],
								t: 23.976,
								ti: [
									-2.147,
									2.784,
									0
								],
								to: [
									1.796,
									-3.705,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.057
								},
								i: {
									x: 0.833,
									y: 0.951
								},
								s: [
									260.206,
									227.707
								],
								t: 25.974,
								ti: [
									-2.218,
									2.088,
									0
								],
								to: [
									2.147,
									-2.784,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.084
								},
								i: {
									x: 0.833,
									y: 0.926
								},
								s: [
									266.89,
									220.559
								],
								t: 27.972,
								ti: [
									-2.161,
									1.578,
									0
								],
								to: [
									2.218,
									-2.088,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.106
								},
								i: {
									x: 0.833,
									y: 0.906
								},
								s: [
									273.513,
									215.179
								],
								t: 29.97,
								ti: [
									-2.053,
									1.203,
									0
								],
								to: [
									2.161,
									-1.578,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.123
								},
								i: {
									x: 0.833,
									y: 0.889
								},
								s: [
									279.855,
									211.089
								],
								t: 31.968,
								ti: [
									-1.93,
									0.918,
									0
								],
								to: [
									2.053,
									-1.203,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.137
								},
								i: {
									x: 0.833,
									y: 0.877
								},
								s: [
									285.832,
									207.964
								],
								t: 33.966,
								ti: [
									-1.801,
									0.7,
									0
								],
								to: [
									1.93,
									-0.918,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.147
								},
								i: {
									x: 0.833,
									y: 0.866
								},
								s: [
									291.433,
									205.582
								],
								t: 35.964,
								ti: [
									-1.666,
									0.538,
									0
								],
								to: [
									1.801,
									-0.7,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.154
								},
								i: {
									x: 0.833,
									y: 0.859
								},
								s: [
									296.641,
									203.764
								],
								t: 37.962,
								ti: [
									-1.53,
									0.417,
									0
								],
								to: [
									1.666,
									-0.538,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.16
								},
								i: {
									x: 0.833,
									y: 0.856
								},
								s: [
									301.428,
									202.354
								],
								t: 39.96,
								ti: [
									-1.402,
									0.32,
									0
								],
								to: [
									1.53,
									-0.417,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.163
								},
								i: {
									x: 0.833,
									y: 0.85
								},
								s: [
									305.818,
									201.265
								],
								t: 41.958,
								ti: [
									-1.283,
									0.243,
									0
								],
								to: [
									1.402,
									-0.32,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.168
								},
								i: {
									x: 0.833,
									y: 0.847
								},
								s: [
									309.838,
									200.433
								],
								t: 43.956,
								ti: [
									-1.172,
									0.18,
									0
								],
								to: [
									1.283,
									-0.243,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.169
								},
								i: {
									x: 0.833,
									y: 0.845
								},
								s: [
									313.514,
									199.809
								],
								t: 45.954,
								ti: [
									-1.068,
									0.128,
									0
								],
								to: [
									1.172,
									-0.18,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.172
								},
								i: {
									x: 0.833,
									y: 0.844
								},
								s: [
									316.868,
									199.355
								],
								t: 47.952,
								ti: [
									-0.97,
									0.084,
									0
								],
								to: [
									1.068,
									-0.128,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.174
								},
								i: {
									x: 0.833,
									y: 0.842
								},
								s: [
									319.92,
									199.043
								],
								t: 49.95,
								ti: [
									-0.879,
									0.048,
									0
								],
								to: [
									0.97,
									-0.084,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.176
								},
								i: {
									x: 0.833,
									y: 0.842
								},
								s: [
									322.69,
									198.85
								],
								t: 51.948,
								ti: [
									-0.793,
									0.017,
									0
								],
								to: [
									0.879,
									-0.048,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.176
								},
								i: {
									x: 0.833,
									y: 0.842
								},
								s: [
									325.194,
									198.756
								],
								t: 53.946,
								ti: [
									-0.712,
									-9e-3,
									0
								],
								to: [
									0.793,
									-0.017,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.176
								},
								i: {
									x: 0.833,
									y: 0.842
								},
								s: [
									327.449,
									198.747
								],
								t: 55.944,
								ti: [
									-0.636,
									-0.03,
									0
								],
								to: [
									0.712,
									0.009,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.176
								},
								i: {
									x: 0.833,
									y: 0.844
								},
								s: [
									329.469,
									198.808
								],
								t: 57.942,
								ti: [
									-0.564,
									-0.048,
									0
								],
								to: [
									0.636,
									0.03,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.174
								},
								i: {
									x: 0.833,
									y: 0.846
								},
								s: [
									331.266,
									198.928
								],
								t: 59.94,
								ti: [
									-0.497,
									-0.063,
									0
								],
								to: [
									0.564,
									0.048,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.172
								},
								i: {
									x: 0.833,
									y: 0.85
								},
								s: [
									332.854,
									199.098
								],
								t: 61.938,
								ti: [
									-0.434,
									-0.076,
									0
								],
								to: [
									0.497,
									0.063,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.853
								},
								s: [
									334.247,
									199.309
								],
								t: 63.936,
								ti: [
									-0.375,
									-0.085,
									0
								],
								to: [
									0.434,
									0.076,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.163
								},
								i: {
									x: 0.833,
									y: 0.86
								},
								s: [
									335.457,
									199.552
								],
								t: 65.934,
								ti: [
									-0.32,
									-0.092,
									0
								],
								to: [
									0.375,
									0.085,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.155
								},
								i: {
									x: 0.833,
									y: 0.868
								},
								s: [
									336.496,
									199.819
								],
								t: 67.932,
								ti: [
									-0.269,
									-0.097,
									0
								],
								to: [
									0.32,
									0.092,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.144
								},
								i: {
									x: 0.833,
									y: 0.877
								},
								s: [
									337.376,
									200.105
								],
								t: 69.93,
								ti: [
									-0.221,
									-0.099,
									0
								],
								to: [
									0.269,
									0.097,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.129
								},
								i: {
									x: 0.833,
									y: 0.891
								},
								s: [
									338.108,
									200.401
								],
								t: 71.928,
								ti: [
									-0.178,
									-0.1,
									0
								],
								to: [
									0.221,
									0.099,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.111
								},
								i: {
									x: 0.833,
									y: 0.908
								},
								s: [
									338.704,
									200.702
								],
								t: 73.926,
								ti: [
									-0.138,
									-0.098,
									0
								],
								to: [
									0.178,
									0.1,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.086
								},
								i: {
									x: 0.833,
									y: 0.929
								},
								s: [
									339.176,
									200.999
								],
								t: 75.923,
								ti: [
									-0.103,
									-0.094,
									0
								],
								to: [
									0.138,
									0.098,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.059
								},
								i: {
									x: 0.833,
									y: 0.952
								},
								s: [
									339.534,
									201.288
								],
								t: 77.921,
								ti: [
									-0.071,
									-0.087,
									0
								],
								to: [
									0.103,
									0.094,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.031
								},
								i: {
									x: 0.833,
									y: 0.975
								},
								s: [
									339.791,
									201.562
								],
								t: 79.919,
								ti: [
									-0.043,
									-0.079,
									0
								],
								to: [
									0.071,
									0.087,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.01
								},
								i: {
									x: 0.833,
									y: 0.992
								},
								s: [
									339.958,
									201.813
								],
								t: 81.917,
								ti: [
									-0.02,
									-0.068,
									0
								],
								to: [
									0.043,
									0.079,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.001
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									340.049,
									202.035
								],
								t: 83.915,
								ti: [
									0,
									-0.055,
									0
								],
								to: [
									0.02,
									0.068,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									340.075,
									202.222
								],
								t: 85.913,
								ti: [
									0.014,
									-0.04,
									0
								],
								to: [
									0,
									0.055,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									340.051,
									202.365
								],
								t: 87.911,
								ti: [
									0.025,
									-0.022,
									0
								],
								to: [
									-0.014,
									0.04,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									339.989,
									202.459
								],
								t: 89.909,
								ti: [
									0.024,
									-2e-3,
									0
								],
								to: [
									-0.025,
									0.022,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									339.903,
									202.496
								],
								t: 91.907,
								ti: [
									0.008,
									0.02,
									0
								],
								to: [
									-0.024,
									0.002,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 0.999
								},
								s: [
									339.844,
									202.469
								],
								t: 93.905,
								ti: [
									-0.011,
									0.042,
									0
								],
								to: [
									-8e-3,
									-0.02,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.004
								},
								i: {
									x: 0.833,
									y: 0.995
								},
								s: [
									339.858,
									202.373
								],
								t: 95.903,
								ti: [
									-0.012,
									0.057,
									0
								],
								to: [
									0.011,
									-0.042,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									339.908,
									202.219
								],
								t: 97.901,
								ti: [
									-1e-3,
									0.066,
									0
								],
								to: [
									0.012,
									-0.057,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									339.927,
									202.033
								],
								t: 99.899,
								ti: [
									0.008,
									0.072,
									0
								],
								to: [
									0.001,
									-0.066,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									339.916,
									201.823
								],
								t: 101.897,
								ti: [
									0.017,
									0.076,
									0
								],
								to: [
									-8e-3,
									-0.072,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									339.877,
									201.599
								],
								t: 103.895,
								ti: [
									0.026,
									0.078,
									0
								],
								to: [
									-0.017,
									-0.076,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									339.812,
									201.365
								],
								t: 105.893,
								ti: [
									0.033,
									0.078,
									0
								],
								to: [
									-0.026,
									-0.078,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									339.723,
									201.128
								],
								t: 107.891,
								ti: [
									0.04,
									0.076,
									0
								],
								to: [
									-0.033,
									-0.078,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									339.613,
									200.895
								],
								t: 109.889,
								ti: [
									0.046,
									0.073,
									0
								],
								to: [
									-0.04,
									-0.076,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									339.484,
									200.67
								],
								t: 111.887,
								ti: [
									0.051,
									0.068,
									0
								],
								to: [
									-0.046,
									-0.073,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									339.339,
									200.457
								],
								t: 113.885,
								ti: [
									0.055,
									0.062,
									0
								],
								to: [
									-0.051,
									-0.068,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									339.179,
									200.262
								],
								t: 115.883,
								ti: [
									0.029,
									0.029,
									0
								],
								to: [
									-0.055,
									-0.062,
									0
								]
							},
							{
								s: [
									339.007,
									200.087
								],
								t: 117.881
							}
						]
					},
					r: {
						a: 0,
						k: 92
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									0
								],
								t: 11.988
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 21.978
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 65.934
							},
							{
								s: [
									0
								],
								t: 97.901
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "Polystar 1",
						it: [
							{
								ty: "sr",
								nm: "Polystar Path 1",
								d: 1,
								pt: {
									a: 0,
									k: 3
								},
								p: {
									a: 0,
									k: [
										6,
										32
									]
								},
								or: {
									a: 0,
									k: 6.599
								},
								os: {
									a: 0,
									k: 0
								},
								r: {
									a: 0,
									k: 0
								},
								sy: 2
							},
							{
								ty: "fl",
								nm: "Fill 1",
								c: {
									a: 0,
									k: [
										0.322,
										0.624,
										0.988
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										-7.382,
										-25.677
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 2
			},
			{
				ty: 4,
				nm: "Shape Layer 68",
				sr: 1,
				st: 21.978,
				op: 149.85,
				ip: 21.978,
				ln: "6960",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									59.343,
									96.124
								],
								t: 21.978
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									89.744,
									43.042
								],
								t: 23.976
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									104.203,
									66.307
								],
								t: 25.974
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									95.197,
									89.821
								],
								t: 27.972
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									89.153,
									41.816
								],
								t: 29.97
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									125.946,
									74.556
								],
								t: 31.968
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									169.121,
									79.673
								],
								t: 33.966
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									129.751,
									102.297
								],
								t: 35.964
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									81.726,
									99.791
								],
								t: 37.962
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									93.197,
									117.733
								],
								t: 39.96
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									116.588,
									84.536
								],
								t: 41.958
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									77.774,
									77.458
								],
								t: 43.956
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									80.336,
									112.065
								],
								t: 45.954
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									93.979,
									55.33
								],
								t: 47.952
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									91.437,
									45.624
								],
								t: 49.95
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									94.777,
									67.955
								],
								t: 51.948
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									58.109,
									118.474
								],
								t: 53.946
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									125.074,
									97.355
								],
								t: 55.944
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									95.015,
									93.056
								],
								t: 57.942
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									108.364,
									63.932
								],
								t: 59.94
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									29.719,
									92.263
								],
								t: 61.938
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									91.786,
									90.449
								],
								t: 63.936
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									150.239,
									55.635
								],
								t: 65.934
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									131.528,
									79.867
								],
								t: 67.932
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									114.424,
									104
								],
								t: 69.93
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									99.134,
									112.3
								],
								t: 71.928
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									104.825,
									98.77
								],
								t: 73.926
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									67.48,
									67.824
								],
								t: 75.924
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									65.344,
									10.519
								],
								t: 77.922
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									77.671,
									71.977
								],
								t: 79.92
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									76.639,
									101.368
								],
								t: 81.918
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									25.532,
									39.221
								],
								t: 83.916
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									33.627,
									30.543
								],
								t: 85.913
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									29.417,
									64.046
								],
								t: 87.911
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									40.374,
									53.993
								],
								t: 89.909
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									71.134,
									29.6
								],
								t: 91.907
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									37.38,
									38.828
								],
								t: 93.905
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-15.322,
									-10.291
								],
								t: 95.903
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									86.713,
									39.937
								],
								t: 97.901
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									48.493,
									27.546
								],
								t: 99.899
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									46.484,
									-5.44
								],
								t: 101.897
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									56.051,
									33.097
								],
								t: 103.895
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									77.513,
									62.169
								],
								t: 105.893
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									46.909,
									73.396
								],
								t: 107.891
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									53.173,
									25.847
								],
								t: 109.889
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									56.946,
									-11.873
								],
								t: 111.887
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									96.787,
									-13.805
								],
								t: 113.885
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									45.548,
									-2.059
								],
								t: 115.883
							},
							{
								s: [
									29.917,
									33.378
								],
								t: 117.881
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									266.709,
									299.63
								],
								t: 21.978,
								ti: [
									0.204,
									-1.854,
									0
								],
								to: [
									-0.015,
									0.376,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									266.621,
									301.887
								],
								t: 23.976,
								ti: [
									0.96,
									-4.091,
									0
								],
								to: [
									-0.204,
									1.854,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									265.488,
									310.754
								],
								t: 25.974,
								ti: [
									2.202,
									-5.284,
									0
								],
								to: [
									-0.96,
									4.091,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									260.859,
									326.432
								],
								t: 27.972,
								ti: [
									3.145,
									-4.688,
									0
								],
								to: [
									-2.202,
									5.284,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									252.276,
									342.456
								],
								t: 29.97,
								ti: [
									3.441,
									-3.397,
									0
								],
								to: [
									-3.145,
									4.688,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									241.99,
									354.561
								],
								t: 31.968,
								ti: [
									3.35,
									-2.293,
									0
								],
								to: [
									-3.441,
									3.397,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									231.629,
									362.84
								],
								t: 33.966,
								ti: [
									3.107,
									-1.507,
									0
								],
								to: [
									-3.35,
									2.293,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									221.889,
									368.32
								],
								t: 35.964,
								ti: [
									2.823,
									-0.973,
									0
								],
								to: [
									-3.107,
									1.507,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									212.988,
									371.885
								],
								t: 37.962,
								ti: [
									2.545,
									-0.61,
									0
								],
								to: [
									-2.823,
									0.973,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									204.948,
									374.155
								],
								t: 39.96,
								ti: [
									2.287,
									-0.361,
									0
								],
								to: [
									-2.545,
									0.61,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									197.719,
									375.542
								],
								t: 41.958,
								ti: [
									2.057,
									-0.189,
									0
								],
								to: [
									-2.287,
									0.361,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									191.223,
									376.321
								],
								t: 43.956,
								ti: [
									1.855,
									-0.069,
									0
								],
								to: [
									-2.057,
									0.189,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									185.374,
									376.678
								],
								t: 45.954,
								ti: [
									1.678,
									0.016,
									0
								],
								to: [
									-1.855,
									0.069,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									180.091,
									376.736
								],
								t: 47.952,
								ti: [
									1.52,
									0.078,
									0
								],
								to: [
									-1.678,
									-0.016,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									175.308,
									376.58
								],
								t: 49.95,
								ti: [
									1.379,
									0.122,
									0
								],
								to: [
									-1.52,
									-0.078,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									170.97,
									376.27
								],
								t: 51.948,
								ti: [
									1.252,
									0.155,
									0
								],
								to: [
									-1.379,
									-0.122,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									167.033,
									375.845
								],
								t: 53.946,
								ti: [
									1.137,
									0.18,
									0
								],
								to: [
									-1.252,
									-0.155,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									163.458,
									375.337
								],
								t: 55.944,
								ti: [
									1.031,
									0.198,
									0
								],
								to: [
									-1.137,
									-0.18,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									160.214,
									374.766
								],
								t: 57.942,
								ti: [
									0.933,
									0.212,
									0
								],
								to: [
									-1.031,
									-0.198,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									157.274,
									374.147
								],
								t: 59.94,
								ti: [
									0.843,
									0.223,
									0
								],
								to: [
									-0.933,
									-0.212,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									154.615,
									373.492
								],
								t: 61.938,
								ti: [
									0.758,
									0.232,
									0
								],
								to: [
									-0.843,
									-0.223,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									152.218,
									372.807
								],
								t: 63.936,
								ti: [
									0.683,
									0.239,
									0
								],
								to: [
									-0.758,
									-0.232,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									150.067,
									372.098
								],
								t: 65.934,
								ti: [
									0.619,
									0.242,
									0
								],
								to: [
									-0.683,
									-0.239,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									148.12,
									371.372
								],
								t: 67.932,
								ti: [
									0.56,
									0.239,
									0
								],
								to: [
									-0.619,
									-0.242,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									146.355,
									370.647
								],
								t: 69.93,
								ti: [
									0.506,
									0.232,
									0
								],
								to: [
									-0.56,
									-0.239,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									144.758,
									369.937
								],
								t: 71.928,
								ti: [
									0.454,
									0.219,
									0
								],
								to: [
									-0.506,
									-0.232,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									143.32,
									369.258
								],
								t: 73.926,
								ti: [
									0.406,
									0.203,
									0
								],
								to: [
									-0.454,
									-0.219,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									142.032,
									368.621
								],
								t: 75.924,
								ti: [
									0.36,
									0.184,
									0
								],
								to: [
									-0.406,
									-0.203,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									140.885,
									368.038
								],
								t: 77.922,
								ti: [
									0.317,
									0.162,
									0
								],
								to: [
									-0.36,
									-0.184,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									139.871,
									367.517
								],
								t: 79.92,
								ti: [
									0.277,
									0.138,
									0
								],
								to: [
									-0.317,
									-0.162,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									138.982,
									367.066
								],
								t: 81.918,
								ti: [
									0.238,
									0.111,
									0
								],
								to: [
									-0.277,
									-0.138,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									138.211,
									366.692
								],
								t: 83.916,
								ti: [
									0.201,
									0.083,
									0
								],
								to: [
									-0.238,
									-0.111,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									137.554,
									366.399
								],
								t: 85.913,
								ti: [
									0.166,
									0.055,
									0
								],
								to: [
									-0.201,
									-0.083,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									137.005,
									366.191
								],
								t: 87.911,
								ti: [
									0.132,
									0.025,
									0
								],
								to: [
									-0.166,
									-0.055,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									136.559,
									366.071
								],
								t: 89.909,
								ti: [
									0.1,
									-5e-3,
									0
								],
								to: [
									-0.132,
									-0.025,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									136.211,
									366.04
								],
								t: 91.907,
								ti: [
									0.069,
									-0.034,
									0
								],
								to: [
									-0.1,
									0.005,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									135.959,
									366.098
								],
								t: 93.905,
								ti: [
									0.039,
									-0.063,
									0
								],
								to: [
									-0.069,
									0.034,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									135.797,
									366.244
								],
								t: 95.903,
								ti: [
									0.011,
									-0.091,
									0
								],
								to: [
									-0.039,
									0.063,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									135.723,
									366.476
								],
								t: 97.901,
								ti: [
									-0.016,
									-0.118,
									0
								],
								to: [
									-0.011,
									0.091,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.002
								},
								i: {
									x: 0.833,
									y: 0.998
								},
								s: [
									135.732,
									366.79
								],
								t: 99.899,
								ti: [
									-0.036,
									-0.141,
									0
								],
								to: [
									0.016,
									0.118,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.003
								},
								i: {
									x: 0.833,
									y: 0.996
								},
								s: [
									135.82,
									367.181
								],
								t: 101.897,
								ti: [
									-0.044,
									-0.159,
									0
								],
								to: [
									0.036,
									0.141,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.003
								},
								i: {
									x: 0.833,
									y: 0.997
								},
								s: [
									135.95,
									367.634
								],
								t: 103.895,
								ti: [
									-0.046,
									-0.173,
									0
								],
								to: [
									0.044,
									0.159,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.002
								},
								i: {
									x: 0.833,
									y: 0.997
								},
								s: [
									136.085,
									368.134
								],
								t: 105.893,
								ti: [
									-0.047,
									-0.184,
									0
								],
								to: [
									0.046,
									0.173,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.002
								},
								i: {
									x: 0.833,
									y: 0.998
								},
								s: [
									136.223,
									368.671
								],
								t: 107.891,
								ti: [
									-0.048,
									-0.193,
									0
								],
								to: [
									0.047,
									0.184,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.002
								},
								i: {
									x: 0.833,
									y: 0.998
								},
								s: [
									136.365,
									369.239
								],
								t: 109.889,
								ti: [
									-0.048,
									-0.197,
									0
								],
								to: [
									0.048,
									0.193,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.002
								},
								i: {
									x: 0.833,
									y: 0.998
								},
								s: [
									136.509,
									369.827
								],
								t: 111.887,
								ti: [
									-0.048,
									-0.198,
									0
								],
								to: [
									0.048,
									0.197,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.002
								},
								i: {
									x: 0.833,
									y: 0.998
								},
								s: [
									136.653,
									370.423
								],
								t: 113.885,
								ti: [
									-0.047,
									-0.195,
									0
								],
								to: [
									0.048,
									0.198,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.002
								},
								i: {
									x: 0.833,
									y: 0.998
								},
								s: [
									136.796,
									371.017
								],
								t: 115.883,
								ti: [
									-0.023,
									-0.096,
									0
								],
								to: [
									0.047,
									0.195,
									0
								]
							},
							{
								s: [
									136.937,
									371.594
								],
								t: 117.881
							}
						]
					},
					r: {
						a: 0,
						k: 92
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									0
								],
								t: 21.978
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 31.968
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 75.924
							},
							{
								s: [
									0
								],
								t: 107.891
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "Polystar 1",
						it: [
							{
								ty: "sr",
								nm: "Polystar Path 1",
								d: 1,
								pt: {
									a: 0,
									k: 3
								},
								p: {
									a: 0,
									k: [
										6,
										32
									]
								},
								or: {
									a: 0,
									k: 6.599
								},
								os: {
									a: 0,
									k: 0
								},
								r: {
									a: 0,
									k: 0
								},
								sy: 2
							},
							{
								ty: "fl",
								nm: "Fill 1",
								c: {
									a: 0,
									k: [
										0.322,
										0.624,
										0.988
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										-7.382,
										-25.677
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 3
			},
			{
				ty: 4,
				nm: "Shape Layer 67",
				sr: 1,
				st: 3.996,
				op: 149.85,
				ip: 3.996,
				ln: "6959",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									100.63,
									69.657
								],
								t: 3.996
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									104.514,
									69.052
								],
								t: 5.994
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									115.346,
									69.821
								],
								t: 7.992
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									58.871,
									88.161
								],
								t: 9.99
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									51.174,
									36.165
								],
								t: 11.988
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									95.636,
									55.822
								],
								t: 13.986
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									69.725,
									97.853
								],
								t: 15.984
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									86.959,
									82.233
								],
								t: 17.982
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									94.096,
									56.625
								],
								t: 19.98
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									151.503,
									104.404
								],
								t: 21.978
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									121.653,
									123.646
								],
								t: 23.976
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									91.668,
									73.435
								],
								t: 25.974
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									66.045,
									99.285
								],
								t: 27.972
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									87.746,
									66.291
								],
								t: 29.97
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									100.66,
									48.526
								],
								t: 31.968
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									95.172,
									108.893
								],
								t: 33.966
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									95.987,
									89.94
								],
								t: 35.964
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									94.176,
									58.401
								],
								t: 37.962
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									130.21,
									65.835
								],
								t: 39.96
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									47.499,
									124.757
								],
								t: 41.958
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									105.068,
									83.037
								],
								t: 43.956
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									118.917,
									107.79
								],
								t: 45.954
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									134.616,
									75.912
								],
								t: 47.952
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									86.877,
									99.716
								],
								t: 49.95
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									54.265,
									96.009
								],
								t: 51.948
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									123.839,
									64.381
								],
								t: 53.946
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									97.726,
									39.711
								],
								t: 55.944
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									92.458,
									75.119
								],
								t: 57.942
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									59.151,
									108.162
								],
								t: 59.94
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									86.256,
									126.307
								],
								t: 61.938
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									81.627,
									95.551
								],
								t: 63.936
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									53.31,
									31.043
								],
								t: 65.934
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									67.002,
									42.37
								],
								t: 67.931
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									81.207,
									78.404
								],
								t: 69.929
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									50.269,
									13.881
								],
								t: 71.927
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									31.981,
									57.039
								],
								t: 73.925
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									30.188,
									54.035
								],
								t: 75.923
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									41.246,
									45.317
								],
								t: 77.921
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									34.148,
									-11.396
								],
								t: 79.919
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									34.363,
									9.033
								],
								t: 81.917
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-8.365,
									-24.009
								],
								t: 83.915
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									32.621,
									-15.669
								],
								t: 85.913
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									44.332,
									-6.94
								],
								t: 87.911
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									47.804,
									-14.568
								],
								t: 89.909
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									50.704,
									8.589
								],
								t: 91.907
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									66.039,
									65.528
								],
								t: 93.905
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									32.735,
									78.112
								],
								t: 95.903
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									30.98,
									12.995
								],
								t: 97.901
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									46.164,
									-40.385
								],
								t: 99.899
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									82.432,
									-28.944
								],
								t: 101.897
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									74.813,
									1.96
								],
								t: 103.895
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									13.817,
									22.06
								],
								t: 105.893
							},
							{
								s: [
									39.779,
									9.173
								],
								t: 107.891
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.136
								},
								i: {
									x: 0.833,
									y: 0.667
								},
								s: [
									262.436,
									299.331
								],
								t: 3.996,
								ti: [
									-2.348,
									1.046,
									0
								],
								to: [
									0.489,
									-0.187,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.078
								},
								i: {
									x: 0.833,
									y: 0.824
								},
								s: [
									265.373,
									298.21
								],
								t: 5.994,
								ti: [
									-5.031,
									2.854,
									0
								],
								to: [
									2.348,
									-1.046,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.078
								},
								i: {
									x: 0.833,
									y: 0.894
								},
								s: [
									276.523,
									293.055
								],
								t: 7.992,
								ti: [
									-6.175,
									4.882,
									0
								],
								to: [
									5.031,
									-2.854,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.059
								},
								i: {
									x: 0.833,
									y: 0.942
								},
								s: [
									295.56,
									281.084
								],
								t: 9.99,
								ti: [
									-4.919,
									5.974,
									0
								],
								to: [
									6.175,
									-4.882,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.026
								},
								i: {
									x: 0.833,
									y: 0.977
								},
								s: [
									313.573,
									263.763
								],
								t: 11.988,
								ti: [
									-2.793,
									5.995,
									0
								],
								to: [
									4.919,
									-5.974,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.004
								},
								i: {
									x: 0.833,
									y: 0.996
								},
								s: [
									325.076,
									245.24
								],
								t: 13.986,
								ti: [
									-0.958,
									5.467,
									0
								],
								to: [
									2.793,
									-5.995,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									330.333,
									227.794
								],
								t: 15.984,
								ti: [
									0.382,
									4.708,
									0
								],
								to: [
									0.958,
									-5.467,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									330.823,
									212.44
								],
								t: 17.982,
								ti: [
									1.261,
									3.892,
									0
								],
								to: [
									-0.382,
									-4.708,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									328.039,
									199.545
								],
								t: 19.98,
								ti: [
									1.765,
									3.129,
									0
								],
								to: [
									-1.261,
									-3.892,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									323.257,
									189.086
								],
								t: 21.978,
								ti: [
									2.001,
									2.482,
									0
								],
								to: [
									-1.765,
									-3.129,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									317.447,
									180.769
								],
								t: 23.976,
								ti: [
									2.064,
									1.961,
									0
								],
								to: [
									-2.001,
									-2.482,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									311.25,
									174.195
								],
								t: 25.974,
								ti: [
									2.024,
									1.552,
									0
								],
								to: [
									-2.064,
									-1.961,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									305.064,
									169.001
								],
								t: 27.972,
								ti: [
									1.932,
									1.236,
									0
								],
								to: [
									-2.024,
									-1.552,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									299.106,
									164.881
								],
								t: 29.97,
								ti: [
									1.816,
									0.99,
									0
								],
								to: [
									-1.932,
									-1.236,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									293.474,
									161.588
								],
								t: 31.968,
								ti: [
									1.69,
									0.797,
									0
								],
								to: [
									-1.816,
									-0.99,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									288.212,
									158.939
								],
								t: 33.966,
								ti: [
									1.563,
									0.644,
									0
								],
								to: [
									-1.69,
									-0.797,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									283.333,
									156.803
								],
								t: 35.964,
								ti: [
									1.437,
									0.519,
									0
								],
								to: [
									-1.563,
									-0.644,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									278.836,
									155.078
								],
								t: 37.962,
								ti: [
									1.316,
									0.416,
									0
								],
								to: [
									-1.437,
									-0.519,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									274.712,
									153.691
								],
								t: 39.96,
								ti: [
									1.201,
									0.33,
									0
								],
								to: [
									-1.316,
									-0.416,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									270.942,
									152.585
								],
								t: 41.958,
								ti: [
									1.094,
									0.257,
									0
								],
								to: [
									-1.201,
									-0.33,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									267.505,
									151.714
								],
								t: 43.956,
								ti: [
									0.992,
									0.194,
									0
								],
								to: [
									-1.094,
									-0.257,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									264.381,
									151.045
								],
								t: 45.954,
								ti: [
									0.897,
									0.139,
									0
								],
								to: [
									-0.992,
									-0.194,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									261.551,
									150.551
								],
								t: 47.952,
								ti: [
									0.808,
									0.091,
									0
								],
								to: [
									-0.897,
									-0.139,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									258.997,
									150.211
								],
								t: 49.95,
								ti: [
									0.724,
									0.048,
									0
								],
								to: [
									-0.808,
									-0.091,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									256.702,
									150.007
								],
								t: 51.948,
								ti: [
									0.646,
									0.009,
									0
								],
								to: [
									-0.724,
									-0.048,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									254.651,
									149.925
								],
								t: 53.946,
								ti: [
									0.572,
									-0.025,
									0
								],
								to: [
									-0.646,
									-9e-3,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									252.828,
									149.951
								],
								t: 55.944,
								ti: [
									0.502,
									-0.055,
									0
								],
								to: [
									-0.572,
									0.025,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									251.221,
									150.073
								],
								t: 57.942,
								ti: [
									0.437,
									-0.082,
									0
								],
								to: [
									-0.502,
									0.055,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									249.815,
									150.281
								],
								t: 59.94,
								ti: [
									0.377,
									-0.105,
									0
								],
								to: [
									-0.437,
									0.082,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									248.597,
									150.563
								],
								t: 61.938,
								ti: [
									0.321,
									-0.125,
									0
								],
								to: [
									-0.377,
									0.105,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									247.552,
									150.91
								],
								t: 63.936,
								ti: [
									0.269,
									-0.141,
									0
								],
								to: [
									-0.321,
									0.125,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									246.671,
									151.311
								],
								t: 65.934,
								ti: [
									0.22,
									-0.154,
									0
								],
								to: [
									-0.269,
									0.141,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									245.941,
									151.756
								],
								t: 67.931,
								ti: [
									0.174,
									-0.163,
									0
								],
								to: [
									-0.22,
									0.154,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									245.353,
									152.233
								],
								t: 69.929,
								ti: [
									0.132,
									-0.168,
									0
								],
								to: [
									-0.174,
									0.163,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									244.897,
									152.732
								],
								t: 71.927,
								ti: [
									0.093,
									-0.169,
									0
								],
								to: [
									-0.132,
									0.168,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									244.562,
									153.241
								],
								t: 73.925,
								ti: [
									0.057,
									-0.166,
									0
								],
								to: [
									-0.093,
									0.169,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									244.34,
									153.746
								],
								t: 75.923,
								ti: [
									0.024,
									-0.158,
									0
								],
								to: [
									-0.057,
									0.166,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									244.221,
									154.236
								],
								t: 77.921,
								ti: [
									-6e-3,
									-0.145,
									0
								],
								to: [
									-0.024,
									0.158,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.001
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									244.197,
									154.694
								],
								t: 79.919,
								ti: [
									-0.033,
									-0.128,
									0
								],
								to: [
									0.006,
									0.145,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.008
								},
								i: {
									x: 0.833,
									y: 0.992
								},
								s: [
									244.257,
									155.108
								],
								t: 81.917,
								ti: [
									-0.049,
									-0.109,
									0
								],
								to: [
									0.033,
									0.128,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.017
								},
								i: {
									x: 0.833,
									y: 0.983
								},
								s: [
									244.394,
									155.461
								],
								t: 83.915,
								ti: [
									-0.051,
									-0.108,
									0
								],
								to: [
									0.049,
									0.109,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.01
								},
								i: {
									x: 0.833,
									y: 0.989
								},
								s: [
									244.552,
									155.765
								],
								t: 85.913,
								ti: [
									-0.047,
									-0.12,
									0
								],
								to: [
									0.051,
									0.108,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.006
								},
								i: {
									x: 0.833,
									y: 0.993
								},
								s: [
									244.699,
									156.107
								],
								t: 87.911,
								ti: [
									-0.044,
									-0.131,
									0
								],
								to: [
									0.047,
									0.12,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.005
								},
								i: {
									x: 0.833,
									y: 0.995
								},
								s: [
									244.836,
									156.487
								],
								t: 89.909,
								ti: [
									-0.041,
									-0.137,
									0
								],
								to: [
									0.044,
									0.131,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.004
								},
								i: {
									x: 0.833,
									y: 0.996
								},
								s: [
									244.964,
									156.891
								],
								t: 91.907,
								ti: [
									-0.039,
									-0.14,
									0
								],
								to: [
									0.041,
									0.137,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.003
								},
								i: {
									x: 0.833,
									y: 0.997
								},
								s: [
									245.085,
									157.309
								],
								t: 93.905,
								ti: [
									-0.037,
									-0.14,
									0
								],
								to: [
									0.039,
									0.14,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.002
								},
								i: {
									x: 0.833,
									y: 0.998
								},
								s: [
									245.198,
									157.733
								],
								t: 95.903,
								ti: [
									-0.035,
									-0.138,
									0
								],
								to: [
									0.037,
									0.14,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.002
								},
								i: {
									x: 0.833,
									y: 0.998
								},
								s: [
									245.305,
									158.152
								],
								t: 97.901,
								ti: [
									-0.033,
									-0.133,
									0
								],
								to: [
									0.035,
									0.138,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.002
								},
								i: {
									x: 0.833,
									y: 0.998
								},
								s: [
									245.406,
									158.559
								],
								t: 99.899,
								ti: [
									-0.031,
									-0.125,
									0
								],
								to: [
									0.033,
									0.133,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.002
								},
								i: {
									x: 0.833,
									y: 0.998
								},
								s: [
									245.502,
									158.947
								],
								t: 101.897,
								ti: [
									-0.03,
									-0.116,
									0
								],
								to: [
									0.031,
									0.125,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.003
								},
								i: {
									x: 0.833,
									y: 0.997
								},
								s: [
									245.594,
									159.31
								],
								t: 103.895,
								ti: [
									-0.029,
									-0.104,
									0
								],
								to: [
									0.03,
									0.116,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.004
								},
								i: {
									x: 0.833,
									y: 0.996
								},
								s: [
									245.683,
									159.641
								],
								t: 105.893,
								ti: [
									-0.014,
									-0.049,
									0
								],
								to: [
									0.029,
									0.104,
									0
								]
							},
							{
								s: [
									245.769,
									159.936
								],
								t: 107.891
							}
						]
					},
					r: {
						a: 0,
						k: 92
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									0
								],
								t: 3.996
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 13.986
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 57.942
							},
							{
								s: [
									0
								],
								t: 89.909
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "Polystar 1",
						it: [
							{
								ty: "sr",
								nm: "Polystar Path 1",
								d: 1,
								pt: {
									a: 0,
									k: 3
								},
								p: {
									a: 0,
									k: [
										6,
										32
									]
								},
								or: {
									a: 0,
									k: 6.599
								},
								os: {
									a: 0,
									k: 0
								},
								r: {
									a: 0,
									k: 0
								},
								sy: 2
							},
							{
								ty: "fl",
								nm: "Fill 1",
								c: {
									a: 0,
									k: [
										0.322,
										0.624,
										0.988
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										-7.382,
										-25.677
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 4
			},
			{
				ty: 4,
				nm: "Shape Layer 66",
				sr: 1,
				st: 17.982,
				op: 149.85,
				ip: 17.982,
				ln: "6958",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									60.433,
									69.807
								],
								t: 17.982
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									57.035,
									63.909
								],
								t: 19.98
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									110.865,
									70.792
								],
								t: 21.978
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									90.384,
									117.236
								],
								t: 23.976
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									78.755,
									118.657
								],
								t: 25.974
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									89.349,
									90.995
								],
								t: 27.972
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									127.76,
									125.63
								],
								t: 29.97
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									109.298,
									141.669
								],
								t: 31.968
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									74.466,
									65.123
								],
								t: 33.966
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									46.407,
									94.474
								],
								t: 35.964
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									50.79,
									61.594
								],
								t: 37.962
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									74.379,
									60.195
								],
								t: 39.96
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									67.656,
									89.669
								],
								t: 41.958
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									88.817,
									119.34
								],
								t: 43.956
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									92.391,
									70.889
								],
								t: 45.954
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									145.365,
									97.56
								],
								t: 47.952
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									71.948,
									114.853
								],
								t: 49.95
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									67.657,
									97.077
								],
								t: 51.948
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									108.077,
									92.496
								],
								t: 53.946
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									122.812,
									108.142
								],
								t: 55.944
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									136.892,
									105.97
								],
								t: 57.942
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									71.752,
									114.791
								],
								t: 59.94
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									93.325,
									80.942
								],
								t: 61.938
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									93.159,
									47.153
								],
								t: 63.936
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									100.704,
									44.07
								],
								t: 65.934
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									67.68,
									88.243
								],
								t: 67.932
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									68.025,
									152.101
								],
								t: 69.93
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									100.152,
									137.254
								],
								t: 71.928
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									91.001,
									95.342
								],
								t: 73.926
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									52.026,
									87.036
								],
								t: 75.924
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									90.362,
									85.565
								],
								t: 77.922
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									89.547,
									32.423
								],
								t: 79.92
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									55.168,
									83.983
								],
								t: 81.917
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									58.978,
									88.274
								],
								t: 83.915
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									34.79,
									80.994
								],
								t: 85.913
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									39.732,
									2.714
								],
								t: 87.911
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									28.352,
									-0.992
								],
								t: 89.909
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									29.041,
									12.182
								],
								t: 91.907
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									1.635,
									-20.19
								],
								t: 93.905
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									23.803,
									1.627
								],
								t: 95.903
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									22.083,
									0.392
								],
								t: 97.901
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									48.704,
									41.779
								],
								t: 99.899
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									43.437,
									45.791
								],
								t: 101.897
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									13.575,
									72.931
								],
								t: 103.895
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-12.851,
									42.13
								],
								t: 105.893
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									26.868,
									-22.827
								],
								t: 107.891
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									60.696,
									-28.382
								],
								t: 109.889
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									64.461,
									8.569
								],
								t: 111.887
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									14.897,
									8.85
								],
								t: 113.885
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									38.326,
									-8.337
								],
								t: 115.883
							},
							{
								s: [
									30.376,
									9.931
								],
								t: 117.881
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									264.075,
									300.144
								],
								t: 17.982,
								ti: [
									0.355,
									-2.342,
									0
								],
								to: [
									-0.069,
									0.468,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									263.663,
									302.955
								],
								t: 19.98,
								ti: [
									0.559,
									-5.353,
									0
								],
								to: [
									-0.355,
									2.342,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									261.945,
									314.199
								],
								t: 21.978,
								ti: [
									0.004,
									-7.357,
									0
								],
								to: [
									-0.559,
									5.353,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									260.312,
									335.072
								],
								t: 23.976,
								ti: [
									-1.215,
									-7.142,
									0
								],
								to: [
									-4e-3,
									7.357,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.004
								},
								i: {
									x: 0.833,
									y: 0.997
								},
								s: [
									261.922,
									358.34
								],
								t: 25.974,
								ti: [
									-2.396,
									-5.718,
									0
								],
								to: [
									1.215,
									7.142,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.024
								},
								i: {
									x: 0.833,
									y: 0.98
								},
								s: [
									267.601,
									377.926
								],
								t: 27.972,
								ti: [
									-3.152,
									-4.167,
									0
								],
								to: [
									2.396,
									5.718,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.063
								},
								i: {
									x: 0.833,
									y: 0.946
								},
								s: [
									276.299,
									392.647
								],
								t: 29.97,
								ti: [
									-3.444,
									-2.85,
									0
								],
								to: [
									3.152,
									4.167,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.104
								},
								i: {
									x: 0.833,
									y: 0.909
								},
								s: [
									286.512,
									402.925
								],
								t: 31.968,
								ti: [
									-3.405,
									-1.874,
									0
								],
								to: [
									3.444,
									2.85,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.137
								},
								i: {
									x: 0.833,
									y: 0.88
								},
								s: [
									296.962,
									409.748
								],
								t: 33.966,
								ti: [
									-3.2,
									-1.208,
									0
								],
								to: [
									3.405,
									1.874,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.155
								},
								i: {
									x: 0.833,
									y: 0.863
								},
								s: [
									306.94,
									414.169
								],
								t: 35.964,
								ti: [
									-2.937,
									-0.769,
									0
								],
								to: [
									3.2,
									1.208,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.165
								},
								i: {
									x: 0.833,
									y: 0.852
								},
								s: [
									316.159,
									416.998
								],
								t: 37.962,
								ti: [
									-2.672,
									-0.481,
									0
								],
								to: [
									2.937,
									0.769,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.17
								},
								i: {
									x: 0.833,
									y: 0.847
								},
								s: [
									324.559,
									418.783
								],
								t: 39.96,
								ti: [
									-2.428,
									-0.291,
									0
								],
								to: [
									2.672,
									0.481,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.173
								},
								i: {
									x: 0.833,
									y: 0.844
								},
								s: [
									332.191,
									419.883
								],
								t: 41.958,
								ti: [
									-2.206,
									-0.163,
									0
								],
								to: [
									2.428,
									0.291,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.175
								},
								i: {
									x: 0.833,
									y: 0.841
								},
								s: [
									339.125,
									420.527
								],
								t: 43.956,
								ti: [
									-2.007,
									-0.077,
									0
								],
								to: [
									2.206,
									0.163,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.175
								},
								i: {
									x: 0.833,
									y: 0.841
								},
								s: [
									345.429,
									420.863
								],
								t: 45.954,
								ti: [
									-1.827,
									-0.019,
									0
								],
								to: [
									2.007,
									0.077,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.175
								},
								i: {
									x: 0.833,
									y: 0.841
								},
								s: [
									351.165,
									420.991
								],
								t: 47.952,
								ti: [
									-1.665,
									0.021,
									0
								],
								to: [
									1.827,
									0.019,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.175
								},
								i: {
									x: 0.833,
									y: 0.841
								},
								s: [
									356.391,
									420.977
								],
								t: 49.95,
								ti: [
									-1.519,
									0.049,
									0
								],
								to: [
									1.665,
									-0.021,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.175
								},
								i: {
									x: 0.833,
									y: 0.841
								},
								s: [
									361.156,
									420.865
								],
								t: 51.948,
								ti: [
									-1.386,
									0.069,
									0
								],
								to: [
									1.519,
									-0.049,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.175
								},
								i: {
									x: 0.833,
									y: 0.841
								},
								s: [
									365.504,
									420.683
								],
								t: 53.946,
								ti: [
									-1.264,
									0.084,
									0
								],
								to: [
									1.386,
									-0.069,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.174
								},
								i: {
									x: 0.833,
									y: 0.842
								},
								s: [
									369.472,
									420.452
								],
								t: 55.944,
								ti: [
									-1.151,
									0.096,
									0
								],
								to: [
									1.264,
									-0.084,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.172
								},
								i: {
									x: 0.833,
									y: 0.844
								},
								s: [
									373.088,
									420.182
								],
								t: 57.942,
								ti: [
									-1.046,
									0.107,
									0
								],
								to: [
									1.151,
									-0.096,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.172
								},
								i: {
									x: 0.833,
									y: 0.844
								},
								s: [
									376.379,
									419.878
								],
								t: 59.94,
								ti: [
									-0.947,
									0.118,
									0
								],
								to: [
									1.046,
									-0.107,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.169
								},
								i: {
									x: 0.833,
									y: 0.845
								},
								s: [
									379.365,
									419.542
								],
								t: 61.938,
								ti: [
									-0.856,
									0.124,
									0
								],
								to: [
									0.947,
									-0.118,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.169
								},
								i: {
									x: 0.833,
									y: 0.847
								},
								s: [
									382.063,
									419.172
								],
								t: 63.936,
								ti: [
									-0.773,
									0.118,
									0
								],
								to: [
									0.856,
									-0.124,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.17
								},
								i: {
									x: 0.833,
									y: 0.848
								},
								s: [
									384.499,
									418.801
								],
								t: 65.934,
								ti: [
									-0.697,
									0.107,
									0
								],
								to: [
									0.773,
									-0.118,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.17
								},
								i: {
									x: 0.833,
									y: 0.848
								},
								s: [
									386.7,
									418.464
								],
								t: 67.932,
								ti: [
									-0.626,
									0.097,
									0
								],
								to: [
									0.697,
									-0.107,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.17
								},
								i: {
									x: 0.833,
									y: 0.848
								},
								s: [
									388.681,
									418.159
								],
								t: 69.93,
								ti: [
									-0.561,
									0.088,
									0
								],
								to: [
									0.626,
									-0.097,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.171
								},
								i: {
									x: 0.833,
									y: 0.849
								},
								s: [
									390.459,
									417.883
								],
								t: 71.928,
								ti: [
									-0.5,
									0.079,
									0
								],
								to: [
									0.561,
									-0.088,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.171
								},
								i: {
									x: 0.833,
									y: 0.849
								},
								s: [
									392.047,
									417.633
								],
								t: 73.926,
								ti: [
									-0.443,
									0.072,
									0
								],
								to: [
									0.5,
									-0.079,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.171
								},
								i: {
									x: 0.833,
									y: 0.85
								},
								s: [
									393.458,
									417.406
								],
								t: 75.924,
								ti: [
									-0.39,
									0.066,
									0
								],
								to: [
									0.443,
									-0.072,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.169
								},
								i: {
									x: 0.833,
									y: 0.85
								},
								s: [
									394.704,
									417.199
								],
								t: 77.922,
								ti: [
									-0.34,
									0.061,
									0
								],
								to: [
									0.39,
									-0.066,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.17
								},
								i: {
									x: 0.833,
									y: 0.854
								},
								s: [
									395.795,
									417.009
								],
								t: 79.92,
								ti: [
									-0.293,
									0.057,
									0
								],
								to: [
									0.34,
									-0.061,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.168
								},
								i: {
									x: 0.833,
									y: 0.855
								},
								s: [
									396.741,
									416.833
								],
								t: 81.917,
								ti: [
									-0.249,
									0.053,
									0
								],
								to: [
									0.293,
									-0.057,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.169
								},
								i: {
									x: 0.833,
									y: 0.859
								},
								s: [
									397.551,
									416.669
								],
								t: 83.915,
								ti: [
									-0.207,
									0.05,
									0
								],
								to: [
									0.249,
									-0.053,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.166
								},
								i: {
									x: 0.833,
									y: 0.864
								},
								s: [
									398.233,
									416.514
								],
								t: 85.913,
								ti: [
									-0.168,
									0.048,
									0
								],
								to: [
									0.207,
									-0.05,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.161
								},
								i: {
									x: 0.833,
									y: 0.871
								},
								s: [
									398.794,
									416.367
								],
								t: 87.911,
								ti: [
									-0.132,
									0.046,
									0
								],
								to: [
									0.168,
									-0.048,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.151
								},
								i: {
									x: 0.833,
									y: 0.884
								},
								s: [
									399.242,
									416.225
								],
								t: 89.909,
								ti: [
									-0.097,
									0.045,
									0
								],
								to: [
									0.132,
									-0.046,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.129
								},
								i: {
									x: 0.833,
									y: 0.905
								},
								s: [
									399.584,
									416.088
								],
								t: 91.907,
								ti: [
									-0.064,
									0.044,
									0
								],
								to: [
									0.097,
									-0.045,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.083
								},
								i: {
									x: 0.833,
									y: 0.941
								},
								s: [
									399.824,
									415.954
								],
								t: 93.905,
								ti: [
									-0.034,
									0.043,
									0
								],
								to: [
									0.064,
									-0.044,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.013
								},
								i: {
									x: 0.833,
									y: 0.99
								},
								s: [
									399.97,
									415.824
								],
								t: 95.903,
								ti: [
									-0.012,
									0.044,
									0
								],
								to: [
									0.034,
									-0.043,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									400.026,
									415.696
								],
								t: 97.901,
								ti: [
									-6e-3,
									0.049,
									0
								],
								to: [
									0.012,
									-0.044,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									400.041,
									415.559
								],
								t: 99.899,
								ti: [
									-8e-3,
									0.056,
									0
								],
								to: [
									0.006,
									-0.049,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.001
								},
								i: {
									x: 0.833,
									y: 0.999
								},
								s: [
									400.063,
									415.401
								],
								t: 101.897,
								ti: [
									-0.011,
									0.062,
									0
								],
								to: [
									0.008,
									-0.056,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.001
								},
								i: {
									x: 0.833,
									y: 0.999
								},
								s: [
									400.091,
									415.224
								],
								t: 103.895,
								ti: [
									-0.014,
									0.066,
									0
								],
								to: [
									0.011,
									-0.062,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.002
								},
								i: {
									x: 0.833,
									y: 0.998
								},
								s: [
									400.129,
									415.031
								],
								t: 105.893,
								ti: [
									-0.017,
									0.07,
									0
								],
								to: [
									0.014,
									-0.066,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.003
								},
								i: {
									x: 0.833,
									y: 0.997
								},
								s: [
									400.175,
									414.825
								],
								t: 107.891,
								ti: [
									-0.021,
									0.073,
									0
								],
								to: [
									0.017,
									-0.07,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.004
								},
								i: {
									x: 0.833,
									y: 0.996
								},
								s: [
									400.232,
									414.61
								],
								t: 109.889,
								ti: [
									-0.025,
									0.074,
									0
								],
								to: [
									0.021,
									-0.073,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.007
								},
								i: {
									x: 0.833,
									y: 0.993
								},
								s: [
									400.301,
									414.389
								],
								t: 111.887,
								ti: [
									-0.029,
									0.073,
									0
								],
								to: [
									0.025,
									-0.074,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.01
								},
								i: {
									x: 0.833,
									y: 0.99
								},
								s: [
									400.382,
									414.168
								],
								t: 113.885,
								ti: [
									-0.034,
									0.071,
									0
								],
								to: [
									0.029,
									-0.073,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.017
								},
								i: {
									x: 0.833,
									y: 0.983
								},
								s: [
									400.476,
									413.95
								],
								t: 115.883,
								ti: [
									-0.018,
									0.035,
									0
								],
								to: [
									0.034,
									-0.071,
									0
								]
							},
							{
								s: [
									400.585,
									413.741
								],
								t: 117.881
							}
						]
					},
					r: {
						a: 0,
						k: 92
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									0
								],
								t: 17.982
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 27.972
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 71.928
							},
							{
								s: [
									0
								],
								t: 103.895
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "Polystar 1",
						it: [
							{
								ty: "sr",
								nm: "Polystar Path 1",
								d: 1,
								pt: {
									a: 0,
									k: 3
								},
								p: {
									a: 0,
									k: [
										6,
										32
									]
								},
								or: {
									a: 0,
									k: 6.599
								},
								os: {
									a: 0,
									k: 0
								},
								r: {
									a: 0,
									k: 0
								},
								sy: 2
							},
							{
								ty: "fl",
								nm: "Fill 1",
								c: {
									a: 0,
									k: [
										0.322,
										0.624,
										0.988
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										-7.382,
										-25.677
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 5
			},
			{
				ty: 4,
				nm: "Shape Layer 65",
				sr: 1,
				st: 38.961,
				op: 149.85,
				ip: 38.961,
				ln: "6957",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									111.822,
									109.374
								],
								t: 38.961
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									100.055,
									106.422
								],
								t: 40.959
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									97.093,
									40.951
								],
								t: 42.957
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									67.613,
									71.247
								],
								t: 44.955
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									79.872,
									109.348
								],
								t: 46.953
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									101.054,
									94.428
								],
								t: 48.951
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									106.979,
									137.485
								],
								t: 50.949
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									85.798,
									101.174
								],
								t: 52.947
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									88.947,
									113.411
								],
								t: 54.945
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									86.793,
									131.596
								],
								t: 56.943
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									106.377,
									110.603
								],
								t: 58.941
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									104.74,
									50.192
								],
								t: 60.939
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									75.287,
									93.627
								],
								t: 62.937
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									57.971,
									102.957
								],
								t: 64.935
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									48.983,
									104.599
								],
								t: 66.933
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									48.677,
									103.694
								],
								t: 68.931
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									67.607,
									107.546
								],
								t: 70.929
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									93.956,
									61.633
								],
								t: 72.927
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									135.372,
									117.12
								],
								t: 74.925
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									94.654,
									82.761
								],
								t: 76.923
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									85.351,
									85.606
								],
								t: 78.921
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									87.506,
									70.455
								],
								t: 80.919
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									107.432,
									104.297
								],
								t: 82.917
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									140.473,
									106.399
								],
								t: 84.915
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									118.147,
									128.441
								],
								t: 86.913
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									84.776,
									65.43
								],
								t: 88.911
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									105.029,
									77.29
								],
								t: 90.909
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									91.068,
									48.266
								],
								t: 92.907
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									50.228,
									37.635
								],
								t: 94.905
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									54.329,
									100.336
								],
								t: 96.903
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									67.613,
									90.964
								],
								t: 98.901
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									81.902,
									93.51
								],
								t: 100.899
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									25.699,
									89.858
								],
								t: 102.896
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									51.156,
									75.74
								],
								t: 104.894
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									91.35,
									60.958
								],
								t: 106.892
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									62.734,
									57.409
								],
								t: 108.89
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									70.32,
									67.319
								],
								t: 110.888
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									14.17,
									58.838
								],
								t: 112.886
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									28.636,
									19.113
								],
								t: 114.884
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									32.23,
									22.336
								],
								t: 116.882
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									14.851,
									31.15
								],
								t: 118.88
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									4.812,
									10.283
								],
								t: 120.878
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									25.925,
									32.587
								],
								t: 122.876
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									30.453,
									9.9
								],
								t: 124.874
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									21.826,
									85.625
								],
								t: 126.872
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									9.608,
									24.619
								],
								t: 128.87
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-1.289,
									66.096
								],
								t: 130.868
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-33.054,
									59.758
								],
								t: 132.866
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									7.239,
									14.644
								],
								t: 134.864
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									44.549,
									12.547
								],
								t: 136.862
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									40.492,
									17.184
								],
								t: 138.86
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									9.161,
									-7.703
								],
								t: 140.858
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									7.764,
									16.458
								],
								t: 142.856
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									36.594,
									-26.534
								],
								t: 144.854
							},
							{
								s: [
									30.332,
									11.798
								],
								t: 146.852
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.085
								},
								i: {
									x: 0.833,
									y: 0.799
								},
								s: [
									268.501,
									303.894
								],
								t: 38.961,
								ti: [
									-1.332,
									1.601,
									0
								],
								to: [
									0.373,
									-0.267,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.017
								},
								i: {
									x: 0.833,
									y: 0.963
								},
								s: [
									270.738,
									302.29
								],
								t: 40.959,
								ti: [
									1.952,
									1.768,
									0
								],
								to: [
									1.332,
									-1.601,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									276.491,
									294.286
								],
								t: 42.957,
								ti: [
									6.31,
									0.166,
									0
								],
								to: [
									-1.952,
									-1.768,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									259.026,
									291.685
								],
								t: 44.955,
								ti: [
									6.364,
									-0.502,
									0
								],
								to: [
									-6.31,
									-0.166,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									238.628,
									293.288
								],
								t: 46.953,
								ti: [
									5.435,
									-0.368,
									0
								],
								to: [
									-6.364,
									0.502,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									220.844,
									294.694
								],
								t: 48.951,
								ti: [
									4.549,
									-0.177,
									0
								],
								to: [
									-5.435,
									0.368,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									206.017,
									295.497
								],
								t: 50.949,
								ti: [
									3.853,
									-0.014,
									0
								],
								to: [
									-4.549,
									0.177,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									193.549,
									295.758
								],
								t: 52.947,
								ti: [
									3.314,
									0.117,
									0
								],
								to: [
									-3.853,
									0.014,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									182.897,
									295.583
								],
								t: 54.945,
								ti: [
									2.886,
									0.223,
									0
								],
								to: [
									-3.314,
									-0.117,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									173.668,
									295.056
								],
								t: 56.943,
								ti: [
									2.537,
									0.31,
									0
								],
								to: [
									-2.886,
									-0.223,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									165.584,
									294.243
								],
								t: 58.941,
								ti: [
									2.246,
									0.383,
									0
								],
								to: [
									-2.537,
									-0.31,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									158.446,
									293.194
								],
								t: 60.939,
								ti: [
									2.001,
									0.441,
									0
								],
								to: [
									-2.246,
									-0.383,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									152.105,
									291.947
								],
								t: 62.937,
								ti: [
									1.789,
									0.485,
									0
								],
								to: [
									-2.001,
									-0.441,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									146.441,
									290.551
								],
								t: 64.935,
								ti: [
									1.601,
									0.519,
									0
								],
								to: [
									-1.789,
									-0.485,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									141.373,
									289.038
								],
								t: 66.933,
								ti: [
									1.435,
									0.544,
									0
								],
								to: [
									-1.601,
									-0.519,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									136.833,
									287.437
								],
								t: 68.931,
								ti: [
									1.285,
									0.562,
									0
								],
								to: [
									-1.435,
									-0.544,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									132.765,
									285.771
								],
								t: 70.929,
								ti: [
									1.15,
									0.573,
									0
								],
								to: [
									-1.285,
									-0.562,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									129.121,
									284.063
								],
								t: 72.927,
								ti: [
									1.027,
									0.578,
									0
								],
								to: [
									-1.15,
									-0.573,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									125.863,
									282.331
								],
								t: 74.925,
								ti: [
									0.915,
									0.576,
									0
								],
								to: [
									-1.027,
									-0.578,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									122.957,
									280.597
								],
								t: 76.923,
								ti: [
									0.814,
									0.569,
									0
								],
								to: [
									-0.915,
									-0.576,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									120.371,
									278.877
								],
								t: 78.921,
								ti: [
									0.721,
									0.558,
									0
								],
								to: [
									-0.814,
									-0.569,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									118.075,
									277.184
								],
								t: 80.919,
								ti: [
									0.637,
									0.542,
									0
								],
								to: [
									-0.721,
									-0.558,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									116.044,
									275.532
								],
								t: 82.917,
								ti: [
									0.56,
									0.523,
									0
								],
								to: [
									-0.637,
									-0.542,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									114.254,
									273.931
								],
								t: 84.915,
								ti: [
									0.49,
									0.502,
									0
								],
								to: [
									-0.56,
									-0.523,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									112.684,
									272.392
								],
								t: 86.913,
								ti: [
									0.427,
									0.478,
									0
								],
								to: [
									-0.49,
									-0.502,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									111.312,
									270.921
								],
								t: 88.911,
								ti: [
									0.369,
									0.453,
									0
								],
								to: [
									-0.427,
									-0.478,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									110.122,
									269.523
								],
								t: 90.909,
								ti: [
									0.317,
									0.426,
									0
								],
								to: [
									-0.369,
									-0.453,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									109.095,
									268.204
								],
								t: 92.907,
								ti: [
									0.27,
									0.399,
									0
								],
								to: [
									-0.317,
									-0.426,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									108.219,
									266.966
								],
								t: 94.905,
								ti: [
									0.226,
									0.37,
									0
								],
								to: [
									-0.27,
									-0.399,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									107.478,
									265.812
								],
								t: 96.903,
								ti: [
									0.186,
									0.342,
									0
								],
								to: [
									-0.226,
									-0.37,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									106.862,
									264.743
								],
								t: 98.901,
								ti: [
									0.15,
									0.313,
									0
								],
								to: [
									-0.186,
									-0.342,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									106.36,
									263.762
								],
								t: 100.899,
								ti: [
									0.117,
									0.283,
									0
								],
								to: [
									-0.15,
									-0.313,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									105.962,
									262.868
								],
								t: 102.896,
								ti: [
									0.086,
									0.254,
									0
								],
								to: [
									-0.117,
									-0.283,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									105.66,
									262.062
								],
								t: 104.894,
								ti: [
									0.058,
									0.224,
									0
								],
								to: [
									-0.086,
									-0.254,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									105.445,
									261.346
								],
								t: 106.892,
								ti: [
									0.032,
									0.194,
									0
								],
								to: [
									-0.058,
									-0.224,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									105.312,
									260.718
								],
								t: 108.89,
								ti: [
									0.008,
									0.164,
									0
								],
								to: [
									-0.032,
									-0.194,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									105.253,
									260.18
								],
								t: 110.888,
								ti: [
									-0.014,
									0.135,
									0
								],
								to: [
									-8e-3,
									-0.164,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.001
								},
								i: {
									x: 0.833,
									y: 0.999
								},
								s: [
									105.263,
									259.732
								],
								t: 112.886,
								ti: [
									-0.034,
									0.104,
									0
								],
								to: [
									0.014,
									-0.135,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.015
								},
								i: {
									x: 0.833,
									y: 0.987
								},
								s: [
									105.336,
									259.373
								],
								t: 114.884,
								ti: [
									-0.052,
									0.074,
									0
								],
								to: [
									0.034,
									-0.104,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.066
								},
								i: {
									x: 0.833,
									y: 0.941
								},
								s: [
									105.467,
									259.105
								],
								t: 116.882,
								ti: [
									-0.065,
									0.05,
									0
								],
								to: [
									0.052,
									-0.074,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.112
								},
								i: {
									x: 0.833,
									y: 0.895
								},
								s: [
									105.65,
									258.927
								],
								t: 118.88,
								ti: [
									-0.069,
									0.036,
									0
								],
								to: [
									0.065,
									-0.05,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.129
								},
								i: {
									x: 0.833,
									y: 0.888
								},
								s: [
									105.86,
									258.807
								],
								t: 120.878,
								ti: [
									-0.062,
									0.029,
									0
								],
								to: [
									0.069,
									-0.036,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.136
								},
								i: {
									x: 0.833,
									y: 0.895
								},
								s: [
									106.065,
									258.712
								],
								t: 122.876,
								ti: [
									-0.047,
									0.024,
									0
								],
								to: [
									0.062,
									-0.029,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.13
								},
								i: {
									x: 0.833,
									y: 0.91
								},
								s: [
									106.232,
									258.632
								],
								t: 124.874,
								ti: [
									-0.031,
									0.02,
									0
								],
								to: [
									0.047,
									-0.024,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.111
								},
								i: {
									x: 0.833,
									y: 0.936
								},
								s: [
									106.349,
									258.566
								],
								t: 126.872,
								ti: [
									-0.015,
									0.014,
									0
								],
								to: [
									0.031,
									-0.02,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.033
								},
								i: {
									x: 0.833,
									y: 0.98
								},
								s: [
									106.418,
									258.515
								],
								t: 128.87,
								ti: [
									0.001,
									0.009,
									0
								],
								to: [
									0.015,
									-0.014,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									106.44,
									258.479
								],
								t: 130.868,
								ti: [
									0.016,
									0.003,
									0
								],
								to: [
									-1e-3,
									-9e-3,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									106.414,
									258.46
								],
								t: 132.866,
								ti: [
									0.031,
									-3e-3,
									0
								],
								to: [
									-0.016,
									-3e-3,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									106.343,
									258.459
								],
								t: 134.864,
								ti: [
									0.045,
									-8e-3,
									0
								],
								to: [
									-0.031,
									0.003,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									106.228,
									258.475
								],
								t: 136.862,
								ti: [
									0.059,
									-0.014,
									0
								],
								to: [
									-0.045,
									0.008,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									106.07,
									258.51
								],
								t: 138.86,
								ti: [
									0.072,
									-0.02,
									0
								],
								to: [
									-0.059,
									0.014,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									105.873,
									258.562
								],
								t: 140.858,
								ti: [
									0.084,
									-0.026,
									0
								],
								to: [
									-0.072,
									0.02,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									105.639,
									258.632
								],
								t: 142.856,
								ti: [
									0.095,
									-0.032,
									0
								],
								to: [
									-0.084,
									0.026,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									105.369,
									258.719
								],
								t: 144.854,
								ti: [
									0.05,
									-0.017,
									0
								],
								to: [
									-0.095,
									0.032,
									0
								]
							},
							{
								s: [
									105.069,
									258.823
								],
								t: 146.852
							}
						]
					},
					r: {
						a: 0,
						k: 92
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									0
								],
								t: 38.961
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 48.951
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 92.907
							},
							{
								s: [
									0
								],
								t: 124.874
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "Polystar 1",
						it: [
							{
								ty: "sr",
								nm: "Polystar Path 1",
								d: 1,
								pt: {
									a: 0,
									k: 3
								},
								p: {
									a: 0,
									k: [
										6,
										32
									]
								},
								or: {
									a: 0,
									k: 6.599
								},
								os: {
									a: 0,
									k: 0
								},
								r: {
									a: 0,
									k: 0
								},
								sy: 2
							},
							{
								ty: "fl",
								nm: "Fill 1",
								c: {
									a: 0,
									k: [
										0.322,
										0.624,
										0.988
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										-7.382,
										-25.677
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 6
			},
			{
				ty: 4,
				nm: "Shape Layer 64",
				sr: 1,
				st: 1.998,
				op: 149.85,
				ip: 1.998,
				ln: "6956",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									88.706,
									125.309
								],
								t: 1.998
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									101.05,
									65.647
								],
								t: 3.996
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									64.822,
									119.625
								],
								t: 5.994
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									95.37,
									85.974
								],
								t: 7.992
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									130.225,
									63.782
								],
								t: 9.99
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									82.767,
									137.754
								],
								t: 11.988
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									95.438,
									114.769
								],
								t: 13.986
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									103.2,
									80.591
								],
								t: 15.984
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									90.818,
									98.938
								],
								t: 17.982
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									35.459,
									109.792
								],
								t: 19.98
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									111.828,
									112.627
								],
								t: 21.978
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									66.113,
									132.396
								],
								t: 23.976
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									25.062,
									87.733
								],
								t: 25.974
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									107.997,
									65.085
								],
								t: 27.972
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									91.212,
									67.15
								],
								t: 29.97
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									84.699,
									52.844
								],
								t: 31.968
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									117.811,
									115.589
								],
								t: 33.966
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									116.527,
									92.87
								],
								t: 35.964
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									118.433,
									95.846
								],
								t: 37.962
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									77.764,
									57.746
								],
								t: 39.96
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									70.59,
									60.792
								],
								t: 41.958
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									112.827,
									65.643
								],
								t: 43.956
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									139.959,
									82.972
								],
								t: 45.954
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									89.044,
									39.953
								],
								t: 47.952
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									61.106,
									115.024
								],
								t: 49.95
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									41.52,
									141.346
								],
								t: 51.948
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									68.262,
									107.246
								],
								t: 53.946
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									65.317,
									84.613
								],
								t: 55.944
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									106.651,
									57.805
								],
								t: 57.942
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									66.005,
									65.265
								],
								t: 59.94
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									67.009,
									46.429
								],
								t: 61.938
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									66.639,
									51.274
								],
								t: 63.936
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									54.923,
									71.216
								],
								t: 65.933
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									65.427,
									35.22
								],
								t: 67.931
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									82.893,
									37.183
								],
								t: 69.929
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									50.525,
									41.333
								],
								t: 71.927
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									35.563,
									32.66
								],
								t: 73.925
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									33.685,
									23.422
								],
								t: 75.923
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									59.517,
									70.825
								],
								t: 77.921
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									68.226,
									22.181
								],
								t: 79.919
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									53.746,
									26.302
								],
								t: 81.917
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									62.499,
									-7.882
								],
								t: 83.915
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									31.128,
									3.701
								],
								t: 85.913
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-0.586,
									59.702
								],
								t: 87.911
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									2.703,
									25.328
								],
								t: 89.909
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-10.892,
									49.534
								],
								t: 91.907
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									24.109,
									12.637
								],
								t: 93.905
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									15.151,
									21.155
								],
								t: 95.903
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									8.06,
									16.479
								],
								t: 97.901
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									61.168,
									27.875
								],
								t: 99.899
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									25.413,
									-14.304
								],
								t: 101.897
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									10.106,
									8.552
								],
								t: 103.895
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									32.24,
									5.058
								],
								t: 105.893
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									29.528,
									36.767
								],
								t: 107.891
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									26.015,
									30.226
								],
								t: 109.889
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									25.151,
									18.362
								],
								t: 111.887
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									24.725,
									54.585
								],
								t: 113.885
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									23.696,
									35.402
								],
								t: 115.883
							},
							{
								s: [
									33.602,
									11.392
								],
								t: 117.881
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.07
								},
								i: {
									x: 0.833,
									y: 0.848
								},
								s: [
									270.415,
									303.961
								],
								t: 1.998,
								ti: [
									-1.389,
									1.063,
									0
								],
								to: [
									0.303,
									-0.268,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.054
								},
								i: {
									x: 0.833,
									y: 0.898
								},
								s: [
									272.233,
									302.354
								],
								t: 3.996,
								ti: [
									-2.915,
									0.504,
									0
								],
								to: [
									1.389,
									-1.063,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.117
								},
								i: {
									x: 0.833,
									y: 0.837
								},
								s: [
									278.751,
									297.585
								],
								t: 5.994,
								ti: [
									-1.552,
									-2.903,
									0
								],
								to: [
									2.915,
									-0.504,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									289.724,
									299.332
								],
								t: 7.992,
								ti: [
									0.807,
									-4.867,
									0
								],
								to: [
									1.552,
									2.903,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									288.065,
									315.004
								],
								t: 9.99,
								ti: [
									1.017,
									-4.14,
									0
								],
								to: [
									-0.807,
									4.867,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									284.884,
									328.537
								],
								t: 11.988,
								ti: [
									0.905,
									-3.485,
									0
								],
								to: [
									-1.017,
									4.14,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									281.965,
									339.842
								],
								t: 13.986,
								ti: [
									0.776,
									-2.987,
									0
								],
								to: [
									-0.905,
									3.485,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									279.455,
									349.449
								],
								t: 15.984,
								ti: [
									0.667,
									-2.607,
									0
								],
								to: [
									-0.776,
									2.987,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									277.308,
									357.764
								],
								t: 17.982,
								ti: [
									0.578,
									-2.312,
									0
								],
								to: [
									-0.667,
									2.607,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									275.455,
									365.094
								],
								t: 19.98,
								ti: [
									0.505,
									-2.074,
									0
								],
								to: [
									-0.578,
									2.312,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									273.842,
									371.638
								],
								t: 21.978,
								ti: [
									0.444,
									-1.876,
									0
								],
								to: [
									-0.505,
									2.074,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									272.427,
									377.536
								],
								t: 23.976,
								ti: [
									0.393,
									-1.708,
									0
								],
								to: [
									-0.444,
									1.876,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									271.178,
									382.891
								],
								t: 25.974,
								ti: [
									0.349,
									-1.562,
									0
								],
								to: [
									-0.393,
									1.708,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									270.071,
									387.781
								],
								t: 27.972,
								ti: [
									0.31,
									-1.434,
									0
								],
								to: [
									-0.349,
									1.562,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									269.086,
									392.264
								],
								t: 29.97,
								ti: [
									0.275,
									-1.32,
									0
								],
								to: [
									-0.31,
									1.434,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									268.211,
									396.386
								],
								t: 31.968,
								ti: [
									0.243,
									-1.215,
									0
								],
								to: [
									-0.275,
									1.32,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									267.436,
									400.181
								],
								t: 33.966,
								ti: [
									0.213,
									-1.118,
									0
								],
								to: [
									-0.243,
									1.215,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									266.752,
									403.676
								],
								t: 35.964,
								ti: [
									0.185,
									-1.028,
									0
								],
								to: [
									-0.213,
									1.118,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									266.156,
									406.891
								],
								t: 37.962,
								ti: [
									0.158,
									-0.941,
									0
								],
								to: [
									-0.185,
									1.028,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									265.642,
									409.842
								],
								t: 39.96,
								ti: [
									0.131,
									-0.859,
									0
								],
								to: [
									-0.158,
									0.941,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									265.209,
									412.54
								],
								t: 41.958,
								ti: [
									0.105,
									-0.779,
									0
								],
								to: [
									-0.131,
									0.859,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									264.855,
									414.996
								],
								t: 43.956,
								ti: [
									0.078,
									-0.702,
									0
								],
								to: [
									-0.105,
									0.779,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									264.581,
									417.216
								],
								t: 45.954,
								ti: [
									0.051,
									-0.625,
									0
								],
								to: [
									-0.078,
									0.702,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									264.386,
									419.205
								],
								t: 47.952,
								ti: [
									0.024,
									-0.55,
									0
								],
								to: [
									-0.051,
									0.625,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									264.272,
									420.968
								],
								t: 49.95,
								ti: [
									-4e-3,
									-0.475,
									0
								],
								to: [
									-0.024,
									0.55,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									264.241,
									422.506
								],
								t: 51.948,
								ti: [
									-0.032,
									-0.401,
									0
								],
								to: [
									0.004,
									0.475,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									264.295,
									423.82
								],
								t: 53.946,
								ti: [
									-0.062,
									-0.326,
									0
								],
								to: [
									0.032,
									0.401,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.003
								},
								i: {
									x: 0.833,
									y: 0.997
								},
								s: [
									264.435,
									424.912
								],
								t: 55.944,
								ti: [
									-0.092,
									-0.251,
									0
								],
								to: [
									0.062,
									0.326,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.017
								},
								i: {
									x: 0.833,
									y: 0.986
								},
								s: [
									264.666,
									425.779
								],
								t: 57.942,
								ti: [
									-0.123,
									-0.178,
									0
								],
								to: [
									0.092,
									0.251,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.061
								},
								i: {
									x: 0.833,
									y: 0.947
								},
								s: [
									264.99,
									426.419
								],
								t: 59.94,
								ti: [
									-0.144,
									-0.125,
									0
								],
								to: [
									0.123,
									0.178,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.094
								},
								i: {
									x: 0.833,
									y: 0.911
								},
								s: [
									265.403,
									426.848
								],
								t: 61.938,
								ti: [
									-0.154,
									-0.094,
									0
								],
								to: [
									0.144,
									0.125,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.12
								},
								i: {
									x: 0.833,
									y: 0.885
								},
								s: [
									265.856,
									427.168
								],
								t: 63.936,
								ti: [
									-0.158,
									-0.068,
									0
								],
								to: [
									0.154,
									0.094,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.142
								},
								i: {
									x: 0.833,
									y: 0.865
								},
								s: [
									266.328,
									427.409
								],
								t: 65.933,
								ti: [
									-0.158,
									-0.046,
									0
								],
								to: [
									0.158,
									0.068,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.159
								},
								i: {
									x: 0.833,
									y: 0.85
								},
								s: [
									266.806,
									427.579
								],
								t: 67.931,
								ti: [
									-0.155,
									-0.026,
									0
								],
								to: [
									0.158,
									0.046,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.168
								},
								i: {
									x: 0.833,
									y: 0.841
								},
								s: [
									267.278,
									427.686
								],
								t: 69.929,
								ti: [
									-0.148,
									-8e-3,
									0
								],
								to: [
									0.155,
									0.026,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.172
								},
								i: {
									x: 0.833,
									y: 0.839
								},
								s: [
									267.736,
									427.736
								],
								t: 71.927,
								ti: [
									-0.139,
									0.007,
									0
								],
								to: [
									0.148,
									0.008,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.17
								},
								i: {
									x: 0.833,
									y: 0.843
								},
								s: [
									268.169,
									427.736
								],
								t: 73.925,
								ti: [
									-0.127,
									0.022,
									0
								],
								to: [
									0.139,
									-7e-3,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.159
								},
								i: {
									x: 0.833,
									y: 0.852
								},
								s: [
									268.571,
									427.692
								],
								t: 75.923,
								ti: [
									-0.114,
									0.034,
									0
								],
								to: [
									0.127,
									-0.022,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.141
								},
								i: {
									x: 0.833,
									y: 0.871
								},
								s: [
									268.934,
									427.607
								],
								t: 77.921,
								ti: [
									-0.098,
									0.046,
									0
								],
								to: [
									0.114,
									-0.034,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.115
								},
								i: {
									x: 0.833,
									y: 0.898
								},
								s: [
									269.252,
									427.486
								],
								t: 79.919,
								ti: [
									-0.081,
									0.051,
									0
								],
								to: [
									0.098,
									-0.046,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.098
								},
								i: {
									x: 0.833,
									y: 0.919
								},
								s: [
									269.522,
									427.333
								],
								t: 81.917,
								ti: [
									-0.064,
									0.046,
									0
								],
								to: [
									0.081,
									-0.051,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.102
								},
								i: {
									x: 0.833,
									y: 0.925
								},
								s: [
									269.74,
									427.18
								],
								t: 83.915,
								ti: [
									-0.047,
									0.035,
									0
								],
								to: [
									0.064,
									-0.046,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.098
								},
								i: {
									x: 0.833,
									y: 0.936
								},
								s: [
									269.907,
									427.059
								],
								t: 85.913,
								ti: [
									-0.029,
									0.025,
									0
								],
								to: [
									0.047,
									-0.035,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.08
								},
								i: {
									x: 0.833,
									y: 0.958
								},
								s: [
									270.02,
									426.97
								],
								t: 87.911,
								ti: [
									-0.011,
									0.015,
									0
								],
								to: [
									0.029,
									-0.025,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									270.079,
									426.911
								],
								t: 89.909,
								ti: [
									0.007,
									0.006,
									0
								],
								to: [
									0.011,
									-0.015,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									270.083,
									426.879
								],
								t: 91.907,
								ti: [
									0.025,
									-2e-3,
									0
								],
								to: [
									-7e-3,
									-6e-3,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									270.035,
									426.873
								],
								t: 93.905,
								ti: [
									0.041,
									-9e-3,
									0
								],
								to: [
									-0.025,
									0.002,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									269.935,
									426.889
								],
								t: 95.903,
								ti: [
									0.056,
									-0.014,
									0
								],
								to: [
									-0.041,
									0.009,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									269.788,
									426.925
								],
								t: 97.901,
								ti: [
									0.07,
									-0.019,
									0
								],
								to: [
									-0.056,
									0.014,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									269.597,
									426.976
								],
								t: 99.899,
								ti: [
									0.082,
									-0.022,
									0
								],
								to: [
									-0.07,
									0.019,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									269.367,
									427.038
								],
								t: 101.897,
								ti: [
									0.092,
									-0.023,
									0
								],
								to: [
									-0.082,
									0.022,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									269.104,
									427.106
								],
								t: 103.895,
								ti: [
									0.099,
									-0.022,
									0
								],
								to: [
									-0.092,
									0.023,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									268.815,
									427.175
								],
								t: 105.893,
								ti: [
									0.104,
									-0.02,
									0
								],
								to: [
									-0.099,
									0.022,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									268.508,
									427.24
								],
								t: 107.891,
								ti: [
									0.105,
									-0.015,
									0
								],
								to: [
									-0.104,
									0.02,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									268.192,
									427.293
								],
								t: 109.889,
								ti: [
									0.103,
									-8e-3,
									0
								],
								to: [
									-0.105,
									0.015,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									267.876,
									427.329
								],
								t: 111.887,
								ti: [
									0.098,
									0.002,
									0
								],
								to: [
									-0.103,
									0.008,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									267.571,
									427.341
								],
								t: 113.885,
								ti: [
									0.088,
									0.014,
									0
								],
								to: [
									-0.098,
									-2e-3,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									267.289,
									427.32
								],
								t: 115.883,
								ti: [
									0.041,
									0.01,
									0
								],
								to: [
									-0.088,
									-0.014,
									0
								]
							},
							{
								s: [
									267.042,
									427.258
								],
								t: 117.881
							}
						]
					},
					r: {
						a: 0,
						k: 92
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									0
								],
								t: 1.998
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 11.988
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 55.944
							},
							{
								s: [
									0
								],
								t: 87.911
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "Rectangle 1",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0.012,
												10.621
											],
											[
												-5.695,
												5.34
											],
											[
												-2.557,
												-7.377
											],
											[
												3.15,
												-2.096
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "Fill 1",
								c: {
									a: 0,
									k: [
										0.322,
										0.624,
										0.988
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										-3.421,
										4.043
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 7
			},
			{
				ty: 4,
				nm: "Shape Layer 63",
				sr: 1,
				st: 7.992,
				op: 149.85,
				ip: 7.992,
				ln: "6955",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									146.545,
									56.981
								],
								t: 7.992
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									102.654,
									113.791
								],
								t: 9.99
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									102.133,
									114.538
								],
								t: 11.988
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									115.051,
									67.711
								],
								t: 13.986
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									89.461,
									104.174
								],
								t: 15.984
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									44.049,
									120.312
								],
								t: 17.982
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									77.823,
									118.832
								],
								t: 19.98
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									107.747,
									119.743
								],
								t: 21.978
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									53.479,
									67.782
								],
								t: 23.976
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									113.921,
									99.393
								],
								t: 25.974
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									111.576,
									88.565
								],
								t: 27.972
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									55.899,
									36.375
								],
								t: 29.97
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									98.768,
									100.4
								],
								t: 31.968
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									81.873,
									108.568
								],
								t: 33.966
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									117.879,
									85.877
								],
								t: 35.964
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									94.849,
									58.578
								],
								t: 37.962
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									77.175,
									81.139
								],
								t: 39.96
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									102.134,
									95.906
								],
								t: 41.958
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									142.654,
									110.218
								],
								t: 43.956
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									111.887,
									49.352
								],
								t: 45.954
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									81.638,
									92.763
								],
								t: 47.952
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									38.028,
									132.048
								],
								t: 49.95
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									86.128,
									88.194
								],
								t: 51.948
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									68.431,
									76.37
								],
								t: 53.946
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									88.699,
									62.632
								],
								t: 55.944
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									46.98,
									59.998
								],
								t: 57.942
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									109.874,
									70.958
								],
								t: 59.94
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									96.114,
									55.137
								],
								t: 61.938
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									85.214,
									90.54
								],
								t: 63.936
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									80.545,
									35.132
								],
								t: 65.934
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									98.178,
									65.031
								],
								t: 67.932
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									40.533,
									60.003
								],
								t: 69.93
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									56.966,
									52.732
								],
								t: 71.927
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									47.335,
									25.638
								],
								t: 73.925
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									49.783,
									59.415
								],
								t: 75.923
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									54.761,
									18.968
								],
								t: 77.921
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									60.644,
									13.657
								],
								t: 79.919
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									50.471,
									7.064
								],
								t: 81.917
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									47.647,
									18.253
								],
								t: 83.915
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-15.426,
									58.31
								],
								t: 85.913
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									27.159,
									27.049
								],
								t: 87.911
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									21.997,
									13.425
								],
								t: 89.909
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									59.347,
									9.373
								],
								t: 91.907
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									54.352,
									8.634
								],
								t: 93.905
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									34.643,
									10.569
								],
								t: 95.903
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									67.47,
									-8.566
								],
								t: 97.901
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									34.991,
									-28.664
								],
								t: 99.899
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									20.908,
									-15.133
								],
								t: 101.897
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									21.531,
									-2.998
								],
								t: 103.895
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									3.556,
									37.39
								],
								t: 105.893
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-5.112,
									48.357
								],
								t: 107.891
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									37.958,
									65.386
								],
								t: 109.889
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									40.525,
									59.682
								],
								t: 111.887
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									42.972,
									53.735
								],
								t: 113.885
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									65.106,
									-1.291
								],
								t: 115.883
							},
							{
								s: [
									21.097,
									5.723
								],
								t: 117.881
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									267.904,
									308.221
								],
								t: 7.992,
								ti: [
									-0.406,
									2.013,
									0
								],
								to: [
									-0.062,
									-0.384,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.002
								},
								i: {
									x: 0.833,
									y: 0.995
								},
								s: [
									267.529,
									305.917
								],
								t: 9.99,
								ti: [
									-2.229,
									4.277,
									0
								],
								to: [
									0.406,
									-2.013,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.022
								},
								i: {
									x: 0.833,
									y: 0.97
								},
								s: [
									270.337,
									296.143
								],
								t: 11.988,
								ti: [
									-4.056,
									5.365,
									0
								],
								to: [
									2.229,
									-4.277,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.043
								},
								i: {
									x: 0.833,
									y: 0.958
								},
								s: [
									280.902,
									280.252
								],
								t: 13.986,
								ti: [
									-4.394,
									5.019,
									0
								],
								to: [
									4.056,
									-5.365,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.055
								},
								i: {
									x: 0.833,
									y: 0.954
								},
								s: [
									294.676,
									263.955
								],
								t: 15.984,
								ti: [
									-3.868,
									4.214,
									0
								],
								to: [
									4.394,
									-5.019,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.057
								},
								i: {
									x: 0.833,
									y: 0.952
								},
								s: [
									307.264,
									250.141
								],
								t: 17.982,
								ti: [
									-3.257,
									3.538,
									0
								],
								to: [
									3.868,
									-4.214,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.056
								},
								i: {
									x: 0.833,
									y: 0.952
								},
								s: [
									317.883,
									238.67
								],
								t: 19.98,
								ti: [
									-2.752,
									3.047,
									0
								],
								to: [
									3.257,
									-3.538,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.053
								},
								i: {
									x: 0.833,
									y: 0.954
								},
								s: [
									326.809,
									228.915
								],
								t: 21.978,
								ti: [
									-2.349,
									2.69,
									0
								],
								to: [
									2.752,
									-3.047,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.049
								},
								i: {
									x: 0.833,
									y: 0.957
								},
								s: [
									334.394,
									220.39
								],
								t: 23.976,
								ti: [
									-2.023,
									2.427,
									0
								],
								to: [
									2.349,
									-2.69,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.044
								},
								i: {
									x: 0.833,
									y: 0.96
								},
								s: [
									340.902,
									212.773
								],
								t: 25.974,
								ti: [
									-1.753,
									2.23,
									0
								],
								to: [
									2.023,
									-2.427,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.039
								},
								i: {
									x: 0.833,
									y: 0.965
								},
								s: [
									346.531,
									205.826
								],
								t: 27.972,
								ti: [
									-1.519,
									2.072,
									0
								],
								to: [
									1.753,
									-2.23,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.033
								},
								i: {
									x: 0.833,
									y: 0.969
								},
								s: [
									351.417,
									199.393
								],
								t: 29.97,
								ti: [
									-1.306,
									1.928,
									0
								],
								to: [
									1.519,
									-2.072,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.028
								},
								i: {
									x: 0.833,
									y: 0.974
								},
								s: [
									355.644,
									193.397
								],
								t: 31.968,
								ti: [
									-1.106,
									1.797,
									0
								],
								to: [
									1.306,
									-1.928,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.022
								},
								i: {
									x: 0.833,
									y: 0.98
								},
								s: [
									359.255,
									187.824
								],
								t: 33.966,
								ti: [
									-0.913,
									1.682,
									0
								],
								to: [
									1.106,
									-1.797,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.016
								},
								i: {
									x: 0.833,
									y: 0.986
								},
								s: [
									362.28,
									182.616
								],
								t: 35.964,
								ti: [
									-0.72,
									1.579,
									0
								],
								to: [
									0.913,
									-1.682,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.009
								},
								i: {
									x: 0.833,
									y: 0.991
								},
								s: [
									364.731,
									177.73
								],
								t: 37.962,
								ti: [
									-0.524,
									1.479,
									0
								],
								to: [
									0.72,
									-1.579,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.004
								},
								i: {
									x: 0.833,
									y: 0.996
								},
								s: [
									366.601,
									173.143
								],
								t: 39.96,
								ti: [
									-0.321,
									1.378,
									0
								],
								to: [
									0.524,
									-1.479,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.001
								},
								i: {
									x: 0.833,
									y: 0.999
								},
								s: [
									367.872,
									168.855
								],
								t: 41.958,
								ti: [
									-0.115,
									1.264,
									0
								],
								to: [
									0.321,
									-1.378,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									368.526,
									164.876
								],
								t: 43.956,
								ti: [
									0.083,
									1.13,
									0
								],
								to: [
									0.115,
									-1.264,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									368.561,
									161.269
								],
								t: 45.954,
								ti: [
									0.254,
									0.978,
									0
								],
								to: [
									-0.083,
									-1.13,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									368.028,
									158.096
								],
								t: 47.952,
								ti: [
									0.382,
									0.82,
									0
								],
								to: [
									-0.254,
									-0.978,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									367.038,
									155.4
								],
								t: 49.95,
								ti: [
									0.464,
									0.67,
									0
								],
								to: [
									-0.382,
									-0.82,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									365.735,
									153.176
								],
								t: 51.948,
								ti: [
									0.506,
									0.539,
									0
								],
								to: [
									-0.464,
									-0.67,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									364.254,
									151.378
								],
								t: 53.946,
								ti: [
									0.52,
									0.43,
									0
								],
								to: [
									-0.506,
									-0.539,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									362.7,
									149.94
								],
								t: 55.944,
								ti: [
									0.517,
									0.343,
									0
								],
								to: [
									-0.52,
									-0.43,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									361.136,
									148.795
								],
								t: 57.942,
								ti: [
									0.505,
									0.273,
									0
								],
								to: [
									-0.517,
									-0.343,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									359.597,
									147.883
								],
								t: 59.94,
								ti: [
									0.487,
									0.216,
									0
								],
								to: [
									-0.505,
									-0.273,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									358.105,
									147.16
								],
								t: 61.938,
								ti: [
									0.465,
									0.169,
									0
								],
								to: [
									-0.487,
									-0.216,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									356.676,
									146.589
								],
								t: 63.936,
								ti: [
									0.441,
									0.132,
									0
								],
								to: [
									-0.465,
									-0.169,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									355.317,
									146.143
								],
								t: 65.934,
								ti: [
									0.415,
									0.101,
									0
								],
								to: [
									-0.441,
									-0.132,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									354.033,
									145.799
								],
								t: 67.932,
								ti: [
									0.388,
									0.076,
									0
								],
								to: [
									-0.415,
									-0.101,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									352.827,
									145.538
								],
								t: 69.93,
								ti: [
									0.36,
									0.056,
									0
								],
								to: [
									-0.388,
									-0.076,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									351.704,
									145.343
								],
								t: 71.927,
								ti: [
									0.33,
									0.04,
									0
								],
								to: [
									-0.36,
									-0.056,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									350.668,
									145.203
								],
								t: 73.925,
								ti: [
									0.298,
									0.027,
									0
								],
								to: [
									-0.33,
									-0.04,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									349.724,
									145.104
								],
								t: 75.923,
								ti: [
									0.263,
									0.019,
									0
								],
								to: [
									-0.298,
									-0.027,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									348.882,
									145.038
								],
								t: 77.921,
								ti: [
									0.227,
									0.013,
									0
								],
								to: [
									-0.263,
									-0.019,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									348.144,
									144.993
								],
								t: 79.919,
								ti: [
									0.189,
									0.011,
									0
								],
								to: [
									-0.227,
									-0.013,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									347.517,
									144.959
								],
								t: 81.917,
								ti: [
									0.146,
									0.011,
									0
								],
								to: [
									-0.189,
									-0.011,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									347.011,
									144.929
								],
								t: 83.915,
								ti: [
									0.1,
									0.014,
									0
								],
								to: [
									-0.146,
									-0.011,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									346.639,
									144.893
								],
								t: 85.913,
								ti: [
									0.056,
									0.022,
									0
								],
								to: [
									-0.1,
									-0.014,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									346.413,
									144.843
								],
								t: 87.911,
								ti: [
									0.03,
									0.033,
									0
								],
								to: [
									-0.056,
									-0.022,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									346.304,
									144.761
								],
								t: 89.909,
								ti: [
									0.031,
									0.038,
									0
								],
								to: [
									-0.03,
									-0.033,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									346.234,
									144.648
								],
								t: 91.907,
								ti: [
									0.045,
									0.038,
									0
								],
								to: [
									-0.031,
									-0.038,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									346.12,
									144.534
								],
								t: 93.905,
								ti: [
									0.059,
									0.037,
									0
								],
								to: [
									-0.045,
									-0.038,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									345.962,
									144.422
								],
								t: 95.903,
								ti: [
									0.072,
									0.036,
									0
								],
								to: [
									-0.059,
									-0.037,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									345.764,
									144.313
								],
								t: 97.901,
								ti: [
									0.083,
									0.034,
									0
								],
								to: [
									-0.072,
									-0.036,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									345.53,
									144.207
								],
								t: 99.899,
								ti: [
									0.093,
									0.033,
									0
								],
								to: [
									-0.083,
									-0.034,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									345.264,
									144.107
								],
								t: 101.897,
								ti: [
									0.102,
									0.031,
									0
								],
								to: [
									-0.093,
									-0.033,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									344.97,
									144.011
								],
								t: 103.895,
								ti: [
									0.11,
									0.029,
									0
								],
								to: [
									-0.102,
									-0.031,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									344.65,
									143.922
								],
								t: 105.893,
								ti: [
									0.117,
									0.026,
									0
								],
								to: [
									-0.11,
									-0.029,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									344.308,
									143.839
								],
								t: 107.891,
								ti: [
									0.123,
									0.024,
									0
								],
								to: [
									-0.117,
									-0.026,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									343.947,
									143.764
								],
								t: 109.889,
								ti: [
									0.127,
									0.022,
									0
								],
								to: [
									-0.123,
									-0.024,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									343.572,
									143.695
								],
								t: 111.887,
								ti: [
									0.13,
									0.019,
									0
								],
								to: [
									-0.127,
									-0.022,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									343.185,
									143.634
								],
								t: 113.885,
								ti: [
									0.133,
									0.017,
									0
								],
								to: [
									-0.13,
									-0.019,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									342.79,
									143.581
								],
								t: 115.883,
								ti: [
									0.067,
									0.008,
									0
								],
								to: [
									-0.133,
									-0.017,
									0
								]
							},
							{
								s: [
									342.389,
									143.535
								],
								t: 117.881
							}
						]
					},
					r: {
						a: 0,
						k: 92
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									0
								],
								t: 7.992
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 17.982
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 61.938
							},
							{
								s: [
									0
								],
								t: 93.905
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "Rectangle 1",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0.012,
												10.621
											],
											[
												-5.695,
												5.34
											],
											[
												-2.557,
												-7.377
											],
											[
												3.15,
												-2.096
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "Fill 1",
								c: {
									a: 0,
									k: [
										0.137,
										0.459,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										-3.421,
										4.043
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 8
			},
			{
				ty: 4,
				nm: "Shape Layer 62",
				sr: 1,
				st: 23.976,
				op: 149.85,
				ip: 23.976,
				ln: "6954",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									88.213,
									98.042
								],
								t: 23.976
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									98.671,
									49.922
								],
								t: 25.974
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									54.098,
									71.655
								],
								t: 27.972
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									63.017,
									105.433
								],
								t: 29.97
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									59.185,
									119.254
								],
								t: 31.968
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									102.36,
									105.209
								],
								t: 33.966
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									79.066,
									71.811
								],
								t: 35.964
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									101.985,
									115.908
								],
								t: 37.962
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									105.84,
									113.791
								],
								t: 39.96
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									60.688,
									44.915
								],
								t: 41.958
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									90.735,
									61.894
								],
								t: 43.956
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									48.636,
									106.533
								],
								t: 45.954
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									110.804,
									104.766
								],
								t: 47.952
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									105.35,
									91.067
								],
								t: 49.95
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									112.726,
									102.388
								],
								t: 51.948
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									78.021,
									118.647
								],
								t: 53.946
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									123.499,
									128.748
								],
								t: 55.944
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									116.924,
									82.593
								],
								t: 57.942
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									102.179,
									95.418
								],
								t: 59.94
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									61.093,
									131.691
								],
								t: 61.938
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									97.755,
									79.275
								],
								t: 63.936
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									111.269,
									51.174
								],
								t: 65.934
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									98.597,
									85.374
								],
								t: 67.932
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									44.555,
									68.006
								],
								t: 69.93
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									83.792,
									66.311
								],
								t: 71.928
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									93.366,
									52.935
								],
								t: 73.926
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									80.351,
									77.978
								],
								t: 75.924
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									105.736,
									46.617
								],
								t: 77.922
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									119.231,
									66.597
								],
								t: 79.92
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									31.333,
									68.163
								],
								t: 81.918
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									32.821,
									63.516
								],
								t: 83.916
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									55.229,
									35.157
								],
								t: 85.914
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									53.579,
									43.75
								],
								t: 87.911
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									41.681,
									9.938
								],
								t: 89.909
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									65.338,
									25.314
								],
								t: 91.907
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									39.293,
									35.228
								],
								t: 93.905
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									71.909,
									22.453
								],
								t: 95.903
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-13.722,
									50.113
								],
								t: 97.901
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									12.165,
									54.928
								],
								t: 99.899
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									36.047,
									7.012
								],
								t: 101.897
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									75.273,
									-11.082
								],
								t: 103.895
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									68.05,
									17.747
								],
								t: 105.893
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									73.648,
									32.314
								],
								t: 107.891
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									69.641,
									-15.771
								],
								t: 109.889
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									32.387,
									-24.312
								],
								t: 111.887
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									31.664,
									-22.708
								],
								t: 113.885
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									31.682,
									0.419
								],
								t: 115.883
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-15.245,
									26.807
								],
								t: 117.881
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-2.957,
									39.841
								],
								t: 119.879
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									41.396,
									91.664
								],
								t: 121.877
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									48.828,
									48.327
								],
								t: 123.875
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									46.178,
									24.721
								],
								t: 125.873
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									72.828,
									8.231
								],
								t: 127.871
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									23.424,
									10.493
								],
								t: 129.869
							},
							{
								s: [
									-3.769,
									24.296
								],
								t: 131.867
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									274.616,
									306.243
								],
								t: 23.976,
								ti: [
									0.824,
									2.77,
									0
								],
								to: [
									-0.115,
									-0.59,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									273.925,
									302.703
								],
								t: 25.974,
								ti: [
									2.181,
									6.093,
									0
								],
								to: [
									-0.824,
									-2.77,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									269.674,
									289.624
								],
								t: 27.972,
								ti: [
									3.267,
									8.196,
									0
								],
								to: [
									-2.181,
									-6.093,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									260.838,
									266.142
								],
								t: 29.97,
								ti: [
									3.485,
									7.964,
									0
								],
								to: [
									-3.267,
									-8.196,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									250.074,
									240.449
								],
								t: 31.968,
								ti: [
									3.198,
									6.707,
									0
								],
								to: [
									-3.485,
									-7.964,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									239.929,
									218.357
								],
								t: 33.966,
								ti: [
									2.853,
									5.529,
									0
								],
								to: [
									-3.198,
									-6.707,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									230.887,
									200.209
								],
								t: 35.964,
								ti: [
									2.563,
									4.612,
									0
								],
								to: [
									-2.853,
									-5.529,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									222.813,
									185.182
								],
								t: 37.962,
								ti: [
									2.332,
									3.906,
									0
								],
								to: [
									-2.563,
									-4.612,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									215.51,
									172.535
								],
								t: 39.96,
								ti: [
									2.146,
									3.349,
									0
								],
								to: [
									-2.332,
									-3.906,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									208.822,
									161.746
								],
								t: 41.958,
								ti: [
									1.992,
									2.898,
									0
								],
								to: [
									-2.146,
									-3.349,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									202.636,
									152.442
								],
								t: 43.956,
								ti: [
									1.863,
									2.525,
									0
								],
								to: [
									-1.992,
									-2.898,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									196.868,
									144.357
								],
								t: 45.954,
								ti: [
									1.751,
									2.21,
									0
								],
								to: [
									-1.863,
									-2.525,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									191.458,
									137.291
								],
								t: 47.952,
								ti: [
									1.653,
									1.941,
									0
								],
								to: [
									-1.751,
									-2.21,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									186.36,
									131.094
								],
								t: 49.95,
								ti: [
									1.563,
									1.706,
									0
								],
								to: [
									-1.653,
									-1.941,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									181.542,
									125.648
								],
								t: 51.948,
								ti: [
									1.481,
									1.501,
									0
								],
								to: [
									-1.563,
									-1.706,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									176.98,
									120.856
								],
								t: 53.946,
								ti: [
									1.403,
									1.32,
									0
								],
								to: [
									-1.481,
									-1.501,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									172.656,
									116.64
								],
								t: 55.944,
								ti: [
									1.328,
									1.158,
									0
								],
								to: [
									-1.403,
									-1.32,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									168.561,
									112.936
								],
								t: 57.942,
								ti: [
									1.255,
									1.014,
									0
								],
								to: [
									-1.328,
									-1.158,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									164.687,
									109.689
								],
								t: 59.94,
								ti: [
									1.183,
									0.886,
									0
								],
								to: [
									-1.255,
									-1.014,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									161.03,
									106.849
								],
								t: 61.938,
								ti: [
									1.111,
									0.771,
									0
								],
								to: [
									-1.183,
									-0.886,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									157.59,
									104.374
								],
								t: 63.936,
								ti: [
									1.038,
									0.668,
									0
								],
								to: [
									-1.111,
									-0.771,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									154.367,
									102.223
								],
								t: 65.934,
								ti: [
									0.964,
									0.577,
									0
								],
								to: [
									-1.038,
									-0.668,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									151.363,
									100.364
								],
								t: 67.932,
								ti: [
									0.888,
									0.495,
									0
								],
								to: [
									-0.964,
									-0.577,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									148.583,
									98.763
								],
								t: 69.93,
								ti: [
									0.81,
									0.422,
									0
								],
								to: [
									-0.888,
									-0.495,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									146.035,
									97.394
								],
								t: 71.928,
								ti: [
									0.741,
									0.358,
									0
								],
								to: [
									-0.81,
									-0.422,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									143.723,
									96.23
								],
								t: 73.926,
								ti: [
									0.687,
									0.303,
									0
								],
								to: [
									-0.741,
									-0.358,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									141.59,
									95.244
								],
								t: 75.924,
								ti: [
									0.639,
									0.255,
									0
								],
								to: [
									-0.687,
									-0.303,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									139.604,
									94.413
								],
								t: 77.922,
								ti: [
									0.592,
									0.214,
									0
								],
								to: [
									-0.639,
									-0.255,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									137.759,
									93.715
								],
								t: 79.92,
								ti: [
									0.547,
									0.179,
									0
								],
								to: [
									-0.592,
									-0.214,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									136.052,
									93.13
								],
								t: 81.918,
								ti: [
									0.502,
									0.149,
									0
								],
								to: [
									-0.547,
									-0.179,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									134.48,
									92.643
								],
								t: 83.916,
								ti: [
									0.46,
									0.124,
									0
								],
								to: [
									-0.502,
									-0.149,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									133.038,
									92.238
								],
								t: 85.914,
								ti: [
									0.418,
									0.103,
									0
								],
								to: [
									-0.46,
									-0.124,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									131.723,
									91.901
								],
								t: 87.911,
								ti: [
									0.378,
									0.085,
									0
								],
								to: [
									-0.418,
									-0.103,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									130.53,
									91.622
								],
								t: 89.909,
								ti: [
									0.339,
									0.071,
									0
								],
								to: [
									-0.378,
									-0.085,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									129.457,
									91.39
								],
								t: 91.907,
								ti: [
									0.301,
									0.059,
									0
								],
								to: [
									-0.339,
									-0.071,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									128.499,
									91.197
								],
								t: 93.905,
								ti: [
									0.264,
									0.049,
									0
								],
								to: [
									-0.301,
									-0.059,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									127.654,
									91.037
								],
								t: 95.903,
								ti: [
									0.228,
									0.041,
									0
								],
								to: [
									-0.264,
									-0.049,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									126.917,
									90.903
								],
								t: 97.901,
								ti: [
									0.193,
									0.034,
									0
								],
								to: [
									-0.228,
									-0.041,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									126.287,
									90.791
								],
								t: 99.899,
								ti: [
									0.158,
									0.028,
									0
								],
								to: [
									-0.193,
									-0.034,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									125.761,
									90.698
								],
								t: 101.897,
								ti: [
									0.134,
									0.025,
									0
								],
								to: [
									-0.158,
									-0.028,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									125.337,
									90.622
								],
								t: 103.895,
								ti: [
									0.126,
									0.027,
									0
								],
								to: [
									-0.134,
									-0.025,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									124.96,
									90.547
								],
								t: 105.893,
								ti: [
									0.127,
									0.03,
									0
								],
								to: [
									-0.126,
									-0.027,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									124.579,
									90.461
								],
								t: 107.891,
								ti: [
									0.127,
									0.034,
									0
								],
								to: [
									-0.127,
									-0.03,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									124.196,
									90.364
								],
								t: 109.889,
								ti: [
									0.126,
									0.037,
									0
								],
								to: [
									-0.127,
									-0.034,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									123.816,
									90.257
								],
								t: 111.887,
								ti: [
									0.124,
									0.04,
									0
								],
								to: [
									-0.126,
									-0.037,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									123.44,
									90.141
								],
								t: 113.885,
								ti: [
									0.121,
									0.042,
									0
								],
								to: [
									-0.124,
									-0.04,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									123.073,
									90.017
								],
								t: 115.883,
								ti: [
									0.116,
									0.044,
									0
								],
								to: [
									-0.121,
									-0.042,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									122.717,
									89.887
								],
								t: 117.881,
								ti: [
									0.11,
									0.046,
									0
								],
								to: [
									-0.116,
									-0.044,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									122.376,
									89.751
								],
								t: 119.879,
								ti: [
									0.103,
									0.046,
									0
								],
								to: [
									-0.11,
									-0.046,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									122.055,
									89.613
								],
								t: 121.877,
								ti: [
									0.095,
									0.046,
									0
								],
								to: [
									-0.103,
									-0.046,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									121.755,
									89.474
								],
								t: 123.875,
								ti: [
									0.086,
									0.045,
									0
								],
								to: [
									-0.095,
									-0.046,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									121.483,
									89.337
								],
								t: 125.873,
								ti: [
									0.075,
									0.043,
									0
								],
								to: [
									-0.086,
									-0.045,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									121.241,
									89.204
								],
								t: 127.871,
								ti: [
									0.062,
									0.041,
									0
								],
								to: [
									-0.075,
									-0.043,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									121.035,
									89.077
								],
								t: 129.869,
								ti: [
									0.028,
									0.019,
									0
								],
								to: [
									-0.062,
									-0.041,
									0
								]
							},
							{
								s: [
									120.867,
									88.96
								],
								t: 131.867
							}
						]
					},
					r: {
						a: 0,
						k: 92
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									0
								],
								t: 23.976
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 33.966
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 77.922
							},
							{
								s: [
									0
								],
								t: 109.889
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "Rectangle 1",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0.012,
												10.621
											],
											[
												-5.695,
												5.34
											],
											[
												-2.557,
												-7.377
											],
											[
												3.15,
												-2.096
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "Fill 1",
								c: {
									a: 0,
									k: [
										0.137,
										0.459,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										-3.421,
										4.043
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 9
			},
			{
				ty: 4,
				nm: "Shape Layer 61",
				sr: 1,
				st: 7.992,
				op: 149.85,
				ip: 7.992,
				ln: "6953",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									97.409,
									66.055
								],
								t: 7.992
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									44.567,
									76.147
								],
								t: 9.99
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									63.613,
									73.054
								],
								t: 11.988
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									100.946,
									97.634
								],
								t: 13.986
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									61.805,
									70.187
								],
								t: 15.984
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									87.307,
									64.612
								],
								t: 17.982
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									125.487,
									111.62
								],
								t: 19.98
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									109.816,
									104.073
								],
								t: 21.978
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									65.323,
									104.689
								],
								t: 23.976
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									47.252,
									134.038
								],
								t: 25.974
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									91.917,
									108.765
								],
								t: 27.972
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									102.196,
									140.322
								],
								t: 29.97
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									122.314,
									110.374
								],
								t: 31.968
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									110.56,
									62.157
								],
								t: 33.966
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									65.661,
									77.47
								],
								t: 35.964
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									85.871,
									65.321
								],
								t: 37.962
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									67.714,
									49.917
								],
								t: 39.96
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									78.115,
									97.527
								],
								t: 41.958
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									143.974,
									113.298
								],
								t: 43.956
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									91.205,
									80.878
								],
								t: 45.954
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									128.534,
									117.961
								],
								t: 47.952
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									81.833,
									74.831
								],
								t: 49.95
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									130.604,
									103.951
								],
								t: 51.948
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									118.24,
									117.585
								],
								t: 53.946
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									86.185,
									91.54
								],
								t: 55.944
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									59.806,
									81.372
								],
								t: 57.942
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									62.144,
									101.879
								],
								t: 59.94
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									25.053,
									61.948
								],
								t: 61.938
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									88.839,
									64.113
								],
								t: 63.936
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									98.389,
									60.046
								],
								t: 65.934
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									75.918,
									45.28
								],
								t: 67.932
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									65.601,
									48.361
								],
								t: 69.93
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									72.571,
									31.73
								],
								t: 71.927
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									108.482,
									26.833
								],
								t: 73.925
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									64.065,
									74.946
								],
								t: 75.923
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									22.794,
									25.686
								],
								t: 77.921
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									33.918,
									6.407
								],
								t: 79.919
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									48.539,
									53.893
								],
								t: 81.917
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									27.022,
									-9.839
								],
								t: 83.915
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									36.118,
									31.361
								],
								t: 85.913
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									44.181,
									-10.557
								],
								t: 87.911
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-4.037,
									-4.307
								],
								t: 89.909
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									68.255,
									26.661
								],
								t: 91.907
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									13.766,
									42.343
								],
								t: 93.905
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									32.121,
									48.441
								],
								t: 95.903
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									43.941,
									45.171
								],
								t: 97.901
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									7.866,
									-41.801
								],
								t: 99.899
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									17.231,
									-5.411
								],
								t: 101.897
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									18.373,
									36.907
								],
								t: 103.895
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									41.417,
									41.547
								],
								t: 105.893
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									28.526,
									49.618
								],
								t: 107.891
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									48.627,
									48.688
								],
								t: 109.889
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-5.742,
									52.477
								],
								t: 111.887
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									4.853,
									21.683
								],
								t: 113.885
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									15.758,
									47.142
								],
								t: 115.883
							},
							{
								s: [
									10.26,
									18.203
								],
								t: 117.881
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.09
								},
								i: {
									x: 0.833,
									y: 0.778
								},
								s: [
									269.491,
									306.01
								],
								t: 7.992,
								ti: [
									-1.762,
									-1.355,
									0
								],
								to: [
									0.367,
									0.261,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.051
								},
								i: {
									x: 0.833,
									y: 0.885
								},
								s: [
									271.692,
									307.579
								],
								t: 9.99,
								ti: [
									-4.055,
									-2.961,
									0
								],
								to: [
									1.762,
									1.355,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.071
								},
								i: {
									x: 0.833,
									y: 0.904
								},
								s: [
									280.065,
									314.139
								],
								t: 11.988,
								ti: [
									-5.763,
									-3.712,
									0
								],
								to: [
									4.055,
									2.961,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.1
								},
								i: {
									x: 0.833,
									y: 0.901
								},
								s: [
									296.024,
									325.342
								],
								t: 13.986,
								ti: [
									-5.909,
									-3.26,
									0
								],
								to: [
									5.763,
									3.712,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.128
								},
								i: {
									x: 0.833,
									y: 0.891
								},
								s: [
									314.641,
									336.411
								],
								t: 15.984,
								ti: [
									-5.199,
									-2.461,
									0
								],
								to: [
									5.909,
									3.26,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.142
								},
								i: {
									x: 0.833,
									y: 0.883
								},
								s: [
									331.476,
									344.903
								],
								t: 17.982,
								ti: [
									-4.435,
									-1.834,
									0
								],
								to: [
									5.199,
									2.461,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.149
								},
								i: {
									x: 0.833,
									y: 0.875
								},
								s: [
									345.833,
									351.179
								],
								t: 19.98,
								ti: [
									-3.802,
									-1.398,
									0
								],
								to: [
									4.435,
									1.834,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.153
								},
								i: {
									x: 0.833,
									y: 0.87
								},
								s: [
									358.083,
									355.908
								],
								t: 21.978,
								ti: [
									-3.292,
									-1.093,
									0
								],
								to: [
									3.802,
									1.398,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.156
								},
								i: {
									x: 0.833,
									y: 0.865
								},
								s: [
									368.642,
									359.567
								],
								t: 23.976,
								ti: [
									-2.886,
									-0.867,
									0
								],
								to: [
									3.292,
									1.093,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.159
								},
								i: {
									x: 0.833,
									y: 0.861
								},
								s: [
									377.836,
									362.467
								],
								t: 25.974,
								ti: [
									-2.566,
									-0.687,
									0
								],
								to: [
									2.886,
									0.867,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.162
								},
								i: {
									x: 0.833,
									y: 0.857
								},
								s: [
									385.959,
									364.771
								],
								t: 27.972,
								ti: [
									-2.306,
									-0.543,
									0
								],
								to: [
									2.566,
									0.687,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.164
								},
								i: {
									x: 0.833,
									y: 0.853
								},
								s: [
									393.233,
									366.589
								],
								t: 29.97,
								ti: [
									-2.085,
									-0.431,
									0
								],
								to: [
									2.306,
									0.543,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.85
								},
								s: [
									399.792,
									368.03
								],
								t: 31.968,
								ti: [
									-1.895,
									-0.342,
									0
								],
								to: [
									2.085,
									0.431,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.168
								},
								i: {
									x: 0.833,
									y: 0.847
								},
								s: [
									405.741,
									369.174
								],
								t: 33.966,
								ti: [
									-1.729,
									-0.272,
									0
								],
								to: [
									1.895,
									0.342,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.169
								},
								i: {
									x: 0.833,
									y: 0.846
								},
								s: [
									411.16,
									370.082
								],
								t: 35.964,
								ti: [
									-1.583,
									-0.217,
									0
								],
								to: [
									1.729,
									0.272,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.17
								},
								i: {
									x: 0.833,
									y: 0.843
								},
								s: [
									416.115,
									370.805
								],
								t: 37.962,
								ti: [
									-1.452,
									-0.173,
									0
								],
								to: [
									1.583,
									0.217,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.171
								},
								i: {
									x: 0.833,
									y: 0.843
								},
								s: [
									420.657,
									371.382
								],
								t: 39.96,
								ti: [
									-1.335,
									-0.139,
									0
								],
								to: [
									1.452,
									0.173,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.171
								},
								i: {
									x: 0.833,
									y: 0.843
								},
								s: [
									424.829,
									371.844
								],
								t: 41.958,
								ti: [
									-1.229,
									-0.113,
									0
								],
								to: [
									1.335,
									0.139,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.171
								},
								i: {
									x: 0.833,
									y: 0.843
								},
								s: [
									428.668,
									372.218
								],
								t: 43.956,
								ti: [
									-1.131,
									-0.094,
									0
								],
								to: [
									1.229,
									0.113,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.171
								},
								i: {
									x: 0.833,
									y: 0.842
								},
								s: [
									432.201,
									372.525
								],
								t: 45.954,
								ti: [
									-1.041,
									-0.08,
									0
								],
								to: [
									1.131,
									0.094,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.173
								},
								i: {
									x: 0.833,
									y: 0.841
								},
								s: [
									435.454,
									372.783
								],
								t: 47.952,
								ti: [
									-0.958,
									-0.071,
									0
								],
								to: [
									1.041,
									0.08,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.173
								},
								i: {
									x: 0.833,
									y: 0.841
								},
								s: [
									438.448,
									373.008
								],
								t: 49.95,
								ti: [
									-0.88,
									-0.066,
									0
								],
								to: [
									0.958,
									0.071,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.172
								},
								i: {
									x: 0.833,
									y: 0.841
								},
								s: [
									441.201,
									373.211
								],
								t: 51.948,
								ti: [
									-0.807,
									-0.063,
									0
								],
								to: [
									0.88,
									0.066,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.171
								},
								i: {
									x: 0.833,
									y: 0.843
								},
								s: [
									443.727,
									373.403
								],
								t: 53.946,
								ti: [
									-0.738,
									-0.063,
									0
								],
								to: [
									0.807,
									0.063,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.171
								},
								i: {
									x: 0.833,
									y: 0.844
								},
								s: [
									446.042,
									373.591
								],
								t: 55.944,
								ti: [
									-0.673,
									-0.065,
									0
								],
								to: [
									0.738,
									0.063,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.172
								},
								i: {
									x: 0.833,
									y: 0.844
								},
								s: [
									448.156,
									373.783
								],
								t: 57.942,
								ti: [
									-0.611,
									-0.069,
									0
								],
								to: [
									0.673,
									0.065,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.172
								},
								i: {
									x: 0.833,
									y: 0.844
								},
								s: [
									450.079,
									373.983
								],
								t: 59.94,
								ti: [
									-0.552,
									-0.073,
									0
								],
								to: [
									0.611,
									0.069,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.17
								},
								i: {
									x: 0.833,
									y: 0.848
								},
								s: [
									451.822,
									374.195
								],
								t: 61.938,
								ti: [
									-0.495,
									-0.077,
									0
								],
								to: [
									0.552,
									0.073,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.168
								},
								i: {
									x: 0.833,
									y: 0.848
								},
								s: [
									453.39,
									374.419
								],
								t: 63.936,
								ti: [
									-0.44,
									-0.082,
									0
								],
								to: [
									0.495,
									0.077,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.166
								},
								i: {
									x: 0.833,
									y: 0.852
								},
								s: [
									454.792,
									374.659
								],
								t: 65.934,
								ti: [
									-0.387,
									-0.086,
									0
								],
								to: [
									0.44,
									0.082,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.163
								},
								i: {
									x: 0.833,
									y: 0.856
								},
								s: [
									456.031,
									374.911
								],
								t: 67.932,
								ti: [
									-0.336,
									-0.09,
									0
								],
								to: [
									0.387,
									0.086,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.158
								},
								i: {
									x: 0.833,
									y: 0.863
								},
								s: [
									457.115,
									375.176
								],
								t: 69.93,
								ti: [
									-0.286,
									-0.092,
									0
								],
								to: [
									0.336,
									0.09,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.151
								},
								i: {
									x: 0.833,
									y: 0.872
								},
								s: [
									458.047,
									375.45
								],
								t: 71.927,
								ti: [
									-0.237,
									-0.093,
									0
								],
								to: [
									0.286,
									0.092,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.141
								},
								i: {
									x: 0.833,
									y: 0.885
								},
								s: [
									458.831,
									375.73
								],
								t: 73.925,
								ti: [
									-0.19,
									-0.093,
									0
								],
								to: [
									0.237,
									0.093,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.125
								},
								i: {
									x: 0.833,
									y: 0.9
								},
								s: [
									459.47,
									376.01
								],
								t: 75.923,
								ti: [
									-0.143,
									-0.09,
									0
								],
								to: [
									0.19,
									0.093,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.099
								},
								i: {
									x: 0.833,
									y: 0.924
								},
								s: [
									459.968,
									376.286
								],
								t: 77.921,
								ti: [
									-0.097,
									-0.085,
									0
								],
								to: [
									0.143,
									0.09,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.059
								},
								i: {
									x: 0.833,
									y: 0.957
								},
								s: [
									460.328,
									376.55
								],
								t: 79.919,
								ti: [
									-0.052,
									-0.077,
									0
								],
								to: [
									0.097,
									0.085,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.011
								},
								i: {
									x: 0.833,
									y: 0.992
								},
								s: [
									460.55,
									376.795
								],
								t: 81.917,
								ti: [
									-7e-3,
									-0.066,
									0
								],
								to: [
									0.052,
									0.077,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									460.639,
									377.012
								],
								t: 83.915,
								ti: [
									0.032,
									-0.061,
									0
								],
								to: [
									0.007,
									0.066,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									460.595,
									377.193
								],
								t: 85.913,
								ti: [
									0.056,
									-0.069,
									0
								],
								to: [
									-0.032,
									0.061,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									460.445,
									377.377
								],
								t: 87.911,
								ti: [
									0.06,
									-0.083,
									0
								],
								to: [
									-0.056,
									0.069,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									460.259,
									377.605
								],
								t: 89.909,
								ti: [
									0.055,
									-0.097,
									0
								],
								to: [
									-0.06,
									0.083,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									460.084,
									377.877
								],
								t: 91.907,
								ti: [
									0.049,
									-0.11,
									0
								],
								to: [
									-0.055,
									0.097,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									459.926,
									378.189
								],
								t: 93.905,
								ti: [
									0.042,
									-0.121,
									0
								],
								to: [
									-0.049,
									0.11,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									459.788,
									378.537
								],
								t: 95.903,
								ti: [
									0.034,
									-0.13,
									0
								],
								to: [
									-0.042,
									0.121,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									459.673,
									378.915
								],
								t: 97.901,
								ti: [
									0.025,
									-0.138,
									0
								],
								to: [
									-0.034,
									0.13,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									459.585,
									379.319
								],
								t: 99.899,
								ti: [
									0.015,
									-0.145,
									0
								],
								to: [
									-0.025,
									0.138,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									459.525,
									379.745
								],
								t: 101.897,
								ti: [
									0.004,
									-0.15,
									0
								],
								to: [
									-0.015,
									0.145,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									459.496,
									380.189
								],
								t: 103.895,
								ti: [
									-6e-3,
									-0.154,
									0
								],
								to: [
									-4e-3,
									0.15,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									459.499,
									380.647
								],
								t: 105.893,
								ti: [
									-0.017,
									-0.157,
									0
								],
								to: [
									0.006,
									0.154,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									459.535,
									381.115
								],
								t: 107.891,
								ti: [
									-0.028,
									-0.158,
									0
								],
								to: [
									0.017,
									0.157,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.001
								},
								i: {
									x: 0.833,
									y: 0.999
								},
								s: [
									459.603,
									381.589
								],
								t: 109.889,
								ti: [
									-0.039,
									-0.159,
									0
								],
								to: [
									0.028,
									0.158,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.003
								},
								i: {
									x: 0.833,
									y: 0.997
								},
								s: [
									459.705,
									382.066
								],
								t: 111.887,
								ti: [
									-0.05,
									-0.158,
									0
								],
								to: [
									0.039,
									0.159,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.006
								},
								i: {
									x: 0.833,
									y: 0.994
								},
								s: [
									459.838,
									382.542
								],
								t: 113.885,
								ti: [
									-0.059,
									-0.156,
									0
								],
								to: [
									0.05,
									0.158,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.01
								},
								i: {
									x: 0.833,
									y: 0.99
								},
								s: [
									460.002,
									383.013
								],
								t: 115.883,
								ti: [
									-0.032,
									-0.077,
									0
								],
								to: [
									0.059,
									0.156,
									0
								]
							},
							{
								s: [
									460.195,
									383.477
								],
								t: 117.881
							}
						]
					},
					r: {
						a: 0,
						k: 92
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									0
								],
								t: 7.992
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 17.982
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 61.938
							},
							{
								s: [
									0
								],
								t: 93.905
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "Ellipse 1",
						it: [
							{
								ty: "el",
								nm: "Ellipse Path 1",
								d: 1,
								p: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										10,
										10
									]
								}
							},
							{
								ty: "fl",
								nm: "Fill 1",
								c: {
									a: 0,
									k: [
										0.137,
										0.459,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										0,
										0
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 10
			},
			{
				ty: 4,
				nm: "Shape Layer 60",
				sr: 1,
				st: 13.986,
				op: 149.85,
				ip: 13.986,
				ln: "6952",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									64.676,
									29.575
								],
								t: 13.986
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									63.619,
									31.654
								],
								t: 15.984
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									83.082,
									94.984
								],
								t: 17.982
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									98.428,
									68.346
								],
								t: 19.98
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									65.326,
									46.692
								],
								t: 21.978
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									115.976,
									81.786
								],
								t: 23.976
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									94.867,
									134.538
								],
								t: 25.974
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									76.907,
									82.463
								],
								t: 27.972
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									136.087,
									72.163
								],
								t: 29.97
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									146.093,
									94.38
								],
								t: 31.968
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									64.998,
									132.461
								],
								t: 33.966
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									97.241,
									152.104
								],
								t: 35.964
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									126.81,
									118.253
								],
								t: 37.962
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									39.419,
									102.155
								],
								t: 39.96
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									59.845,
									93.89
								],
								t: 41.958
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									71.34,
									47.538
								],
								t: 43.956
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									58.098,
									44.818
								],
								t: 45.954
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									82.135,
									88.74
								],
								t: 47.952
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									95.452,
									70.689
								],
								t: 49.95
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									106.399,
									41.339
								],
								t: 51.948
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									46.837,
									95.066
								],
								t: 53.946
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									100.241,
									76.371
								],
								t: 55.944
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									91.348,
									46.624
								],
								t: 57.942
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									86.082,
									72.273
								],
								t: 59.94
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									104.113,
									51.031
								],
								t: 61.938
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									94.281,
									62.125
								],
								t: 63.936
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									126.942,
									93.089
								],
								t: 65.934
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									108.331,
									65.944
								],
								t: 67.932
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									63.723,
									44.138
								],
								t: 69.93
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									102.921,
									48.671
								],
								t: 71.928
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									78.268,
									71.671
								],
								t: 73.926
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									87.176,
									75.352
								],
								t: 75.924
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									28.705,
									110.854
								],
								t: 77.921
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									18.357,
									46.477
								],
								t: 79.919
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									57.758,
									39.913
								],
								t: 81.917
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									91.489,
									81.222
								],
								t: 83.915
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									20.878,
									48.853
								],
								t: 85.913
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									47.568,
									3.824
								],
								t: 87.911
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									35.966,
									11.947
								],
								t: 89.909
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									44.168,
									4.41
								],
								t: 91.907
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									52.575,
									15.778
								],
								t: 93.905
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									2.557,
									60.137
								],
								t: 95.903
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									14.899,
									27.604
								],
								t: 97.901
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									83.445,
									31.436
								],
								t: 99.899
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									48.803,
									8.908
								],
								t: 101.897
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									20.805,
									49.183
								],
								t: 103.895
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									64.315,
									40.919
								],
								t: 105.893
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									39.92,
									18.864
								],
								t: 107.891
							},
							{
								s: [
									52.411,
									-3.555
								],
								t: 109.889
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.158
								},
								i: {
									x: 0.833,
									y: 0.537
								},
								s: [
									273.717,
									253.598
								],
								t: 13.986,
								ti: [
									-1.664,
									-0.082,
									0
								],
								to: [
									0.28,
									-0.028,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.099
								},
								i: {
									x: 0.833,
									y: 0.762
								},
								s: [
									275.395,
									253.428
								],
								t: 15.984,
								ti: [
									-3.922,
									-0.767,
									0
								],
								to: [
									1.664,
									0.082,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.115
								},
								i: {
									x: 0.833,
									y: 0.841
								},
								s: [
									283.7,
									254.091
								],
								t: 17.982,
								ti: [
									-5.158,
									-1.975,
									0
								],
								to: [
									3.922,
									0.767,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.112
								},
								i: {
									x: 0.833,
									y: 0.89
								},
								s: [
									298.929,
									258.033
								],
								t: 19.98,
								ti: [
									-4.6,
									-2.946,
									0
								],
								to: [
									5.158,
									1.975,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.082
								},
								i: {
									x: 0.833,
									y: 0.93
								},
								s: [
									314.649,
									265.939
								],
								t: 21.978,
								ti: [
									-3.328,
									-3.296,
									0
								],
								to: [
									4.6,
									2.946,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.045
								},
								i: {
									x: 0.833,
									y: 0.962
								},
								s: [
									326.529,
									275.709
								],
								t: 23.976,
								ti: [
									-2.233,
									-3.252,
									0
								],
								to: [
									3.328,
									3.296,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.021
								},
								i: {
									x: 0.833,
									y: 0.982
								},
								s: [
									334.618,
									285.714
								],
								t: 25.974,
								ti: [
									-1.455,
									-3.046,
									0
								],
								to: [
									2.233,
									3.252,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.009
								},
								i: {
									x: 0.833,
									y: 0.992
								},
								s: [
									339.929,
									295.223
								],
								t: 27.972,
								ti: [
									-0.931,
									-2.79,
									0
								],
								to: [
									1.455,
									3.046,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.003
								},
								i: {
									x: 0.833,
									y: 0.997
								},
								s: [
									343.35,
									303.988
								],
								t: 29.97,
								ti: [
									-0.582,
									-2.533,
									0
								],
								to: [
									0.931,
									2.79,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.001
								},
								i: {
									x: 0.833,
									y: 0.999
								},
								s: [
									345.513,
									311.964
								],
								t: 31.968,
								ti: [
									-0.353,
									-2.293,
									0
								],
								to: [
									0.582,
									2.533,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									346.843,
									319.188
								],
								t: 33.966,
								ti: [
									-0.205,
									-2.077,
									0
								],
								to: [
									0.353,
									2.293,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									347.63,
									325.723
								],
								t: 35.964,
								ti: [
									-0.115,
									-1.887,
									0
								],
								to: [
									0.205,
									2.077,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									348.075,
									331.651
								],
								t: 37.962,
								ti: [
									-0.064,
									-1.719,
									0
								],
								to: [
									0.115,
									1.887,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									348.319,
									337.046
								],
								t: 39.96,
								ti: [
									-0.041,
									-1.573,
									0
								],
								to: [
									0.064,
									1.719,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									348.461,
									341.968
								],
								t: 41.958,
								ti: [
									-0.028,
									-1.452,
									0
								],
								to: [
									0.041,
									1.573,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									348.564,
									346.482
								],
								t: 43.956,
								ti: [
									-0.019,
									-1.351,
									0
								],
								to: [
									0.028,
									1.452,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									348.628,
									350.68
								],
								t: 45.954,
								ti: [
									-0.016,
									-1.256,
									0
								],
								to: [
									0.019,
									1.351,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									348.676,
									354.586
								],
								t: 47.952,
								ti: [
									-0.018,
									-1.167,
									0
								],
								to: [
									0.016,
									1.256,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									348.724,
									358.218
								],
								t: 49.95,
								ti: [
									-0.022,
									-1.082,
									0
								],
								to: [
									0.018,
									1.167,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									348.783,
									361.589
								],
								t: 51.948,
								ti: [
									-0.029,
									-1,
									0
								],
								to: [
									0.022,
									1.082,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									348.858,
									364.71
								],
								t: 53.946,
								ti: [
									-0.036,
									-0.921,
									0
								],
								to: [
									0.029,
									1,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									348.955,
									367.59
								],
								t: 55.944,
								ti: [
									-0.043,
									-0.844,
									0
								],
								to: [
									0.036,
									0.921,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									349.073,
									370.236
								],
								t: 57.942,
								ti: [
									-0.05,
									-0.768,
									0
								],
								to: [
									0.043,
									0.844,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									349.212,
									372.652
								],
								t: 59.94,
								ti: [
									-0.056,
									-0.694,
									0
								],
								to: [
									0.05,
									0.768,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									349.372,
									374.845
								],
								t: 61.938,
								ti: [
									-0.062,
									-0.622,
									0
								],
								to: [
									0.056,
									0.694,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									349.55,
									376.819
								],
								t: 63.936,
								ti: [
									-0.067,
									-0.551,
									0
								],
								to: [
									0.062,
									0.622,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									349.743,
									378.577
								],
								t: 65.934,
								ti: [
									-0.07,
									-0.481,
									0
								],
								to: [
									0.067,
									0.551,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.001
								},
								i: {
									x: 0.833,
									y: 0.999
								},
								s: [
									349.95,
									380.124
								],
								t: 67.932,
								ti: [
									-0.073,
									-0.413,
									0
								],
								to: [
									0.07,
									0.481,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.001
								},
								i: {
									x: 0.833,
									y: 0.999
								},
								s: [
									350.166,
									381.464
								],
								t: 69.93,
								ti: [
									-0.075,
									-0.348,
									0
								],
								to: [
									0.073,
									0.413,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.002
								},
								i: {
									x: 0.833,
									y: 0.998
								},
								s: [
									350.389,
									382.603
								],
								t: 71.928,
								ti: [
									-0.075,
									-0.284,
									0
								],
								to: [
									0.075,
									0.348,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.004
								},
								i: {
									x: 0.833,
									y: 0.997
								},
								s: [
									350.614,
									383.549
								],
								t: 73.926,
								ti: [
									-0.075,
									-0.222,
									0
								],
								to: [
									0.075,
									0.284,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.009
								},
								i: {
									x: 0.833,
									y: 0.993
								},
								s: [
									350.84,
									384.306
								],
								t: 75.924,
								ti: [
									-0.073,
									-0.163,
									0
								],
								to: [
									0.075,
									0.222,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.021
								},
								i: {
									x: 0.833,
									y: 0.985
								},
								s: [
									351.062,
									384.882
								],
								t: 77.921,
								ti: [
									-0.071,
									-0.106,
									0
								],
								to: [
									0.073,
									0.163,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.058
								},
								i: {
									x: 0.833,
									y: 0.96
								},
								s: [
									351.279,
									385.285
								],
								t: 79.919,
								ti: [
									-0.068,
									-0.053,
									0
								],
								to: [
									0.071,
									0.106,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.155
								},
								i: {
									x: 0.833,
									y: 0.879
								},
								s: [
									351.487,
									385.521
								],
								t: 81.917,
								ti: [
									-0.064,
									-2e-3,
									0
								],
								to: [
									0.068,
									0.053,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.136
								},
								i: {
									x: 0.833,
									y: 0.848
								},
								s: [
									351.685,
									385.601
								],
								t: 83.915,
								ti: [
									-0.059,
									0.045,
									0
								],
								to: [
									0.064,
									0.002,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.038
								},
								i: {
									x: 0.833,
									y: 0.948
								},
								s: [
									351.87,
									385.535
								],
								t: 85.913,
								ti: [
									-0.054,
									0.088,
									0
								],
								to: [
									0.059,
									-0.045,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.012
								},
								i: {
									x: 0.833,
									y: 0.985
								},
								s: [
									352.04,
									385.333
								],
								t: 87.911,
								ti: [
									-0.049,
									0.127,
									0
								],
								to: [
									0.054,
									-0.088,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.004
								},
								i: {
									x: 0.833,
									y: 0.995
								},
								s: [
									352.195,
									385.007
								],
								t: 89.909,
								ti: [
									-0.043,
									0.161,
									0
								],
								to: [
									0.049,
									-0.127,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.002
								},
								i: {
									x: 0.833,
									y: 0.998
								},
								s: [
									352.331,
									384.571
								],
								t: 91.907,
								ti: [
									-0.035,
									0.185,
									0
								],
								to: [
									0.043,
									-0.161,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.001
								},
								i: {
									x: 0.833,
									y: 0.999
								},
								s: [
									352.45,
									384.039
								],
								t: 93.905,
								ti: [
									-0.024,
									0.192,
									0
								],
								to: [
									0.035,
									-0.185,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									352.541,
									383.461
								],
								t: 95.903,
								ti: [
									-0.013,
									0.188,
									0
								],
								to: [
									0.024,
									-0.192,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									352.596,
									382.887
								],
								t: 97.901,
								ti: [
									-1e-3,
									0.179,
									0
								],
								to: [
									0.013,
									-0.188,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									352.617,
									382.333
								],
								t: 99.899,
								ti: [
									0.007,
									0.165,
									0
								],
								to: [
									0.001,
									-0.179,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									352.603,
									381.814
								],
								t: 101.897,
								ti: [
									0.003,
									0.149,
									0
								],
								to: [
									-7e-3,
									-0.165,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									352.574,
									381.345
								],
								t: 103.895,
								ti: [
									-0.011,
									0.133,
									0
								],
								to: [
									-3e-3,
									-0.149,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									352.587,
									380.922
								],
								t: 105.893,
								ti: [
									-0.023,
									0.117,
									0
								],
								to: [
									0.011,
									-0.133,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.003
								},
								i: {
									x: 0.833,
									y: 0.997
								},
								s: [
									352.639,
									380.546
								],
								t: 107.891,
								ti: [
									-0.014,
									0.055,
									0
								],
								to: [
									0.023,
									-0.117,
									0
								]
							},
							{
								s: [
									352.724,
									380.217
								],
								t: 109.889
							}
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									0
								],
								t: 13.986
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 23.976
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 67.932
							},
							{
								s: [
									0
								],
								t: 99.899
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "Polystar 1",
						it: [
							{
								ty: "sr",
								nm: "Polystar Path 1",
								d: 1,
								pt: {
									a: 0,
									k: 3
								},
								p: {
									a: 0,
									k: [
										6,
										32
									]
								},
								or: {
									a: 0,
									k: 6.599
								},
								os: {
									a: 0,
									k: 0
								},
								r: {
									a: 0,
									k: 0
								},
								sy: 2
							},
							{
								ty: "fl",
								nm: "Fill 1",
								c: {
									a: 0,
									k: [
										0.137,
										0.459,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										-7.382,
										-25.677
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 11
			},
			{
				ty: 4,
				nm: "Shape Layer 59",
				sr: 1,
				st: 23.976,
				op: 149.85,
				ip: 23.976,
				ln: "6951",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									95.923,
									97.698
								],
								t: 23.976
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									119.853,
									100.809
								],
								t: 25.974
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									71.61,
									47.548
								],
								t: 27.972
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									95.909,
									74.187
								],
								t: 29.97
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									116.529,
									126.213
								],
								t: 31.968
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									69.282,
									82.296
								],
								t: 33.966
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									99.804,
									62.944
								],
								t: 35.964
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									155.455,
									101.204
								],
								t: 37.962
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									90.335,
									142.892
								],
								t: 39.96
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									96.569,
									142.898
								],
								t: 41.958
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									105.516,
									144.953
								],
								t: 43.956
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									79.375,
									124.659
								],
								t: 45.954
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									53.599,
									121.011
								],
								t: 47.952
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									77.44,
									94.418
								],
								t: 49.95
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									96.658,
									47.588
								],
								t: 51.948
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									75.964,
									78.236
								],
								t: 53.946
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									94.431,
									116.596
								],
								t: 55.944
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									104.908,
									41.132
								],
								t: 57.942
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									74.497,
									85.65
								],
								t: 59.94
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									75.047,
									137.348
								],
								t: 61.938
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									95.389,
									78.111
								],
								t: 63.936
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									85.987,
									106.338
								],
								t: 65.934
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									86.576,
									59.064
								],
								t: 67.932
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									67.887,
									77.283
								],
								t: 69.93
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									117.559,
									112.652
								],
								t: 71.928
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									115.524,
									117.508
								],
								t: 73.926
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									94.322,
									71.923
								],
								t: 75.924
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									107.41,
									58.262
								],
								t: 77.922
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									89.918,
									50.26
								],
								t: 79.92
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									88.641,
									56.58
								],
								t: 81.918
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									54.485,
									73.842
								],
								t: 83.916
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									41.537,
									63.86
								],
								t: 85.914
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									58.89,
									12.33
								],
								t: 87.911
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									81.867,
									81.726
								],
								t: 89.909
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									44.5,
									97.298
								],
								t: 91.907
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									49.475,
									29.648
								],
								t: 93.905
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									52.978,
									19.812
								],
								t: 95.903
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									48.737,
									19.789
								],
								t: 97.901
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									74.095,
									0.809
								],
								t: 99.899
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									10.268,
									62.842
								],
								t: 101.897
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									27.318,
									46.475
								],
								t: 103.895
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									53.611,
									68.98
								],
								t: 105.893
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									54.64,
									8.452
								],
								t: 107.891
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									21.647,
									41.626
								],
								t: 109.889
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									27.025,
									20.873
								],
								t: 111.887
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									23.296,
									26.051
								],
								t: 113.885
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									28.415,
									26.722
								],
								t: 115.883
							},
							{
								s: [
									22.608,
									32.219
								],
								t: 117.881
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									267.865,
									255.269
								],
								t: 23.976,
								ti: [
									1.026,
									2.138,
									0
								],
								to: [
									-0.161,
									-0.402,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									266.901,
									252.858
								],
								t: 25.974,
								ti: [
									2.899,
									4.739,
									0
								],
								to: [
									-1.026,
									-2.138,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									261.706,
									242.443
								],
								t: 27.972,
								ti: [
									4.94,
									5.799,
									0
								],
								to: [
									-2.899,
									-4.739,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									249.506,
									224.427
								],
								t: 29.97,
								ti: [
									5.963,
									4.5,
									0
								],
								to: [
									-4.94,
									-5.799,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									232.069,
									207.647
								],
								t: 31.968,
								ti: [
									5.888,
									2.374,
									0
								],
								to: [
									-5.963,
									-4.5,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									213.727,
									197.425
								],
								t: 33.966,
								ti: [
									5.276,
									0.563,
									0
								],
								to: [
									-5.888,
									-2.374,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									196.743,
									193.401
								],
								t: 35.964,
								ti: [
									4.452,
									-0.741,
									0
								],
								to: [
									-5.276,
									-0.563,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									182.074,
									194.046
								],
								t: 37.962,
								ti: [
									3.589,
									-1.577,
									0
								],
								to: [
									-4.452,
									0.741,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									170.029,
									197.845
								],
								t: 39.96,
								ti: [
									2.794,
									-2.037,
									0
								],
								to: [
									-3.589,
									1.577,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									160.537,
									203.508
								],
								t: 41.958,
								ti: [
									2.125,
									-2.229,
									0
								],
								to: [
									-2.794,
									2.037,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									153.265,
									210.066
								],
								t: 43.956,
								ti: [
									1.595,
									-2.253,
									0
								],
								to: [
									-2.125,
									2.229,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									147.784,
									216.885
								],
								t: 45.954,
								ti: [
									1.188,
									-2.18,
									0
								],
								to: [
									-1.595,
									2.253,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									143.692,
									223.586
								],
								t: 47.952,
								ti: [
									0.88,
									-2.056,
									0
								],
								to: [
									-1.188,
									2.18,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									140.657,
									229.963
								],
								t: 49.95,
								ti: [
									0.65,
									-1.912,
									0
								],
								to: [
									-0.88,
									2.056,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									138.413,
									235.924
								],
								t: 51.948,
								ti: [
									0.477,
									-1.76,
									0
								],
								to: [
									-0.65,
									1.912,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									136.76,
									241.434
								],
								t: 53.946,
								ti: [
									0.347,
									-1.607,
									0
								],
								to: [
									-0.477,
									1.76,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									135.553,
									246.481
								],
								t: 55.944,
								ti: [
									0.25,
									-1.458,
									0
								],
								to: [
									-0.347,
									1.607,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									134.678,
									251.075
								],
								t: 57.942,
								ti: [
									0.178,
									-1.316,
									0
								],
								to: [
									-0.25,
									1.458,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									134.053,
									255.23
								],
								t: 59.94,
								ti: [
									0.125,
									-1.182,
									0
								],
								to: [
									-0.178,
									1.316,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									133.611,
									258.969
								],
								t: 61.938,
								ti: [
									0.088,
									-1.057,
									0
								],
								to: [
									-0.125,
									1.182,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									133.302,
									262.321
								],
								t: 63.936,
								ti: [
									0.062,
									-0.942,
									0
								],
								to: [
									-0.088,
									1.057,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									133.085,
									265.313
								],
								t: 65.934,
								ti: [
									0.045,
									-0.835,
									0
								],
								to: [
									-0.062,
									0.942,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									132.931,
									267.971
								],
								t: 67.932,
								ti: [
									0.035,
									-0.737,
									0
								],
								to: [
									-0.045,
									0.835,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									132.816,
									270.322
								],
								t: 69.93,
								ti: [
									0.031,
									-0.648,
									0
								],
								to: [
									-0.035,
									0.737,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									132.72,
									272.392
								],
								t: 71.928,
								ti: [
									0.031,
									-0.567,
									0
								],
								to: [
									-0.031,
									0.648,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									132.63,
									274.209
								],
								t: 73.926,
								ti: [
									0.035,
									-0.496,
									0
								],
								to: [
									-0.031,
									0.567,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									132.533,
									275.797
								],
								t: 75.924,
								ti: [
									0.04,
									-0.432,
									0
								],
								to: [
									-0.035,
									0.496,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									132.422,
									277.182
								],
								t: 77.922,
								ti: [
									0.043,
									-0.377,
									0
								],
								to: [
									-0.04,
									0.432,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									132.291,
									278.392
								],
								t: 79.92,
								ti: [
									0.036,
									-0.328,
									0
								],
								to: [
									-0.043,
									0.377,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									132.166,
									279.447
								],
								t: 81.918,
								ti: [
									0.026,
									-0.282,
									0
								],
								to: [
									-0.036,
									0.328,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									132.075,
									280.359
								],
								t: 83.916,
								ti: [
									0.017,
									-0.24,
									0
								],
								to: [
									-0.026,
									0.282,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									132.011,
									281.139
								],
								t: 85.914,
								ti: [
									0.01,
									-0.201,
									0
								],
								to: [
									-0.017,
									0.24,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									131.972,
									281.799
								],
								t: 87.911,
								ti: [
									0.003,
									-0.166,
									0
								],
								to: [
									-0.01,
									0.201,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									131.954,
									282.347
								],
								t: 89.909,
								ti: [
									-2e-3,
									-0.133,
									0
								],
								to: [
									-3e-3,
									0.166,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									131.953,
									282.792
								],
								t: 91.907,
								ti: [
									-7e-3,
									-0.102,
									0
								],
								to: [
									0.002,
									0.133,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									131.967,
									283.142
								],
								t: 93.905,
								ti: [
									-0.011,
									-0.073,
									0
								],
								to: [
									0.007,
									0.102,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.002
								},
								i: {
									x: 0.833,
									y: 0.999
								},
								s: [
									131.994,
									283.403
								],
								t: 95.903,
								ti: [
									-0.014,
									-0.046,
									0
								],
								to: [
									0.011,
									0.073,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.018
								},
								i: {
									x: 0.833,
									y: 0.989
								},
								s: [
									132.031,
									283.58
								],
								t: 97.901,
								ti: [
									-0.017,
									-0.02,
									0
								],
								to: [
									0.014,
									0.046,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.152
								},
								i: {
									x: 0.833,
									y: 0.875
								},
								s: [
									132.078,
									283.677
								],
								t: 99.899,
								ti: [
									-0.019,
									0.004,
									0
								],
								to: [
									0.017,
									0.02,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.069
								},
								i: {
									x: 0.833,
									y: 0.915
								},
								s: [
									132.132,
									283.7
								],
								t: 101.897,
								ti: [
									-0.021,
									0.02,
									0
								],
								to: [
									0.019,
									-4e-3,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.051
								},
								i: {
									x: 0.833,
									y: 0.948
								},
								s: [
									132.193,
									283.651
								],
								t: 103.895,
								ti: [
									-0.023,
									0.018,
									0
								],
								to: [
									0.021,
									-0.02,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.12
								},
								i: {
									x: 0.833,
									y: 0.892
								},
								s: [
									132.259,
									283.583
								],
								t: 105.893,
								ti: [
									-0.025,
									0.008,
									0
								],
								to: [
									0.023,
									-0.018,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.165
								},
								i: {
									x: 0.833,
									y: 0.836
								},
								s: [
									132.331,
									283.544
								],
								t: 107.891,
								ti: [
									-0.026,
									0,
									0
								],
								to: [
									0.025,
									-8e-3,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.157
								},
								i: {
									x: 0.833,
									y: 0.835
								},
								s: [
									132.408,
									283.533
								],
								t: 109.889,
								ti: [
									-0.027,
									-8e-3,
									0
								],
								to: [
									0.026,
									0,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.124
								},
								i: {
									x: 0.833,
									y: 0.865
								},
								s: [
									132.487,
									283.545
								],
								t: 111.887,
								ti: [
									-0.027,
									-0.014,
									0
								],
								to: [
									0.027,
									0.008,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.096
								},
								i: {
									x: 0.833,
									y: 0.896
								},
								s: [
									132.568,
									283.579
								],
								t: 113.885,
								ti: [
									-0.027,
									-0.019,
									0
								],
								to: [
									0.027,
									0.014,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.074
								},
								i: {
									x: 0.833,
									y: 0.923
								},
								s: [
									132.649,
									283.63
								],
								t: 115.883,
								ti: [
									-0.013,
									-0.011,
									0
								],
								to: [
									0.027,
									0.019,
									0
								]
							},
							{
								s: [
									132.728,
									283.695
								],
								t: 117.881
							}
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									0
								],
								t: 23.976
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 33.966
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 77.922
							},
							{
								s: [
									0
								],
								t: 109.889
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "Polystar 1",
						it: [
							{
								ty: "sr",
								nm: "Polystar Path 1",
								d: 1,
								pt: {
									a: 0,
									k: 3
								},
								p: {
									a: 0,
									k: [
										6,
										32
									]
								},
								or: {
									a: 0,
									k: 6.599
								},
								os: {
									a: 0,
									k: 0
								},
								r: {
									a: 0,
									k: 0
								},
								sy: 2
							},
							{
								ty: "fl",
								nm: "Fill 1",
								c: {
									a: 0,
									k: [
										0.137,
										0.459,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										-7.382,
										-25.677
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 12
			},
			{
				ty: 4,
				nm: "Shape Layer 57",
				sr: 1,
				st: 13.986,
				op: 149.85,
				ip: 13.986,
				ln: "6950",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									98.652,
									70.754
								],
								t: 13.986
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									52.407,
									72.577
								],
								t: 15.984
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									83.757,
									80.783
								],
								t: 17.982
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									109.776,
									120.093
								],
								t: 19.98
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									152.905,
									82.158
								],
								t: 21.978
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									120.66,
									59.419
								],
								t: 23.976
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									105.207,
									68.721
								],
								t: 25.974
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									61.164,
									101.207
								],
								t: 27.972
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									57.69,
									84.913
								],
								t: 29.97
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									83.888,
									62.79
								],
								t: 31.968
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									77.451,
									85.785
								],
								t: 33.966
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									56.288,
									101.636
								],
								t: 35.964
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									32.111,
									124.298
								],
								t: 37.962
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									81.428,
									129.386
								],
								t: 39.96
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									65.685,
									67.723
								],
								t: 41.958
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									98.593,
									38.482
								],
								t: 43.956
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									62.324,
									56.222
								],
								t: 45.954
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									79.166,
									81.278
								],
								t: 47.952
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									116.554,
									85.792
								],
								t: 49.95
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									107.89,
									120.793
								],
								t: 51.948
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									109.46,
									111.669
								],
								t: 53.946
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									96.752,
									92.8
								],
								t: 55.944
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									122.109,
									58.72
								],
								t: 57.942
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									97.302,
									70.284
								],
								t: 59.94
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									109.621,
									102.162
								],
								t: 61.938
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									68.943,
									121.676
								],
								t: 63.936
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									92.184,
									74.87
								],
								t: 65.934
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									97.803,
									100.145
								],
								t: 67.932
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									57.518,
									90.885
								],
								t: 69.93
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									70.533,
									61.657
								],
								t: 71.928
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									99.011,
									22.279
								],
								t: 73.926
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									68.391,
									34.404
								],
								t: 75.924
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									64.692,
									74.939
								],
								t: 77.921
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									70.385,
									95.308
								],
								t: 79.919
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									71.029,
									82.647
								],
								t: 81.917
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									14.793,
									22.846
								],
								t: 83.915
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									33.445,
									25.195
								],
								t: 85.913
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									92.281,
									46.336
								],
								t: 87.911
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									15.049,
									48.962
								],
								t: 89.909
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									7.007,
									31.245
								],
								t: 91.907
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									13.248,
									38.566
								],
								t: 93.905
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									24.888,
									3.264
								],
								t: 95.903
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									5.738,
									12.341
								],
								t: 97.901
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									14.963,
									-1.634
								],
								t: 99.899
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									50.015,
									13.874
								],
								t: 101.897
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									33.27,
									10.27
								],
								t: 103.895
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									35.84,
									-1.726
								],
								t: 105.893
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-3.278,
									56.039
								],
								t: 107.891
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-25.859,
									19.601
								],
								t: 109.889
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									41.265,
									-12.971
								],
								t: 111.887
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									16.064,
									44.564
								],
								t: 113.885
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									26.47,
									30.06
								],
								t: 115.883
							},
							{
								s: [
									-24.557,
									-2.189
								],
								t: 117.881
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									276.873,
									250.83
								],
								t: 13.986,
								ti: [
									1.057,
									0.986,
									0
								],
								to: [
									-0.189,
									-0.223,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									275.739,
									249.492
								],
								t: 15.984,
								ti: [
									2.736,
									1.782,
									0
								],
								to: [
									-1.057,
									-0.986,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									270.529,
									244.915
								],
								t: 17.982,
								ti: [
									4.156,
									1.618,
									0
								],
								to: [
									-2.736,
									-1.782,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									259.324,
									238.803
								],
								t: 19.98,
								ti: [
									4.345,
									0.759,
									0
								],
								to: [
									-4.156,
									-1.618,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									245.595,
									235.21
								],
								t: 21.978,
								ti: [
									3.769,
									0.09,
									0
								],
								to: [
									-4.345,
									-0.759,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									233.251,
									234.251
								],
								t: 23.976,
								ti: [
									3.138,
									-0.25,
									0
								],
								to: [
									-3.769,
									-0.09,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									222.982,
									234.672
								],
								t: 25.974,
								ti: [
									2.634,
									-0.412,
									0
								],
								to: [
									-3.138,
									0.25,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									214.421,
									235.749
								],
								t: 27.972,
								ti: [
									2.24,
									-0.491,
									0
								],
								to: [
									-2.634,
									0.412,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									207.179,
									237.146
								],
								t: 29.97,
								ti: [
									1.931,
									-0.529,
									0
								],
								to: [
									-2.24,
									0.491,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									200.979,
									238.697
								],
								t: 31.968,
								ti: [
									1.683,
									-0.547,
									0
								],
								to: [
									-1.931,
									0.529,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									195.596,
									240.321
								],
								t: 33.966,
								ti: [
									1.48,
									-0.555,
									0
								],
								to: [
									-1.683,
									0.547,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									190.881,
									241.977
								],
								t: 35.964,
								ti: [
									1.309,
									-0.559,
									0
								],
								to: [
									-1.48,
									0.555,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									186.716,
									243.649
								],
								t: 37.962,
								ti: [
									1.16,
									-0.566,
									0
								],
								to: [
									-1.309,
									0.559,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									183.025,
									245.334
								],
								t: 39.96,
								ti: [
									1.025,
									-0.581,
									0
								],
								to: [
									-1.16,
									0.566,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									179.755,
									247.045
								],
								t: 41.958,
								ti: [
									0.884,
									-0.616,
									0
								],
								to: [
									-1.025,
									0.581,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									176.877,
									248.822
								],
								t: 43.956,
								ti: [
									0.678,
									-0.697,
									0
								],
								to: [
									-0.884,
									0.616,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									174.448,
									250.742
								],
								t: 45.954,
								ti: [
									0.181,
									-0.747,
									0
								],
								to: [
									-0.678,
									0.697,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.002
								},
								i: {
									x: 0.833,
									y: 0.998
								},
								s: [
									172.806,
									253.001
								],
								t: 47.952,
								ti: [
									-0.395,
									-0.538,
									0
								],
								to: [
									-0.181,
									0.747,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.114
								},
								i: {
									x: 0.833,
									y: 0.899
								},
								s: [
									173.36,
									255.224
								],
								t: 49.95,
								ti: [
									-0.6,
									-0.241,
									0
								],
								to: [
									0.395,
									0.538,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.163
								},
								i: {
									x: 0.833,
									y: 0.859
								},
								s: [
									175.177,
									256.227
								],
								t: 51.948,
								ti: [
									-0.564,
									-0.106,
									0
								],
								to: [
									0.6,
									0.241,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.174
								},
								i: {
									x: 0.833,
									y: 0.847
								},
								s: [
									176.961,
									256.669
								],
								t: 53.946,
								ti: [
									-0.502,
									-0.043,
									0
								],
								to: [
									0.564,
									0.106,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.179
								},
								i: {
									x: 0.833,
									y: 0.844
								},
								s: [
									178.564,
									256.865
								],
								t: 55.944,
								ti: [
									-0.439,
									-8e-3,
									0
								],
								to: [
									0.502,
									0.043,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.179
								},
								i: {
									x: 0.833,
									y: 0.845
								},
								s: [
									179.975,
									256.928
								],
								t: 57.942,
								ti: [
									-0.38,
									0.014,
									0
								],
								to: [
									0.439,
									0.008,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.179
								},
								i: {
									x: 0.833,
									y: 0.846
								},
								s: [
									181.2,
									256.911
								],
								t: 59.94,
								ti: [
									-0.325,
									0.028,
									0
								],
								to: [
									0.38,
									-0.014,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.178
								},
								i: {
									x: 0.833,
									y: 0.849
								},
								s: [
									182.253,
									256.843
								],
								t: 61.938,
								ti: [
									-0.275,
									0.036,
									0
								],
								to: [
									0.325,
									-0.028,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.176
								},
								i: {
									x: 0.833,
									y: 0.853
								},
								s: [
									183.148,
									256.743
								],
								t: 63.936,
								ti: [
									-0.23,
									0.04,
									0
								],
								to: [
									0.275,
									-0.036,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.172
								},
								i: {
									x: 0.833,
									y: 0.857
								},
								s: [
									183.9,
									256.626
								],
								t: 65.934,
								ti: [
									-0.19,
									0.041,
									0
								],
								to: [
									0.23,
									-0.04,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.169
								},
								i: {
									x: 0.833,
									y: 0.86
								},
								s: [
									184.526,
									256.502
								],
								t: 67.932,
								ti: [
									-0.155,
									0.04,
									0
								],
								to: [
									0.19,
									-0.041,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.164
								},
								i: {
									x: 0.833,
									y: 0.866
								},
								s: [
									185.04,
									256.378
								],
								t: 69.93,
								ti: [
									-0.125,
									0.037,
									0
								],
								to: [
									0.155,
									-0.04,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.163
								},
								i: {
									x: 0.833,
									y: 0.869
								},
								s: [
									185.458,
									256.261
								],
								t: 71.928,
								ti: [
									-0.1,
									0.031,
									0
								],
								to: [
									0.125,
									-0.037,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.163
								},
								i: {
									x: 0.833,
									y: 0.867
								},
								s: [
									185.791,
									256.158
								],
								t: 73.926,
								ti: [
									-0.082,
									0.022,
									0
								],
								to: [
									0.1,
									-0.031,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.17
								},
								i: {
									x: 0.833,
									y: 0.85
								},
								s: [
									186.06,
									256.075
								],
								t: 75.924,
								ti: [
									-0.073,
									0.001,
									0
								],
								to: [
									0.082,
									-0.022,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.157
								},
								i: {
									x: 0.833,
									y: 0.837
								},
								s: [
									186.284,
									256.027
								],
								t: 77.921,
								ti: [
									-0.069,
									-0.03,
									0
								],
								to: [
									0.073,
									-1e-3,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.09
								},
								i: {
									x: 0.833,
									y: 0.895
								},
								s: [
									186.495,
									256.07
								],
								t: 79.919,
								ti: [
									-0.067,
									-0.059,
									0
								],
								to: [
									0.069,
									0.03,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.046
								},
								i: {
									x: 0.833,
									y: 0.945
								},
								s: [
									186.699,
									256.205
								],
								t: 81.917,
								ti: [
									-0.065,
									-0.084,
									0
								],
								to: [
									0.067,
									0.059,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.027
								},
								i: {
									x: 0.833,
									y: 0.969
								},
								s: [
									186.897,
									256.422
								],
								t: 83.915,
								ti: [
									-0.063,
									-0.106,
									0
								],
								to: [
									0.065,
									0.084,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.017
								},
								i: {
									x: 0.833,
									y: 0.982
								},
								s: [
									187.09,
									256.71
								],
								t: 85.913,
								ti: [
									-0.062,
									-0.125,
									0
								],
								to: [
									0.063,
									0.106,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.011
								},
								i: {
									x: 0.833,
									y: 0.988
								},
								s: [
									187.278,
									257.059
								],
								t: 87.911,
								ti: [
									-0.059,
									-0.141,
									0
								],
								to: [
									0.062,
									0.125,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.008
								},
								i: {
									x: 0.833,
									y: 0.992
								},
								s: [
									187.46,
									257.46
								],
								t: 89.909,
								ti: [
									-0.057,
									-0.153,
									0
								],
								to: [
									0.059,
									0.141,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.006
								},
								i: {
									x: 0.833,
									y: 0.994
								},
								s: [
									187.635,
									257.904
								],
								t: 91.907,
								ti: [
									-0.059,
									-0.163,
									0
								],
								to: [
									0.057,
									0.153,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.007
								},
								i: {
									x: 0.833,
									y: 0.993
								},
								s: [
									187.802,
									258.381
								],
								t: 93.905,
								ti: [
									-0.07,
									-0.168,
									0
								],
								to: [
									0.059,
									0.163,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.012
								},
								i: {
									x: 0.833,
									y: 0.988
								},
								s: [
									187.988,
									258.88
								],
								t: 95.903,
								ti: [
									-0.084,
									-0.171,
									0
								],
								to: [
									0.07,
									0.168,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.016
								},
								i: {
									x: 0.833,
									y: 0.983
								},
								s: [
									188.22,
									259.391
								],
								t: 97.901,
								ti: [
									-0.097,
									-0.171,
									0
								],
								to: [
									0.084,
									0.171,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.023
								},
								i: {
									x: 0.833,
									y: 0.977
								},
								s: [
									188.492,
									259.907
								],
								t: 99.899,
								ti: [
									-0.108,
									-0.169,
									0
								],
								to: [
									0.097,
									0.171,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.028
								},
								i: {
									x: 0.833,
									y: 0.971
								},
								s: [
									188.799,
									260.419
								],
								t: 101.897,
								ti: [
									-0.117,
									-0.165,
									0
								],
								to: [
									0.108,
									0.169,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.035
								},
								i: {
									x: 0.833,
									y: 0.965
								},
								s: [
									189.138,
									260.923
								],
								t: 103.895,
								ti: [
									-0.125,
									-0.159,
									0
								],
								to: [
									0.117,
									0.165,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.043
								},
								i: {
									x: 0.833,
									y: 0.957
								},
								s: [
									189.502,
									261.41
								],
								t: 105.893,
								ti: [
									-0.13,
									-0.151,
									0
								],
								to: [
									0.125,
									0.159,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.051
								},
								i: {
									x: 0.833,
									y: 0.95
								},
								s: [
									189.886,
									261.876
								],
								t: 107.891,
								ti: [
									-0.134,
									-0.141,
									0
								],
								to: [
									0.13,
									0.151,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.059
								},
								i: {
									x: 0.833,
									y: 0.943
								},
								s: [
									190.284,
									262.315
								],
								t: 109.889,
								ti: [
									-0.135,
									-0.13,
									0
								],
								to: [
									0.134,
									0.141,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.069
								},
								i: {
									x: 0.833,
									y: 0.934
								},
								s: [
									190.69,
									262.722
								],
								t: 111.887,
								ti: [
									-0.135,
									-0.117,
									0
								],
								to: [
									0.135,
									0.13,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.08
								},
								i: {
									x: 0.833,
									y: 0.926
								},
								s: [
									191.097,
									263.093
								],
								t: 113.885,
								ti: [
									-0.132,
									-0.103,
									0
								],
								to: [
									0.135,
									0.117,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.09
								},
								i: {
									x: 0.833,
									y: 0.912
								},
								s: [
									191.499,
									263.423
								],
								t: 115.883,
								ti: [
									-0.065,
									-0.048,
									0
								],
								to: [
									0.132,
									0.103,
									0
								]
							},
							{
								s: [
									191.888,
									263.709
								],
								t: 117.881
							}
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									0
								],
								t: 13.986
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 23.976
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 67.932
							},
							{
								s: [
									0
								],
								t: 99.899
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "Rectangle 1",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0.012,
												10.621
											],
											[
												-5.695,
												5.34
											],
											[
												-2.557,
												-7.377
											],
											[
												3.15,
												-2.096
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "Fill 1",
								c: {
									a: 0,
									k: [
										0.137,
										0.459,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										-3.421,
										4.043
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 13
			},
			{
				ty: 4,
				nm: "Shape Layer 56",
				sr: 1,
				st: 3.996,
				op: 149.85,
				ip: 3.996,
				ln: "6949",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									150.023,
									84.302
								],
								t: 3.996
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									115.536,
									94.772
								],
								t: 5.994
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									101.947,
									84.391
								],
								t: 7.992
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									69.48,
									67.085
								],
								t: 9.99
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									52.556,
									63.303
								],
								t: 11.988
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									76.674,
									80.31
								],
								t: 13.986
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									55.698,
									101.414
								],
								t: 15.984
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									40.385,
									120.878
								],
								t: 17.982
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									19.82,
									111.938
								],
								t: 19.98
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									78.004,
									125.754
								],
								t: 21.978
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									51.803,
									75.606
								],
								t: 23.976
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									82.948,
									47.853
								],
								t: 25.974
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									71.038,
									46.152
								],
								t: 27.972
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									91.761,
									46.937
								],
								t: 29.97
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									99.655,
									57.625
								],
								t: 31.968
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									112.222,
									122.076
								],
								t: 33.966
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									111.361,
									120.336
								],
								t: 35.964
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									111.012,
									117.65
								],
								t: 37.962
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									124.959,
									96.101
								],
								t: 39.96
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									73.624,
									74.745
								],
								t: 41.958
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									79.474,
									96.927
								],
								t: 43.956
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									39.363,
									83.33
								],
								t: 45.954
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									47.32,
									90.031
								],
								t: 47.952
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									92.847,
									97.529
								],
								t: 49.95
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									72.017,
									148.186
								],
								t: 51.948
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									84.935,
									114.918
								],
								t: 53.946
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									115.633,
									56.769
								],
								t: 55.944
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									71.733,
									63.301
								],
								t: 57.942
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									71.982,
									53.5
								],
								t: 59.94
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									84.68,
									111.004
								],
								t: 61.938
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									96.026,
									124.642
								],
								t: 63.936
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									44.359,
									68.117
								],
								t: 65.934
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									16.99,
									33.186
								],
								t: 67.931
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									71.31,
									31.618
								],
								t: 69.929
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									30.563,
									51.009
								],
								t: 71.927
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-2.843,
									83.398
								],
								t: 73.925
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									15.771,
									36.624
								],
								t: 75.923
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									6.523,
									25.933
								],
								t: 77.921
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									36.606,
									28.591
								],
								t: 79.919
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									33.84,
									58.624
								],
								t: 81.917
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									46.823,
									19.638
								],
								t: 83.915
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									56.147,
									-3.469
								],
								t: 85.913
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									44.338,
									8.441
								],
								t: 87.911
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									8.892,
									30.372
								],
								t: 89.909
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-11.629,
									50.878
								],
								t: 91.907
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									26.385,
									8.842
								],
								t: 93.905
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-18.969,
									35.342
								],
								t: 95.903
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									33.051,
									65.059
								],
								t: 97.901
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									19.792,
									-16.798
								],
								t: 99.899
							},
							{
								s: [
									53.472,
									-1.378
								],
								t: 101.897
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									278.346,
									255.953
								],
								t: 3.996,
								ti: [
									0.991,
									1.248,
									0
								],
								to: [
									-0.206,
									-0.234,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									277.109,
									254.547
								],
								t: 5.994,
								ti: [
									0.533,
									2.822,
									0
								],
								to: [
									-0.991,
									-1.248,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									272.4,
									248.463
								],
								t: 7.992,
								ti: [
									-2.874,
									1.607,
									0
								],
								to: [
									-0.533,
									-2.822,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.137
								},
								i: {
									x: 0.833,
									y: 0.851
								},
								s: [
									273.909,
									237.613
								],
								t: 9.99,
								ti: [
									-4.877,
									-0.657,
									0
								],
								to: [
									2.874,
									-1.607,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.168
								},
								i: {
									x: 0.833,
									y: 0.857
								},
								s: [
									289.644,
									238.823
								],
								t: 11.988,
								ti: [
									-4.118,
									-0.868,
									0
								],
								to: [
									4.877,
									0.657,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.172
								},
								i: {
									x: 0.833,
									y: 0.859
								},
								s: [
									303.171,
									241.554
								],
								t: 13.986,
								ti: [
									-3.424,
									-0.757,
									0
								],
								to: [
									4.118,
									0.868,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.171
								},
								i: {
									x: 0.833,
									y: 0.858
								},
								s: [
									314.351,
									244.031
								],
								t: 15.984,
								ti: [
									-2.889,
									-0.625,
									0
								],
								to: [
									3.424,
									0.757,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.169
								},
								i: {
									x: 0.833,
									y: 0.854
								},
								s: [
									323.717,
									246.095
								],
								t: 17.982,
								ti: [
									-2.477,
									-0.51,
									0
								],
								to: [
									2.889,
									0.625,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.17
								},
								i: {
									x: 0.833,
									y: 0.853
								},
								s: [
									331.687,
									247.782
								],
								t: 19.98,
								ti: [
									-2.154,
									-0.414,
									0
								],
								to: [
									2.477,
									0.51,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.17
								},
								i: {
									x: 0.833,
									y: 0.852
								},
								s: [
									338.58,
									249.155
								],
								t: 21.978,
								ti: [
									-1.892,
									-0.333,
									0
								],
								to: [
									2.154,
									0.414,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.171
								},
								i: {
									x: 0.833,
									y: 0.849
								},
								s: [
									344.611,
									250.265
								],
								t: 23.976,
								ti: [
									-1.675,
									-0.265,
									0
								],
								to: [
									1.892,
									0.333,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.171
								},
								i: {
									x: 0.833,
									y: 0.848
								},
								s: [
									349.933,
									251.155
								],
								t: 25.974,
								ti: [
									-1.493,
									-0.207,
									0
								],
								to: [
									1.675,
									0.265,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.173
								},
								i: {
									x: 0.833,
									y: 0.844
								},
								s: [
									354.663,
									251.856
								],
								t: 27.972,
								ti: [
									-1.344,
									-0.162,
									0
								],
								to: [
									1.493,
									0.207,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.173
								},
								i: {
									x: 0.833,
									y: 0.843
								},
								s: [
									358.894,
									252.395
								],
								t: 29.97,
								ti: [
									-1.227,
									-0.138,
									0
								],
								to: [
									1.344,
									0.162,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.171
								},
								i: {
									x: 0.833,
									y: 0.843
								},
								s: [
									362.724,
									252.827
								],
								t: 31.968,
								ti: [
									-1.133,
									-0.127,
									0
								],
								to: [
									1.227,
									0.138,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.17
								},
								i: {
									x: 0.833,
									y: 0.842
								},
								s: [
									366.255,
									253.222
								],
								t: 33.966,
								ti: [
									-1.051,
									-0.117,
									0
								],
								to: [
									1.133,
									0.127,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.17
								},
								i: {
									x: 0.833,
									y: 0.842
								},
								s: [
									369.523,
									253.587
								],
								t: 35.964,
								ti: [
									-0.978,
									-0.109,
									0
								],
								to: [
									1.051,
									0.117,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.17
								},
								i: {
									x: 0.833,
									y: 0.842
								},
								s: [
									372.561,
									253.926
								],
								t: 37.962,
								ti: [
									-0.912,
									-0.101,
									0
								],
								to: [
									0.978,
									0.109,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.17
								},
								i: {
									x: 0.833,
									y: 0.842
								},
								s: [
									375.391,
									254.24
								],
								t: 39.96,
								ti: [
									-0.852,
									-0.093,
									0
								],
								to: [
									0.912,
									0.101,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.17
								},
								i: {
									x: 0.833,
									y: 0.842
								},
								s: [
									378.033,
									254.529
								],
								t: 41.958,
								ti: [
									-0.796,
									-0.085,
									0
								],
								to: [
									0.852,
									0.093,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.169
								},
								i: {
									x: 0.833,
									y: 0.842
								},
								s: [
									380.502,
									254.795
								],
								t: 43.956,
								ti: [
									-0.745,
									-0.076,
									0
								],
								to: [
									0.796,
									0.085,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.169
								},
								i: {
									x: 0.833,
									y: 0.842
								},
								s: [
									382.812,
									255.037
								],
								t: 45.954,
								ti: [
									-0.697,
									-0.068,
									0
								],
								to: [
									0.745,
									0.076,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.169
								},
								i: {
									x: 0.833,
									y: 0.842
								},
								s: [
									384.972,
									255.253
								],
								t: 47.952,
								ti: [
									-0.651,
									-0.059,
									0
								],
								to: [
									0.697,
									0.068,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.17
								},
								i: {
									x: 0.833,
									y: 0.842
								},
								s: [
									386.993,
									255.443
								],
								t: 49.95,
								ti: [
									-0.608,
									-0.05,
									0
								],
								to: [
									0.651,
									0.059,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.17
								},
								i: {
									x: 0.833,
									y: 0.84
								},
								s: [
									388.881,
									255.606
								],
								t: 51.948,
								ti: [
									-0.567,
									-0.04,
									0
								],
								to: [
									0.608,
									0.05,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.172
								},
								i: {
									x: 0.833,
									y: 0.839
								},
								s: [
									390.642,
									255.741
								],
								t: 53.946,
								ti: [
									-0.527,
									-0.03,
									0
								],
								to: [
									0.567,
									0.04,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.173
								},
								i: {
									x: 0.833,
									y: 0.84
								},
								s: [
									392.281,
									255.845
								],
								t: 55.944,
								ti: [
									-0.488,
									-0.019,
									0
								],
								to: [
									0.527,
									0.03,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.174
								},
								i: {
									x: 0.833,
									y: 0.84
								},
								s: [
									393.801,
									255.919
								],
								t: 57.942,
								ti: [
									-0.45,
									-8e-3,
									0
								],
								to: [
									0.488,
									0.019,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.174
								},
								i: {
									x: 0.833,
									y: 0.841
								},
								s: [
									395.207,
									255.96
								],
								t: 59.94,
								ti: [
									-0.412,
									0.002,
									0
								],
								to: [
									0.45,
									0.008,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.175
								},
								i: {
									x: 0.833,
									y: 0.841
								},
								s: [
									396.499,
									255.969
								],
								t: 61.938,
								ti: [
									-0.375,
									0.014,
									0
								],
								to: [
									0.412,
									-2e-3,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.175
								},
								i: {
									x: 0.833,
									y: 0.842
								},
								s: [
									397.679,
									255.945
								],
								t: 63.936,
								ti: [
									-0.338,
									0.025,
									0
								],
								to: [
									0.375,
									-0.014,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.173
								},
								i: {
									x: 0.833,
									y: 0.846
								},
								s: [
									398.748,
									255.888
								],
								t: 65.934,
								ti: [
									-0.301,
									0.036,
									0
								],
								to: [
									0.338,
									-0.025,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.171
								},
								i: {
									x: 0.833,
									y: 0.849
								},
								s: [
									399.706,
									255.797
								],
								t: 67.931,
								ti: [
									-0.264,
									0.047,
									0
								],
								to: [
									0.301,
									-0.036,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.166
								},
								i: {
									x: 0.833,
									y: 0.853
								},
								s: [
									400.554,
									255.673
								],
								t: 69.929,
								ti: [
									-0.227,
									0.057,
									0
								],
								to: [
									0.264,
									-0.047,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.158
								},
								i: {
									x: 0.833,
									y: 0.865
								},
								s: [
									401.291,
									255.517
								],
								t: 71.927,
								ti: [
									-0.189,
									0.067,
									0
								],
								to: [
									0.227,
									-0.057,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.141
								},
								i: {
									x: 0.833,
									y: 0.881
								},
								s: [
									401.915,
									255.33
								],
								t: 73.925,
								ti: [
									-0.151,
									0.077,
									0
								],
								to: [
									0.189,
									-0.067,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.113
								},
								i: {
									x: 0.833,
									y: 0.907
								},
								s: [
									402.427,
									255.112
								],
								t: 75.923,
								ti: [
									-0.113,
									0.086,
									0
								],
								to: [
									0.151,
									-0.077,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.067
								},
								i: {
									x: 0.833,
									y: 0.943
								},
								s: [
									402.824,
									254.867
								],
								t: 77.921,
								ti: [
									-0.074,
									0.094,
									0
								],
								to: [
									0.113,
									-0.086,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.02
								},
								i: {
									x: 0.833,
									y: 0.982
								},
								s: [
									403.104,
									254.596
								],
								t: 79.919,
								ti: [
									-0.034,
									0.101,
									0
								],
								to: [
									0.074,
									-0.094,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									403.266,
									254.302
								],
								t: 81.917,
								ti: [
									0.002,
									0.108,
									0
								],
								to: [
									0.034,
									-0.101,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									403.307,
									253.989
								],
								t: 83.915,
								ti: [
									0.028,
									0.114,
									0
								],
								to: [
									-2e-3,
									-0.108,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									403.256,
									253.656
								],
								t: 85.913,
								ti: [
									0.05,
									0.119,
									0
								],
								to: [
									-0.028,
									-0.114,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									403.14,
									253.307
								],
								t: 87.911,
								ti: [
									0.071,
									0.117,
									0
								],
								to: [
									-0.05,
									-0.119,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									402.953,
									252.945
								],
								t: 89.909,
								ti: [
									0.081,
									0.103,
									0
								],
								to: [
									-0.071,
									-0.117,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									402.716,
									252.603
								],
								t: 91.907,
								ti: [
									0.084,
									0.081,
									0
								],
								to: [
									-0.081,
									-0.103,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									402.468,
									252.328
								],
								t: 93.905,
								ti: [
									0.087,
									0.059,
									0
								],
								to: [
									-0.084,
									-0.081,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									402.212,
									252.118
								],
								t: 95.903,
								ti: [
									0.089,
									0.038,
									0
								],
								to: [
									-0.087,
									-0.059,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									401.947,
									251.973
								],
								t: 97.901,
								ti: [
									0.091,
									0.018,
									0
								],
								to: [
									-0.089,
									-0.038,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									401.676,
									251.89
								],
								t: 99.899,
								ti: [
									0.046,
									0.004,
									0
								],
								to: [
									-0.091,
									-0.018,
									0
								]
							},
							{
								s: [
									401.399,
									251.868
								],
								t: 101.897
							}
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									0
								],
								t: 3.996
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 13.986
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 57.942
							},
							{
								s: [
									0
								],
								t: 89.909
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "Rectangle 1",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0.012,
												10.621
											],
											[
												-5.695,
												5.34
											],
											[
												-2.557,
												-7.377
											],
											[
												3.15,
												-2.096
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "Fill 1",
								c: {
									a: 0,
									k: [
										0.137,
										0.459,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										-3.421,
										4.043
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 14
			},
			{
				ty: 4,
				nm: "Shape Layer 54",
				sr: 1,
				st: 9.99,
				op: 149.85,
				ip: 9.99,
				ln: "6948",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									49.45,
									148.28
								],
								t: 9.99
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									96.233,
									59.296
								],
								t: 11.988
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									84.39,
									38.927
								],
								t: 13.986
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									101.568,
									62.764
								],
								t: 15.984
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									106.222,
									57.834
								],
								t: 17.982
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									64.691,
									35.274
								],
								t: 19.98
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									70.923,
									57.653
								],
								t: 21.978
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									127.324,
									74.727
								],
								t: 23.976
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									101.458,
									99.601
								],
								t: 25.974
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									73.693,
									68.044
								],
								t: 27.972
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									79.522,
									77.427
								],
								t: 29.97
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									46.671,
									43.016
								],
								t: 31.968
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									104.84,
									38.219
								],
								t: 33.966
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									97.095,
									66.774
								],
								t: 35.964
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									45.158,
									58.378
								],
								t: 37.962
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									100.992,
									91.978
								],
								t: 39.96
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									80.364,
									100.301
								],
								t: 41.958
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									89.494,
									62.471
								],
								t: 43.956
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									104.25,
									68.373
								],
								t: 45.954
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									122.573,
									87.899
								],
								t: 47.952
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									63.056,
									70.386
								],
								t: 49.95
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									66.633,
									34.869
								],
								t: 51.948
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									129.403,
									72.011
								],
								t: 53.946
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									112.863,
									90.111
								],
								t: 55.944
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									86.228,
									114.396
								],
								t: 57.942
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									50.891,
									82.427
								],
								t: 59.94
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									55.82,
									44.045
								],
								t: 61.938
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									49.632,
									53.61
								],
								t: 63.936
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									74.255,
									114.253
								],
								t: 65.934
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									80.651,
									78.395
								],
								t: 67.932
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									74.861,
									75.817
								],
								t: 69.93
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									19.702,
									76.263
								],
								t: 71.928
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									37.393,
									80.265
								],
								t: 73.925
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									61.705,
									41.546
								],
								t: 75.923
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									55.488,
									100.178
								],
								t: 77.921
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									24.961,
									77.623
								],
								t: 79.919
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									0.375,
									68.025
								],
								t: 81.917
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									36.365,
									33.155
								],
								t: 83.915
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-12.521,
									56.708
								],
								t: 85.913
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									42.47,
									-4.293
								],
								t: 87.911
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									76.363,
									33.422
								],
								t: 89.909
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									13.419,
									37.087
								],
								t: 91.907
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									40.835,
									16.71
								],
								t: 93.905
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									20.376,
									34.131
								],
								t: 95.903
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									26.948,
									1.687
								],
								t: 97.901
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									27.375,
									36.914
								],
								t: 99.899
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									15.071,
									41.282
								],
								t: 101.897
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									53.354,
									66.388
								],
								t: 103.895
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									22.228,
									81.077
								],
								t: 105.893
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									1.727,
									-9.051
								],
								t: 107.891
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-9.032,
									27.824
								],
								t: 109.889
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									20.502,
									3.731
								],
								t: 111.887
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									35.73,
									4.373
								],
								t: 113.885
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									58.616,
									37.243
								],
								t: 115.883
							},
							{
								s: [
									30.021,
									32.047
								],
								t: 117.881
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									280.895,
									263.305
								],
								t: 9.99,
								ti: [
									2.713,
									-0.992,
									0
								],
								to: [
									-0.567,
									0.175,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									277.49,
									264.357
								],
								t: 11.988,
								ti: [
									6.007,
									-2.449,
									0
								],
								to: [
									-2.713,
									0.992,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									264.618,
									269.257
								],
								t: 13.986,
								ti: [
									8.091,
									-3.591,
									0
								],
								to: [
									-6.007,
									2.449,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									241.447,
									279.054
								],
								t: 15.984,
								ti: [
									7.873,
									-3.782,
									0
								],
								to: [
									-8.091,
									3.591,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									216.07,
									290.801
								],
								t: 17.982,
								ti: [
									6.648,
									-3.432,
									0
								],
								to: [
									-7.873,
									3.782,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									194.207,
									301.746
								],
								t: 19.98,
								ti: [
									5.503,
									-3.025,
									0
								],
								to: [
									-6.648,
									3.432,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									176.185,
									311.391
								],
								t: 21.978,
								ti: [
									4.615,
									-2.683,
									0
								],
								to: [
									-5.503,
									3.025,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									161.19,
									319.898
								],
								t: 23.976,
								ti: [
									3.935,
									-2.407,
									0
								],
								to: [
									-4.615,
									2.683,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									148.493,
									327.489
								],
								t: 25.974,
								ti: [
									3.399,
									-2.181,
									0
								],
								to: [
									-3.935,
									2.407,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									137.583,
									334.338
								],
								t: 27.972,
								ti: [
									2.966,
									-1.993,
									0
								],
								to: [
									-3.399,
									2.181,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									128.098,
									340.575
								],
								t: 29.97,
								ti: [
									2.607,
									-1.832,
									0
								],
								to: [
									-2.966,
									1.993,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									119.785,
									346.294
								],
								t: 31.968,
								ti: [
									2.302,
									-1.693,
									0
								],
								to: [
									-2.607,
									1.832,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									112.455,
									351.568
								],
								t: 33.966,
								ti: [
									2.037,
									-1.57,
									0
								],
								to: [
									-2.302,
									1.693,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									105.973,
									356.452
								],
								t: 35.964,
								ti: [
									1.803,
									-1.461,
									0
								],
								to: [
									-2.037,
									1.57,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									100.233,
									360.99
								],
								t: 37.962,
								ti: [
									1.593,
									-1.362,
									0
								],
								to: [
									-1.803,
									1.461,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									95.155,
									365.216
								],
								t: 39.96,
								ti: [
									1.401,
									-1.271,
									0
								],
								to: [
									-1.593,
									1.362,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									90.677,
									369.16
								],
								t: 41.958,
								ti: [
									1.224,
									-1.188,
									0
								],
								to: [
									-1.401,
									1.271,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									86.752,
									372.844
								],
								t: 43.956,
								ti: [
									1.07,
									-1.108,
									0
								],
								to: [
									-1.224,
									1.188,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									83.332,
									376.285
								],
								t: 45.954,
								ti: [
									0.937,
									-1.031,
									0
								],
								to: [
									-1.07,
									1.108,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									80.332,
									379.49
								],
								t: 47.952,
								ti: [
									0.818,
									-0.958,
									0
								],
								to: [
									-0.937,
									1.031,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									77.708,
									382.471
								],
								t: 49.95,
								ti: [
									0.71,
									-0.889,
									0
								],
								to: [
									-0.818,
									0.958,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									75.425,
									385.239
								],
								t: 51.948,
								ti: [
									0.612,
									-0.822,
									0
								],
								to: [
									-0.71,
									0.889,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									73.45,
									387.804
								],
								t: 53.946,
								ti: [
									0.523,
									-0.758,
									0
								],
								to: [
									-0.612,
									0.822,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									71.754,
									390.173
								],
								t: 55.944,
								ti: [
									0.442,
									-0.696,
									0
								],
								to: [
									-0.523,
									0.758,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									70.313,
									392.354
								],
								t: 57.942,
								ti: [
									0.369,
									-0.637,
									0
								],
								to: [
									-0.442,
									0.696,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									69.102,
									394.352
								],
								t: 59.94,
								ti: [
									0.304,
									-0.579,
									0
								],
								to: [
									-0.369,
									0.637,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									68.096,
									396.175
								],
								t: 61.938,
								ti: [
									0.245,
									-0.524,
									0
								],
								to: [
									-0.304,
									0.579,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									67.277,
									397.829
								],
								t: 63.936,
								ti: [
									0.193,
									-0.471,
									0
								],
								to: [
									-0.245,
									0.524,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									66.624,
									399.32
								],
								t: 65.934,
								ti: [
									0.147,
									-0.42,
									0
								],
								to: [
									-0.193,
									0.471,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									66.118,
									400.656
								],
								t: 67.932,
								ti: [
									0.105,
									-0.37,
									0
								],
								to: [
									-0.147,
									0.42,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									65.744,
									401.84
								],
								t: 69.93,
								ti: [
									0.069,
									-0.322,
									0
								],
								to: [
									-0.105,
									0.37,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									65.487,
									402.877
								],
								t: 71.928,
								ti: [
									0.037,
									-0.276,
									0
								],
								to: [
									-0.069,
									0.322,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									65.332,
									403.773
								],
								t: 73.925,
								ti: [
									0.009,
									-0.231,
									0
								],
								to: [
									-0.037,
									0.276,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									65.265,
									404.532
								],
								t: 75.923,
								ti: [
									-0.014,
									-0.188,
									0
								],
								to: [
									-9e-3,
									0.231,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.001
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									65.276,
									405.16
								],
								t: 77.921,
								ti: [
									-0.034,
									-0.146,
									0
								],
								to: [
									0.014,
									0.188,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.007
								},
								i: {
									x: 0.833,
									y: 0.995
								},
								s: [
									65.351,
									405.66
								],
								t: 79.919,
								ti: [
									-0.051,
									-0.106,
									0
								],
								to: [
									0.034,
									0.146,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.033
								},
								i: {
									x: 0.833,
									y: 0.973
								},
								s: [
									65.481,
									406.037
								],
								t: 81.917,
								ti: [
									-0.064,
									-0.066,
									0
								],
								to: [
									0.051,
									0.106,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.104
								},
								i: {
									x: 0.833,
									y: 0.909
								},
								s: [
									65.655,
									406.293
								],
								t: 83.915,
								ti: [
									-0.074,
									-0.028,
									0
								],
								to: [
									0.064,
									0.066,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.163
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									65.864,
									406.433
								],
								t: 85.913,
								ti: [
									-0.081,
									0.01,
									0
								],
								to: [
									0.074,
									0.028,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.132
								},
								i: {
									x: 0.833,
									y: 0.855
								},
								s: [
									66.098,
									406.459
								],
								t: 87.911,
								ti: [
									-0.083,
									0.038,
									0
								],
								to: [
									0.081,
									-0.01,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.104
								},
								i: {
									x: 0.833,
									y: 0.896
								},
								s: [
									66.349,
									406.373
								],
								t: 89.909,
								ti: [
									-0.078,
									0.048,
									0
								],
								to: [
									0.083,
									-0.038,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.099
								},
								i: {
									x: 0.833,
									y: 0.908
								},
								s: [
									66.596,
									406.231
								],
								t: 91.907,
								ti: [
									-0.069,
									0.051,
									0
								],
								to: [
									0.078,
									-0.048,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.081
								},
								i: {
									x: 0.833,
									y: 0.926
								},
								s: [
									66.819,
									406.083
								],
								t: 93.905,
								ti: [
									-0.057,
									0.054,
									0
								],
								to: [
									0.069,
									-0.051,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.052
								},
								i: {
									x: 0.833,
									y: 0.953
								},
								s: [
									67.01,
									405.928
								],
								t: 95.903,
								ti: [
									-0.042,
									0.058,
									0
								],
								to: [
									0.057,
									-0.054,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.019
								},
								i: {
									x: 0.833,
									y: 0.982
								},
								s: [
									67.16,
									405.761
								],
								t: 97.901,
								ti: [
									-0.023,
									0.063,
									0
								],
								to: [
									0.042,
									-0.058,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.001
								},
								i: {
									x: 0.833,
									y: 0.999
								},
								s: [
									67.259,
									405.58
								],
								t: 99.899,
								ti: [
									-1e-3,
									0.07,
									0
								],
								to: [
									0.023,
									-0.063,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									67.298,
									405.38
								],
								t: 101.897,
								ti: [
									0.023,
									0.076,
									0
								],
								to: [
									0.001,
									-0.07,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									67.266,
									405.158
								],
								t: 103.895,
								ti: [
									0.046,
									0.073,
									0
								],
								to: [
									-0.023,
									-0.076,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									67.158,
									404.922
								],
								t: 105.893,
								ti: [
									0.062,
									0.06,
									0
								],
								to: [
									-0.046,
									-0.073,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									66.993,
									404.72
								],
								t: 107.891,
								ti: [
									0.076,
									0.046,
									0
								],
								to: [
									-0.062,
									-0.06,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									66.783,
									404.561
								],
								t: 109.889,
								ti: [
									0.086,
									0.031,
									0
								],
								to: [
									-0.076,
									-0.046,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									66.539,
									404.446
								],
								t: 111.887,
								ti: [
									0.093,
									0.016,
									0
								],
								to: [
									-0.086,
									-0.031,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									66.269,
									404.376
								],
								t: 113.885,
								ti: [
									0.097,
									0,
									0
								],
								to: [
									-0.093,
									-0.016,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									65.982,
									404.352
								],
								t: 115.883,
								ti: [
									0.049,
									-4e-3,
									0
								],
								to: [
									-0.097,
									0,
									0
								]
							},
							{
								s: [
									65.686,
									404.375
								],
								t: 117.881
							}
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									0
								],
								t: 9.99
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 19.98
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 63.936
							},
							{
								s: [
									0
								],
								t: 95.903
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "Rectangle 1",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0.012,
												10.621
											],
											[
												-5.695,
												5.34
											],
											[
												-2.557,
												-7.377
											],
											[
												3.15,
												-2.096
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "Fill 1",
								c: {
									a: 0,
									k: [
										0.137,
										0.459,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										-3.421,
										4.043
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 15
			},
			{
				ty: 4,
				nm: "Shape Layer 53",
				sr: 1,
				st: 29.97,
				op: 149.85,
				ip: 29.97,
				ln: "6947",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									127.438,
									90.591
								],
								t: 29.97
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									90.096,
									28.016
								],
								t: 31.968
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									67.312,
									81.384
								],
								t: 33.966
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									122.538,
									69.77
								],
								t: 35.964
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									102.02,
									98.906
								],
								t: 37.962
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									60.035,
									90.043
								],
								t: 39.96
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									71.968,
									116.451
								],
								t: 41.958
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									64.586,
									63.443
								],
								t: 43.956
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									109.991,
									44.631
								],
								t: 45.954
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									126.937,
									59.824
								],
								t: 47.952
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									85.604,
									73.442
								],
								t: 49.95
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									70.771,
									70.802
								],
								t: 51.948
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									80.389,
									96.73
								],
								t: 53.946
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									90.289,
									87.923
								],
								t: 55.944
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									90.772,
									58.569
								],
								t: 57.942
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									95.049,
									54.421
								],
								t: 59.94
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									60.54,
									68.48
								],
								t: 61.938
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									44.437,
									36.222
								],
								t: 63.936
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									124.279,
									47.844
								],
								t: 65.934
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									139.353,
									46.441
								],
								t: 67.932
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									137.147,
									101.148
								],
								t: 69.93
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									77.097,
									103.625
								],
								t: 71.928
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									52.92,
									67.602
								],
								t: 73.926
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									38.391,
									66.346
								],
								t: 75.924
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									80.849,
									88.417
								],
								t: 77.922
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									101.514,
									109.026
								],
								t: 79.92
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									66.389,
									95.048
								],
								t: 81.918
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									58.31,
									67.448
								],
								t: 83.916
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									89.867,
									114.12
								],
								t: 85.914
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									99.232,
									53.341
								],
								t: 87.912
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									84.926,
									94.953
								],
								t: 89.91
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									28.265,
									109.679
								],
								t: 91.908
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									24.92,
									76.564
								],
								t: 93.905
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									45.873,
									56.751
								],
								t: 95.903
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									16.102,
									65.143
								],
								t: 97.901
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									27.313,
									-5.503
								],
								t: 99.899
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									69.528,
									52.086
								],
								t: 101.897
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									13.347,
									55.885
								],
								t: 103.895
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									17.457,
									26.517
								],
								t: 105.893
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-6.114,
									46.16
								],
								t: 107.891
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									14.941,
									35.961
								],
								t: 109.889
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									17.614,
									44.753
								],
								t: 111.887
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									12.402,
									22.217
								],
								t: 113.885
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									31.658,
									24.926
								],
								t: 115.883
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-22.38,
									66.727
								],
								t: 117.881
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									0.27,
									30.796
								],
								t: 119.879
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									10.423,
									7.981
								],
								t: 121.877
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									20.367,
									26.148
								],
								t: 123.875
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									30.864,
									-6.905
								],
								t: 125.873
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									43.453,
									19.525
								],
								t: 127.871
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									29.038,
									24.824
								],
								t: 129.869
							},
							{
								s: [
									41.021,
									15.933
								],
								t: 131.867
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									272.114,
									255.071
								],
								t: 29.97,
								ti: [
									1.216,
									-0.382,
									0
								],
								to: [
									-0.266,
									0.053,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									270.517,
									255.387
								],
								t: 31.968,
								ti: [
									2.644,
									-1.017,
									0
								],
								to: [
									-1.216,
									0.382,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									264.819,
									257.361
								],
								t: 33.966,
								ti: [
									3.502,
									-1.605,
									0
								],
								to: [
									-2.644,
									1.017,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									254.654,
									261.49
								],
								t: 35.964,
								ti: [
									3.128,
									-2.062,
									0
								],
								to: [
									-3.502,
									1.605,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									243.809,
									266.989
								],
								t: 37.962,
								ti: [
									0.929,
									-2.4,
									0
								],
								to: [
									-3.128,
									2.062,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.005
								},
								i: {
									x: 0.833,
									y: 0.996
								},
								s: [
									235.889,
									273.86
								],
								t: 39.96,
								ti: [
									-1.493,
									-1.834,
									0
								],
								to: [
									-0.929,
									2.4,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.116
								},
								i: {
									x: 0.833,
									y: 0.896
								},
								s: [
									238.235,
									281.389
								],
								t: 41.958,
								ti: [
									-2.114,
									-0.944,
									0
								],
								to: [
									1.493,
									1.834,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.15
								},
								i: {
									x: 0.833,
									y: 0.87
								},
								s: [
									244.846,
									284.864
								],
								t: 43.956,
								ti: [
									-1.909,
									-0.642,
									0
								],
								to: [
									2.114,
									0.944,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.156
								},
								i: {
									x: 0.833,
									y: 0.864
								},
								s: [
									250.917,
									287.051
								],
								t: 45.954,
								ti: [
									-1.697,
									-0.51,
									0
								],
								to: [
									1.909,
									0.642,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.156
								},
								i: {
									x: 0.833,
									y: 0.86
								},
								s: [
									256.301,
									288.717
								],
								t: 47.952,
								ti: [
									-1.516,
									-0.438,
									0
								],
								to: [
									1.697,
									0.51,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.156
								},
								i: {
									x: 0.833,
									y: 0.86
								},
								s: [
									261.1,
									290.112
								],
								t: 49.95,
								ti: [
									-1.362,
									-0.392,
									0
								],
								to: [
									1.516,
									0.438,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.155
								},
								i: {
									x: 0.833,
									y: 0.859
								},
								s: [
									265.397,
									291.343
								],
								t: 51.948,
								ti: [
									-1.229,
									-0.362,
									0
								],
								to: [
									1.362,
									0.392,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.154
								},
								i: {
									x: 0.833,
									y: 0.86
								},
								s: [
									269.269,
									292.467
								],
								t: 53.946,
								ti: [
									-1.114,
									-0.341,
									0
								],
								to: [
									1.229,
									0.362,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.152
								},
								i: {
									x: 0.833,
									y: 0.862
								},
								s: [
									272.774,
									293.517
								],
								t: 55.944,
								ti: [
									-1.012,
									-0.326,
									0
								],
								to: [
									1.114,
									0.341,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.15
								},
								i: {
									x: 0.833,
									y: 0.863
								},
								s: [
									275.955,
									294.515
								],
								t: 57.942,
								ti: [
									-0.921,
									-0.314,
									0
								],
								to: [
									1.012,
									0.326,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.146
								},
								i: {
									x: 0.833,
									y: 0.866
								},
								s: [
									278.847,
									295.472
								],
								t: 59.94,
								ti: [
									-0.839,
									-0.305,
									0
								],
								to: [
									0.921,
									0.314,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.143
								},
								i: {
									x: 0.833,
									y: 0.869
								},
								s: [
									281.482,
									296.4
								],
								t: 61.938,
								ti: [
									-0.762,
									-0.298,
									0
								],
								to: [
									0.839,
									0.305,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.138
								},
								i: {
									x: 0.833,
									y: 0.873
								},
								s: [
									283.879,
									297.304
								],
								t: 63.936,
								ti: [
									-0.69,
									-0.293,
									0
								],
								to: [
									0.762,
									0.298,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.132
								},
								i: {
									x: 0.833,
									y: 0.879
								},
								s: [
									286.053,
									298.19
								],
								t: 65.934,
								ti: [
									-0.621,
									-0.288,
									0
								],
								to: [
									0.69,
									0.293,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.127
								},
								i: {
									x: 0.833,
									y: 0.884
								},
								s: [
									288.016,
									299.06
								],
								t: 67.932,
								ti: [
									-0.554,
									-0.284,
									0
								],
								to: [
									0.621,
									0.288,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.119
								},
								i: {
									x: 0.833,
									y: 0.893
								},
								s: [
									289.778,
									299.918
								],
								t: 69.93,
								ti: [
									-0.486,
									-0.279,
									0
								],
								to: [
									0.554,
									0.284,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.109
								},
								i: {
									x: 0.833,
									y: 0.903
								},
								s: [
									291.338,
									300.763
								],
								t: 71.928,
								ti: [
									-0.419,
									-0.273,
									0
								],
								to: [
									0.486,
									0.279,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.097
								},
								i: {
									x: 0.833,
									y: 0.914
								},
								s: [
									292.695,
									301.592
								],
								t: 73.926,
								ti: [
									-0.351,
									-0.266,
									0
								],
								to: [
									0.419,
									0.273,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.082
								},
								i: {
									x: 0.833,
									y: 0.929
								},
								s: [
									293.849,
									302.402
								],
								t: 75.924,
								ti: [
									-0.283,
									-0.258,
									0
								],
								to: [
									0.351,
									0.266,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.062
								},
								i: {
									x: 0.833,
									y: 0.947
								},
								s: [
									294.801,
									303.189
								],
								t: 77.922,
								ti: [
									-0.215,
									-0.245,
									0
								],
								to: [
									0.283,
									0.258,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.04
								},
								i: {
									x: 0.833,
									y: 0.967
								},
								s: [
									295.549,
									303.949
								],
								t: 79.92,
								ti: [
									-0.147,
									-0.225,
									0
								],
								to: [
									0.215,
									0.245,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.019
								},
								i: {
									x: 0.833,
									y: 0.985
								},
								s: [
									296.09,
									304.662
								],
								t: 81.918,
								ti: [
									-0.082,
									-0.198,
									0
								],
								to: [
									0.147,
									0.225,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.004
								},
								i: {
									x: 0.833,
									y: 0.997
								},
								s: [
									296.429,
									305.301
								],
								t: 83.916,
								ti: [
									-0.024,
									-0.164,
									0
								],
								to: [
									0.082,
									0.198,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									296.583,
									305.847
								],
								t: 85.914,
								ti: [
									0.026,
									-0.131,
									0
								],
								to: [
									0.024,
									0.164,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									296.574,
									306.285
								],
								t: 87.912,
								ti: [
									0.067,
									-0.108,
									0
								],
								to: [
									-0.026,
									0.131,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									296.425,
									306.636
								],
								t: 89.91,
								ti: [
									0.097,
									-0.091,
									0
								],
								to: [
									-0.067,
									0.108,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									296.17,
									306.934
								],
								t: 91.908,
								ti: [
									0.117,
									-0.076,
									0
								],
								to: [
									-0.097,
									0.091,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									295.842,
									307.183
								],
								t: 93.905,
								ti: [
									0.129,
									-0.065,
									0
								],
								to: [
									-0.117,
									0.076,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									295.468,
									307.393
								],
								t: 95.903,
								ti: [
									0.134,
									-0.057,
									0
								],
								to: [
									-0.129,
									0.065,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									295.071,
									307.574
								],
								t: 97.901,
								ti: [
									0.133,
									-0.051,
									0
								],
								to: [
									-0.134,
									0.057,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									294.667,
									307.733
								],
								t: 99.899,
								ti: [
									0.128,
									-0.046,
									0
								],
								to: [
									-0.133,
									0.051,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									294.272,
									307.878
								],
								t: 101.897,
								ti: [
									0.12,
									-0.044,
									0
								],
								to: [
									-0.128,
									0.046,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									293.898,
									308.012
								],
								t: 103.895,
								ti: [
									0.108,
									-0.042,
									0
								],
								to: [
									-0.12,
									0.044,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									293.554,
									308.14
								],
								t: 105.893,
								ti: [
									0.094,
									-0.041,
									0
								],
								to: [
									-0.108,
									0.042,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									293.249,
									308.264
								],
								t: 107.891,
								ti: [
									0.08,
									-0.044,
									0
								],
								to: [
									-0.094,
									0.041,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									292.988,
									308.385
								],
								t: 109.889,
								ti: [
									0.068,
									-0.055,
									0
								],
								to: [
									-0.08,
									0.044,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									292.767,
									308.528
								],
								t: 111.887,
								ti: [
									0.056,
									-0.069,
									0
								],
								to: [
									-0.068,
									0.055,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									292.579,
									308.714
								],
								t: 113.885,
								ti: [
									0.044,
									-0.082,
									0
								],
								to: [
									-0.056,
									0.069,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									292.428,
									308.941
								],
								t: 115.883,
								ti: [
									0.03,
									-0.094,
									0
								],
								to: [
									-0.044,
									0.082,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									292.318,
									309.205
								],
								t: 117.881,
								ti: [
									0.016,
									-0.105,
									0
								],
								to: [
									-0.03,
									0.094,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									292.249,
									309.504
								],
								t: 119.879,
								ti: [
									0.001,
									-0.114,
									0
								],
								to: [
									-0.016,
									0.105,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									292.223,
									309.833
								],
								t: 121.877,
								ti: [
									-0.013,
									-0.122,
									0
								],
								to: [
									-1e-3,
									0.114,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.001
								},
								i: {
									x: 0.833,
									y: 0.999
								},
								s: [
									292.242,
									310.189
								],
								t: 123.875,
								ti: [
									-0.028,
									-0.128,
									0
								],
								to: [
									0.013,
									0.122,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.003
								},
								i: {
									x: 0.833,
									y: 0.997
								},
								s: [
									292.304,
									310.564
								],
								t: 125.873,
								ti: [
									-0.042,
									-0.131,
									0
								],
								to: [
									0.028,
									0.128,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.007
								},
								i: {
									x: 0.833,
									y: 0.993
								},
								s: [
									292.408,
									310.955
								],
								t: 127.871,
								ti: [
									-0.055,
									-0.133,
									0
								],
								to: [
									0.042,
									0.131,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.012
								},
								i: {
									x: 0.833,
									y: 0.988
								},
								s: [
									292.554,
									311.353
								],
								t: 129.869,
								ti: [
									-0.031,
									-0.067,
									0
								],
								to: [
									0.055,
									0.133,
									0
								]
							},
							{
								s: [
									292.738,
									311.753
								],
								t: 131.867
							}
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									0
								],
								t: 29.97
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 39.96
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 83.916
							},
							{
								s: [
									0
								],
								t: 115.883
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "Rectangle 1",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0.012,
												10.621
											],
											[
												-5.695,
												5.34
											],
											[
												-2.557,
												-7.377
											],
											[
												3.15,
												-2.096
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "Fill 1",
								c: {
									a: 0,
									k: [
										0.137,
										0.459,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										-3.421,
										4.043
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 16
			},
			{
				ty: 4,
				nm: "Shape Layer 52",
				sr: 1,
				st: 43.956,
				op: 149.85,
				ip: 43.956,
				ln: "6946",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									109.864,
									70.089
								],
								t: 43.956
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									86.733,
									68.252
								],
								t: 45.954
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									64.924,
									89.385
								],
								t: 47.952
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									49.171,
									146.99
								],
								t: 49.95
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									70.147,
									94.506
								],
								t: 51.948
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									100.345,
									84.223
								],
								t: 53.946
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									99.102,
									64.322
								],
								t: 55.944
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									129.334,
									103.257
								],
								t: 57.942
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									98.181,
									73.031
								],
								t: 59.94
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									70.521,
									73.149
								],
								t: 61.938
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									90.481,
									75.792
								],
								t: 63.936
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									77.84,
									74.224
								],
								t: 65.934
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									63.067,
									64.426
								],
								t: 67.932
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									56.422,
									72.999
								],
								t: 69.93
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									68.741,
									79.126
								],
								t: 71.928
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									101.082,
									75.355
								],
								t: 73.926
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									143.609,
									54.475
								],
								t: 75.924
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									146.608,
									63.972
								],
								t: 77.922
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									118.472,
									92.79
								],
								t: 79.92
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									55.394,
									59.194
								],
								t: 81.918
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									33.53,
									103.661
								],
								t: 83.916
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									68.551,
									76.112
								],
								t: 85.914
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									89.966,
									83.951
								],
								t: 87.912
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									61.396,
									110.752
								],
								t: 89.91
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									55.64,
									56.936
								],
								t: 91.908
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									130.926,
									113.733
								],
								t: 93.906
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									86.439,
									76.969
								],
								t: 95.904
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									108.294,
									95.156
								],
								t: 97.902
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									58.545,
									89.141
								],
								t: 99.9
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									28.376,
									66.139
								],
								t: 101.898
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									72.983,
									43.989
								],
								t: 103.896
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									56.935,
									55.362
								],
								t: 105.894
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									51.706,
									12.909
								],
								t: 107.891
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									64.946,
									65.932
								],
								t: 109.889
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									20.13,
									72.328
								],
								t: 111.887
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									31.738,
									37.588
								],
								t: 113.885
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-14.966,
									72.869
								],
								t: 115.883
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									15.041,
									59.042
								],
								t: 117.881
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									23.68,
									76.032
								],
								t: 119.879
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									7.79,
									16.858
								],
								t: 121.877
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									37.924,
									1.088
								],
								t: 123.875
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-17.733,
									11.662
								],
								t: 125.873
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-1.626,
									56.352
								],
								t: 127.871
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									18.416,
									34.888
								],
								t: 129.869
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									43.027,
									58.529
								],
								t: 131.867
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									48.754,
									17.354
								],
								t: 133.865
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									55.61,
									17.816
								],
								t: 135.863
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									58.864,
									4.732
								],
								t: 137.861
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									47.582,
									-17.422
								],
								t: 139.859
							},
							{
								s: [
									56.939,
									20.914
								],
								t: 141.857
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									279.864,
									255.271
								],
								t: 43.956,
								ti: [
									1.691,
									-0.679,
									0
								],
								to: [
									-0.343,
									0.177,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									277.804,
									256.336
								],
								t: 45.954,
								ti: [
									3.887,
									-1.09,
									0
								],
								to: [
									-1.691,
									0.679,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									269.719,
									259.347
								],
								t: 47.952,
								ti: [
									3.906,
									1.153,
									0
								],
								to: [
									-3.887,
									1.09,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									254.482,
									262.875
								],
								t: 49.95,
								ti: [
									0.302,
									3.979,
									0
								],
								to: [
									-3.906,
									-1.153,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.012
								},
								i: {
									x: 0.833,
									y: 0.989
								},
								s: [
									246.284,
									252.432
								],
								t: 51.948,
								ti: [
									-2.124,
									4.016,
									0
								],
								to: [
									-0.302,
									-3.979,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.025
								},
								i: {
									x: 0.833,
									y: 0.98
								},
								s: [
									252.67,
									238.999
								],
								t: 53.946,
								ti: [
									-1.967,
									3.264,
									0
								],
								to: [
									2.124,
									-4.016,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.025
								},
								i: {
									x: 0.833,
									y: 0.978
								},
								s: [
									259.026,
									228.335
								],
								t: 55.944,
								ti: [
									-1.669,
									2.774,
									0
								],
								to: [
									1.967,
									-3.264,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.024
								},
								i: {
									x: 0.833,
									y: 0.98
								},
								s: [
									264.471,
									219.412
								],
								t: 57.942,
								ti: [
									-1.398,
									2.426,
									0
								],
								to: [
									1.669,
									-2.774,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.02
								},
								i: {
									x: 0.833,
									y: 0.981
								},
								s: [
									269.041,
									211.694
								],
								t: 59.94,
								ti: [
									-1.168,
									2.169,
									0
								],
								to: [
									1.398,
									-2.426,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.017
								},
								i: {
									x: 0.833,
									y: 0.985
								},
								s: [
									272.862,
									204.857
								],
								t: 61.938,
								ti: [
									-0.974,
									1.973,
									0
								],
								to: [
									1.168,
									-2.169,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.014
								},
								i: {
									x: 0.833,
									y: 0.988
								},
								s: [
									276.051,
									198.681
								],
								t: 63.936,
								ti: [
									-0.806,
									1.82,
									0
								],
								to: [
									0.974,
									-1.973,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.01
								},
								i: {
									x: 0.833,
									y: 0.991
								},
								s: [
									278.705,
									193.017
								],
								t: 65.934,
								ti: [
									-0.644,
									1.685,
									0
								],
								to: [
									0.806,
									-1.82,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.006
								},
								i: {
									x: 0.833,
									y: 0.994
								},
								s: [
									280.888,
									187.764
								],
								t: 67.932,
								ti: [
									-0.482,
									1.558,
									0
								],
								to: [
									0.644,
									-1.685,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.003
								},
								i: {
									x: 0.833,
									y: 0.997
								},
								s: [
									282.57,
									182.907
								],
								t: 69.93,
								ti: [
									-0.333,
									1.443,
									0
								],
								to: [
									0.482,
									-1.558,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.001
								},
								i: {
									x: 0.833,
									y: 0.999
								},
								s: [
									283.781,
									178.414
								],
								t: 71.928,
								ti: [
									-0.197,
									1.336,
									0
								],
								to: [
									0.333,
									-1.443,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									284.566,
									174.251
								],
								t: 73.926,
								ti: [
									-0.074,
									1.237,
									0
								],
								to: [
									0.197,
									-1.336,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									284.965,
									170.396
								],
								t: 75.924,
								ti: [
									0.038,
									1.14,
									0
								],
								to: [
									0.074,
									-1.237,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									285.012,
									166.831
								],
								t: 77.922,
								ti: [
									0.139,
									1.044,
									0
								],
								to: [
									-0.038,
									-1.14,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									284.739,
									163.555
								],
								t: 79.92,
								ti: [
									0.228,
									0.947,
									0
								],
								to: [
									-0.139,
									-1.044,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									284.178,
									160.569
								],
								t: 81.918,
								ti: [
									0.304,
									0.848,
									0
								],
								to: [
									-0.228,
									-0.947,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									283.368,
									157.874
								],
								t: 83.916,
								ti: [
									0.363,
									0.748,
									0
								],
								to: [
									-0.304,
									-0.848,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									282.355,
									155.48
								],
								t: 85.914,
								ti: [
									0.405,
									0.649,
									0
								],
								to: [
									-0.363,
									-0.748,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									281.189,
									153.386
								],
								t: 87.912,
								ti: [
									0.428,
									0.554,
									0
								],
								to: [
									-0.405,
									-0.649,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									279.927,
									151.584
								],
								t: 89.91,
								ti: [
									0.433,
									0.464,
									0
								],
								to: [
									-0.428,
									-0.554,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									278.623,
									150.062
								],
								t: 91.908,
								ti: [
									0.424,
									0.383,
									0
								],
								to: [
									-0.433,
									-0.464,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									277.326,
									148.798
								],
								t: 93.906,
								ti: [
									0.403,
									0.31,
									0
								],
								to: [
									-0.424,
									-0.383,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									276.078,
									147.765
								],
								t: 95.904,
								ti: [
									0.372,
									0.245,
									0
								],
								to: [
									-0.403,
									-0.31,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									274.911,
									146.939
								],
								t: 97.902,
								ti: [
									0.335,
									0.19,
									0
								],
								to: [
									-0.372,
									-0.245,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									273.847,
									146.293
								],
								t: 99.9,
								ti: [
									0.294,
									0.141,
									0
								],
								to: [
									-0.335,
									-0.19,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									272.9,
									145.802
								],
								t: 101.898,
								ti: [
									0.25,
									0.1,
									0
								],
								to: [
									-0.294,
									-0.141,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									272.082,
									145.445
								],
								t: 103.896,
								ti: [
									0.205,
									0.064,
									0
								],
								to: [
									-0.25,
									-0.1,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									271.398,
									145.204
								],
								t: 105.894,
								ti: [
									0.16,
									0.034,
									0
								],
								to: [
									-0.205,
									-0.064,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									270.85,
									145.06
								],
								t: 107.891,
								ti: [
									0.115,
									0.009,
									0
								],
								to: [
									-0.16,
									-0.034,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									270.438,
									144.999
								],
								t: 109.889,
								ti: [
									0.071,
									-0.011,
									0
								],
								to: [
									-0.115,
									-9e-3,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									270.159,
									145.005
								],
								t: 111.887,
								ti: [
									0.029,
									-0.027,
									0
								],
								to: [
									-0.071,
									0.011,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									270.01,
									145.067
								],
								t: 113.885,
								ti: [
									-0.01,
									-0.039,
									0
								],
								to: [
									-0.029,
									0.027,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.024
								},
								i: {
									x: 0.833,
									y: 0.965
								},
								s: [
									269.983,
									145.17
								],
								t: 115.883,
								ti: [
									-0.046,
									-0.046,
									0
								],
								to: [
									0.01,
									0.039,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.068
								},
								i: {
									x: 0.833,
									y: 0.903
								},
								s: [
									270.07,
									145.3
								],
								t: 117.881,
								ti: [
									-0.08,
									-0.05,
									0
								],
								to: [
									0.046,
									0.046,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.1
								},
								i: {
									x: 0.833,
									y: 0.872
								},
								s: [
									270.262,
									145.447
								],
								t: 119.879,
								ti: [
									-0.111,
									-0.049,
									0
								],
								to: [
									0.08,
									0.05,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.122
								},
								i: {
									x: 0.833,
									y: 0.86
								},
								s: [
									270.551,
									145.599
								],
								t: 121.877,
								ti: [
									-0.133,
									-0.043,
									0
								],
								to: [
									0.111,
									0.049,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.146
								},
								i: {
									x: 0.833,
									y: 0.85
								},
								s: [
									270.927,
									145.744
								],
								t: 123.875,
								ti: [
									-0.141,
									-0.026,
									0
								],
								to: [
									0.133,
									0.043,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.165
								},
								i: {
									x: 0.833,
									y: 0.836
								},
								s: [
									271.347,
									145.854
								],
								t: 125.873,
								ti: [
									-0.142,
									-4e-3,
									0
								],
								to: [
									0.141,
									0.026,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.163
								},
								i: {
									x: 0.833,
									y: 0.834
								},
								s: [
									271.77,
									145.903
								],
								t: 127.871,
								ti: [
									-0.143,
									0.021,
									0
								],
								to: [
									0.142,
									0.004,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.153
								},
								i: {
									x: 0.833,
									y: 0.844
								},
								s: [
									272.2,
									145.876
								],
								t: 129.869,
								ti: [
									-0.142,
									0.042,
									0
								],
								to: [
									0.143,
									-0.021,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.135
								},
								i: {
									x: 0.833,
									y: 0.863
								},
								s: [
									272.629,
									145.78
								],
								t: 131.867,
								ti: [
									-0.137,
									0.061,
									0
								],
								to: [
									0.142,
									-0.042,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.115
								},
								i: {
									x: 0.833,
									y: 0.884
								},
								s: [
									273.049,
									145.622
								],
								t: 133.865,
								ti: [
									-0.13,
									0.077,
									0
								],
								to: [
									0.137,
									-0.061,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.093
								},
								i: {
									x: 0.833,
									y: 0.907
								},
								s: [
									273.452,
									145.412
								],
								t: 135.863,
								ti: [
									-0.12,
									0.091,
									0
								],
								to: [
									0.13,
									-0.077,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.075
								},
								i: {
									x: 0.833,
									y: 0.927
								},
								s: [
									273.829,
									145.157
								],
								t: 137.861,
								ti: [
									-0.109,
									0.102,
									0
								],
								to: [
									0.12,
									-0.091,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.055
								},
								i: {
									x: 0.833,
									y: 0.945
								},
								s: [
									274.175,
									144.866
								],
								t: 139.859,
								ti: [
									-0.051,
									0.054,
									0
								],
								to: [
									0.109,
									-0.102,
									0
								]
							},
							{
								s: [
									274.483,
									144.545
								],
								t: 141.857
							}
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									0
								],
								t: 43.956
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 53.946
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 97.902
							},
							{
								s: [
									0
								],
								t: 129.869
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "Rectangle 1",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												0.012,
												10.621
											],
											[
												-5.695,
												5.34
											],
											[
												-2.557,
												-7.377
											],
											[
												3.15,
												-2.096
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "Fill 1",
								c: {
									a: 0,
									k: [
										0.137,
										0.459,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										-3.421,
										4.043
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 17
			},
			{
				ty: 4,
				nm: "Shape Layer 51",
				sr: 1,
				st: 13.986,
				op: 149.85,
				ip: 13.986,
				ln: "6945",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									121.49,
									88.737
								],
								t: 13.986
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									91.076,
									88.159
								],
								t: 15.984
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									67.412,
									108.062
								],
								t: 17.982
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									65.583,
									106.955
								],
								t: 19.98
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									54.874,
									48.475
								],
								t: 21.978
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									69.879,
									74.186
								],
								t: 23.976
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									83.434,
									108.14
								],
								t: 25.974
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									113.236,
									125.507
								],
								t: 27.972
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									72.085,
									108.002
								],
								t: 29.97
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									102.383,
									97.845
								],
								t: 31.968
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									95.054,
									74.753
								],
								t: 33.966
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									69.833,
									55.593
								],
								t: 35.964
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									71.585,
									33.206
								],
								t: 37.962
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									74.924,
									83.413
								],
								t: 39.96
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									121.778,
									73.433
								],
								t: 41.958
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									96.063,
									64.842
								],
								t: 43.956
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									89.506,
									91.864
								],
								t: 45.954
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									90.453,
									96.143
								],
								t: 47.952
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									127.532,
									66.021
								],
								t: 49.95
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									90.276,
									96.965
								],
								t: 51.948
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									88.5,
									122.317
								],
								t: 53.946
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									94.599,
									91.269
								],
								t: 55.944
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									81.585,
									110.87
								],
								t: 57.942
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									51.164,
									75.568
								],
								t: 59.94
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									46.977,
									93.082
								],
								t: 61.938
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									41.615,
									86.585
								],
								t: 63.936
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									35.186,
									124.337
								],
								t: 65.934
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									62.591,
									88.269
								],
								t: 67.932
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									58.881,
									26.321
								],
								t: 69.93
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									84.818,
									48.109
								],
								t: 71.928
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									74.254,
									46.968
								],
								t: 73.926
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									93.883,
									59.486
								],
								t: 75.924
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									86.872,
									59.571
								],
								t: 77.921
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									59.763,
									24.304
								],
								t: 79.919
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									43.653,
									28.352
								],
								t: 81.917
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									74.399,
									44.017
								],
								t: 83.915
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									36.198,
									34.152
								],
								t: 85.913
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									41.448,
									50.974
								],
								t: 87.911
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									10.923,
									53.931
								],
								t: 89.909
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									20.467,
									78.157
								],
								t: 91.907
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-1.575,
									13.482
								],
								t: 93.905
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									31.467,
									39.632
								],
								t: 95.903
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-2.832,
									75.796
								],
								t: 97.901
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									1.556,
									50.773
								],
								t: 99.899
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									39.258,
									-25.561
								],
								t: 101.897
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									53.602,
									3.457
								],
								t: 103.895
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									45.062,
									33.613
								],
								t: 105.893
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-37.848,
									-8.287
								],
								t: 107.891
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									7.213,
									56.765
								],
								t: 109.889
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									-18.526,
									38.06
								],
								t: 111.887
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									43.172,
									56.215
								],
								t: 113.885
							},
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									58.626,
									-14.531
								],
								t: 115.883
							},
							{
								s: [
									73.773,
									0.993
								],
								t: 117.881
							}
						]
					},
					p: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									272.377,
									258.087
								],
								t: 13.986,
								ti: [
									2.139,
									-0.681,
									0
								],
								to: [
									-0.394,
									0.137,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									270.01,
									258.906
								],
								t: 15.984,
								ti: [
									5.098,
									-1.104,
									0
								],
								to: [
									-2.139,
									0.681,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									259.541,
									262.172
								],
								t: 17.982,
								ti: [
									7.13,
									-0.303,
									0
								],
								to: [
									-5.098,
									1.104,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									239.424,
									265.531
								],
								t: 19.98,
								ti: [
									6.918,
									1.295,
									0
								],
								to: [
									-7.13,
									0.303,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									216.76,
									263.988
								],
								t: 21.978,
								ti: [
									5.553,
									2.383,
									0
								],
								to: [
									-6.918,
									-1.295,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									197.916,
									257.762
								],
								t: 23.976,
								ti: [
									4.294,
									2.71,
									0
								],
								to: [
									-5.553,
									-2.383,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									183.44,
									249.693
								],
								t: 25.974,
								ti: [
									3.412,
									2.643,
									0
								],
								to: [
									-4.294,
									-2.71,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									172.149,
									241.499
								],
								t: 27.972,
								ti: [
									2.824,
									2.427,
									0
								],
								to: [
									-3.412,
									-2.643,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									162.967,
									233.838
								],
								t: 29.97,
								ti: [
									2.43,
									2.167,
									0
								],
								to: [
									-2.824,
									-2.427,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									155.204,
									226.937
								],
								t: 31.968,
								ti: [
									2.166,
									1.903,
									0
								],
								to: [
									-2.43,
									-2.167,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									148.386,
									220.833
								],
								t: 33.966,
								ti: [
									1.988,
									1.643,
									0
								],
								to: [
									-2.166,
									-1.903,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									142.207,
									215.519
								],
								t: 35.964,
								ti: [
									1.866,
									1.384,
									0
								],
								to: [
									-1.988,
									-1.643,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									136.458,
									210.978
								],
								t: 37.962,
								ti: [
									1.768,
									1.113,
									0
								],
								to: [
									-1.866,
									-1.384,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									131.01,
									207.214
								],
								t: 39.96,
								ti: [
									1.677,
									0.828,
									0
								],
								to: [
									-1.768,
									-1.113,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									125.848,
									204.301
								],
								t: 41.958,
								ti: [
									1.589,
									0.546,
									0
								],
								to: [
									-1.677,
									-0.828,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									120.949,
									202.245
								],
								t: 43.956,
								ti: [
									1.493,
									0.277,
									0
								],
								to: [
									-1.589,
									-0.546,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									116.315,
									201.024
								],
								t: 45.954,
								ti: [
									1.38,
									0.034,
									0
								],
								to: [
									-1.493,
									-0.277,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									111.993,
									200.584
								],
								t: 47.952,
								ti: [
									1.254,
									-0.168,
									0
								],
								to: [
									-1.38,
									-0.034,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									108.033,
									200.82
								],
								t: 49.95,
								ti: [
									1.122,
									-0.322,
									0
								],
								to: [
									-1.254,
									0.168,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									104.469,
									201.591
								],
								t: 51.948,
								ti: [
									0.991,
									-0.429,
									0
								],
								to: [
									-1.122,
									0.322,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									101.304,
									202.75
								],
								t: 53.946,
								ti: [
									0.869,
									-0.496,
									0
								],
								to: [
									-0.991,
									0.429,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									98.52,
									204.163
								],
								t: 55.944,
								ti: [
									0.759,
									-0.533,
									0
								],
								to: [
									-0.869,
									0.496,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									96.088,
									205.725
								],
								t: 57.942,
								ti: [
									0.662,
									-0.548,
									0
								],
								to: [
									-0.759,
									0.533,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									93.965,
									207.359
								],
								t: 59.94,
								ti: [
									0.577,
									-0.547,
									0
								],
								to: [
									-0.662,
									0.548,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									92.114,
									209.011
								],
								t: 61.938,
								ti: [
									0.502,
									-0.535,
									0
								],
								to: [
									-0.577,
									0.547,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									90.501,
									210.642
								],
								t: 63.936,
								ti: [
									0.436,
									-0.515,
									0
								],
								to: [
									-0.502,
									0.535,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									89.1,
									212.221
								],
								t: 65.934,
								ti: [
									0.376,
									-0.488,
									0
								],
								to: [
									-0.436,
									0.515,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									87.887,
									213.729
								],
								t: 67.932,
								ti: [
									0.324,
									-0.458,
									0
								],
								to: [
									-0.376,
									0.488,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									86.842,
									215.15
								],
								t: 69.93,
								ti: [
									0.277,
									-0.424,
									0
								],
								to: [
									-0.324,
									0.458,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									85.945,
									216.475
								],
								t: 71.928,
								ti: [
									0.234,
									-0.388,
									0
								],
								to: [
									-0.277,
									0.424,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									85.182,
									217.694
								],
								t: 73.926,
								ti: [
									0.195,
									-0.349,
									0
								],
								to: [
									-0.234,
									0.388,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									84.541,
									218.8
								],
								t: 75.924,
								ti: [
									0.16,
									-0.31,
									0
								],
								to: [
									-0.195,
									0.349,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									84.009,
									219.79
								],
								t: 77.921,
								ti: [
									0.129,
									-0.269,
									0
								],
								to: [
									-0.16,
									0.31,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									83.578,
									220.658
								],
								t: 79.919,
								ti: [
									0.099,
									-0.226,
									0
								],
								to: [
									-0.129,
									0.269,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									83.238,
									221.401
								],
								t: 81.917,
								ti: [
									0.072,
									-0.183,
									0
								],
								to: [
									-0.099,
									0.226,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									82.984,
									222.016
								],
								t: 83.915,
								ti: [
									0.048,
									-0.14,
									0
								],
								to: [
									-0.072,
									0.183,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									82.806,
									222.502
								],
								t: 85.913,
								ti: [
									0.026,
									-0.097,
									0
								],
								to: [
									-0.048,
									0.14,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0
								},
								i: {
									x: 0.833,
									y: 1
								},
								s: [
									82.697,
									222.858
								],
								t: 87.911,
								ti: [
									0.005,
									-0.052,
									0
								],
								to: [
									-0.026,
									0.097,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.001
								},
								i: {
									x: 0.833,
									y: 0.999
								},
								s: [
									82.651,
									223.082
								],
								t: 89.909,
								ti: [
									-0.014,
									-8e-3,
									0
								],
								to: [
									-5e-3,
									0.052,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.089
								},
								i: {
									x: 0.833,
									y: 0.873
								},
								s: [
									82.666,
									223.173
								],
								t: 91.907,
								ti: [
									-0.027,
									0.032,
									0
								],
								to: [
									0.014,
									0.008,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.017
								},
								i: {
									x: 0.833,
									y: 0.973
								},
								s: [
									82.736,
									223.128
								],
								t: 93.905,
								ti: [
									-0.027,
									0.062,
									0
								],
								to: [
									0.027,
									-0.032,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.005
								},
								i: {
									x: 0.833,
									y: 0.994
								},
								s: [
									82.826,
									222.979
								],
								t: 95.903,
								ti: [
									-0.023,
									0.085,
									0
								],
								to: [
									0.027,
									-0.062,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.002
								},
								i: {
									x: 0.833,
									y: 0.998
								},
								s: [
									82.9,
									222.757
								],
								t: 97.901,
								ti: [
									-0.025,
									0.099,
									0
								],
								to: [
									0.023,
									-0.085,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.003
								},
								i: {
									x: 0.833,
									y: 0.997
								},
								s: [
									82.964,
									222.469
								],
								t: 99.899,
								ti: [
									-0.032,
									0.102,
									0
								],
								to: [
									0.025,
									-0.099,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.005
								},
								i: {
									x: 0.833,
									y: 0.995
								},
								s: [
									83.05,
									222.164
								],
								t: 101.897,
								ti: [
									-0.036,
									0.101,
									0
								],
								to: [
									0.032,
									-0.102,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.007
								},
								i: {
									x: 0.833,
									y: 0.993
								},
								s: [
									83.155,
									221.857
								],
								t: 103.895,
								ti: [
									-0.038,
									0.098,
									0
								],
								to: [
									0.036,
									-0.101,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.009
								},
								i: {
									x: 0.833,
									y: 0.992
								},
								s: [
									83.269,
									221.556
								],
								t: 105.893,
								ti: [
									-0.038,
									0.093,
									0
								],
								to: [
									0.038,
									-0.098,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.01
								},
								i: {
									x: 0.833,
									y: 0.991
								},
								s: [
									83.385,
									221.268
								],
								t: 107.891,
								ti: [
									-0.035,
									0.085,
									0
								],
								to: [
									0.038,
									-0.093,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.01
								},
								i: {
									x: 0.833,
									y: 0.991
								},
								s: [
									83.497,
									221
								],
								t: 109.889,
								ti: [
									-0.031,
									0.076,
									0
								],
								to: [
									0.035,
									-0.085,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.009
								},
								i: {
									x: 0.833,
									y: 0.992
								},
								s: [
									83.598,
									220.758
								],
								t: 111.887,
								ti: [
									-0.024,
									0.065,
									0
								],
								to: [
									0.031,
									-0.076,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.007
								},
								i: {
									x: 0.833,
									y: 0.995
								},
								s: [
									83.682,
									220.545
								],
								t: 113.885,
								ti: [
									-0.017,
									0.053,
									0
								],
								to: [
									0.024,
									-0.065,
									0
								]
							},
							{
								o: {
									x: 0.167,
									y: 0.003
								},
								i: {
									x: 0.833,
									y: 0.998
								},
								s: [
									83.745,
									220.367
								],
								t: 115.883,
								ti: [
									-6e-3,
									0.023,
									0
								],
								to: [
									0.017,
									-0.053,
									0
								]
							},
							{
								s: [
									83.781,
									220.227
								],
								t: 117.881
							}
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									0
								],
								t: 13.986
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 23.976
							},
							{
								o: {
									x: 0.333,
									y: 0
								},
								i: {
									x: 0.667,
									y: 1
								},
								s: [
									100
								],
								t: 67.932
							},
							{
								s: [
									0
								],
								t: 99.899
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "Ellipse 1",
						it: [
							{
								ty: "el",
								nm: "Ellipse Path 1",
								d: 1,
								p: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										10,
										10
									]
								}
							},
							{
								ty: "fl",
								nm: "Fill 1",
								c: {
									a: 0,
									k: [
										0.137,
										0.459,
										1
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										0,
										0
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 18
			}
		]
	},
	{
		nm: "마지막페이지",
		id: "4",
		fr: 29.97,
		layers: [
			{
				ty: 4,
				nm: "모양 레이어 6",
				sr: 1,
				st: -30,
				op: 150,
				ip: -4,
				ln: "6870",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 0,
						k: [
							100,
							100
						]
					},
					p: {
						a: 0,
						k: [
							76,
							124.5
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 0,
						k: 100
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "모양 1",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: false,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-18.125,
												-15.5
											],
											[
												-8.375,
												-6
											],
											[
												6.5,
												-20.75
											]
										]
									}
								}
							},
							{
								ty: "st",
								nm: "선 1",
								lc: 2,
								lj: 1,
								ml: 4,
								o: {
									a: 0,
									k: 100
								},
								w: {
									a: 0,
									k: 7
								},
								c: {
									a: 0,
									k: [
										0.02,
										0.455,
										0.918
									]
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										0,
										0
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "tm",
						nm: "패스 다듬어 자르기 1",
						e: {
							a: 1,
							k: [
								{
									o: {
										x: 0.333,
										y: 0
									},
									i: {
										x: 0.667,
										y: 1
									},
									s: [
										0
									],
									t: 0
								},
								{
									s: [
										100
									],
									t: 6
								}
							]
						},
						o: {
							a: 0,
							k: 0
						},
						s: {
							a: 0,
							k: 0
						},
						m: 1
					}
				],
				ind: 1
			},
			{
				ty: 4,
				nm: "모양 레이어 5",
				sr: 1,
				st: -28,
				op: 152,
				ip: 1,
				ln: "6869",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							0,
							0
						]
					},
					s: {
						a: 0,
						k: [
							100,
							100
						]
					},
					p: {
						a: 0,
						k: [
							85.375,
							124.5
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 0,
						k: 100
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "모양 2",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: false,
										i: [
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											]
										],
										v: [
											[
												-17.875,
												-15.25
											]
										]
									}
								}
							},
							{
								ty: "st",
								nm: "선 1",
								lc: 1,
								lj: 1,
								ml: 4,
								o: {
									a: 0,
									k: 100
								},
								w: {
									a: 0,
									k: 7
								},
								c: {
									a: 0,
									k: [
										0.22,
										0.824,
										0
									]
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										0,
										0
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "gr",
						nm: "모양 1",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: false,
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												-0.75,
												-5.75
											],
											[
												7.75,
												-14.25
											]
										]
									}
								}
							},
							{
								ty: "st",
								nm: "선 1",
								lc: 2,
								lj: 1,
								ml: 4,
								o: {
									a: 0,
									k: 100
								},
								w: {
									a: 0,
									k: 7
								},
								c: {
									a: 0,
									k: [
										0.22,
										0.824,
										0
									]
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										0,
										0
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					},
					{
						ty: "tm",
						nm: "패스 다듬어 자르기 1",
						e: {
							a: 1,
							k: [
								{
									o: {
										x: 0.333,
										y: 0
									},
									i: {
										x: 0.667,
										y: 1
									},
									s: [
										0
									],
									t: 3
								},
								{
									s: [
										100
									],
									t: 9
								}
							]
						},
						o: {
							a: 0,
							k: 0
						},
						s: {
							a: 0,
							k: 0
						},
						m: 1
					}
				],
				ind: 2
			},
			{
				ty: 4,
				nm: "레이어 4 윤곽선",
				sr: 1,
				st: 15,
				op: 151,
				ip: 10,
				ln: "31",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							4.733,
							4.732
						]
					},
					s: {
						a: 1,
						k: [
							{
								s: [
									63,
									63,
									98.438
								],
								i: {
									x: [
										0.667,
										0.667,
										0.667
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.333,
										0.333,
										0.333
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 12
							},
							{
								s: [
									142,
									142,
									100.709
								],
								i: {
									x: [
										0.667,
										0.667,
										0.667
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.333,
										0.333,
										0.333
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 19
							},
							{
								s: [
									100,
									100,
									100
								],
								i: {
									x: [
										0.667,
										0.667,
										0.667
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.333,
										0.333,
										0.333
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 22
							}
						]
					},
					p: {
						a: 0,
						k: [
							90.85,
							95.443
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									0
								],
								t: 10
							},
							{
								s: [
									100
								],
								t: 20
							}
						]
					}
				},
				shapes: [
					{
						ty: "gr",
						nm: "그룹 1",
						it: [
							{
								ty: "sh",
								nm: "패스 1",
								d: 1,
								ks: {
									a: 0,
									k: {
										c: true,
										i: [
											[
												1.595,
												1.595
											],
											[
												1.596,
												-1.595
											],
											[
												-1.595,
												-1.595
											],
											[
												-1.596,
												1.595
											]
										],
										o: [
											[
												-1.596,
												-1.595
											],
											[
												-1.595,
												1.595
											],
											[
												1.596,
												1.595
											],
											[
												1.595,
												-1.595
											]
										],
										v: [
											[
												2.888,
												-2.887
											],
											[
												-2.888,
												-2.887
											],
											[
												-2.888,
												2.887
											],
											[
												2.888,
												2.887
											]
										]
									}
								}
							},
							{
								ty: "fl",
								nm: "칠 1",
								c: {
									a: 0,
									k: [
										0.02,
										0.455,
										0.918
									]
								},
								r: 1,
								o: {
									a: 0,
									k: 100
								}
							},
							{
								ty: "tr",
								a: {
									a: 0,
									k: [
										0,
										0
									]
								},
								s: {
									a: 0,
									k: [
										100,
										100
									]
								},
								p: {
									a: 0,
									k: [
										4.733,
										4.732
									]
								},
								r: {
									a: 0,
									k: 0
								},
								sa: {
									a: 0,
									k: 0
								},
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				],
				ind: 3
			},
			{
				ty: 5,
				nm: "잔액모으기 완료",
				sr: 1,
				st: 0,
				op: 180,
				ip: 0,
				ln: "10425",
				hasMask: false,
				ao: 0,
				ks: {
					a: {
						a: 0,
						k: [
							31.964,
							-3.929
						]
					},
					s: {
						a: 1,
						k: [
							{
								s: [
									0,
									0,
									100
								],
								i: {
									x: [
										0.667,
										0.667,
										0.667
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.333,
										0.333,
										0.333
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 12
							},
							{
								s: [
									125,
									125,
									100.806
								],
								i: {
									x: [
										0.667,
										0.667,
										0.667
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.333,
										0.333,
										0.333
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 19
							},
							{
								s: [
									104,
									104,
									99.048
								],
								i: {
									x: [
										0.667,
										0.667,
										0.667
									],
									y: [
										1,
										1,
										1
									]
								},
								o: {
									x: [
										0.333,
										0.333,
										0.333
									],
									y: [
										0,
										0,
										0
									]
								},
								t: 22
							}
						]
					},
					p: {
						a: 0,
						k: [
							75.875,
							140.625
						]
					},
					r: {
						a: 0,
						k: 0
					},
					sa: {
						a: 0,
						k: 0
					},
					o: {
						a: 1,
						k: [
							{
								o: {
									x: 0.167,
									y: 0.167
								},
								i: {
									x: 0.833,
									y: 0.833
								},
								s: [
									0
								],
								t: 12
							},
							{
								s: [
									100
								],
								t: 22
							}
						]
					}
				},
				t: {
					m: {
						a: {
							a: 0,
							k: [
								0,
								0
							]
						},
						g: 1
					},
					p: {
						f: {
							a: 0,
							k: 0
						},
						l: {
							a: 0,
							k: 0
						},
						r: {
							a: 0,
							k: 0
						},
						a: {
							a: 0,
							k: 0
						},
						p: {
							a: 0,
							k: 0
						}
					},
					a: [
					],
					d: {
						k: [
							{
								s: {
									f: "NotoSansKR-Bold",
									s: 10,
									t: "잔액모으기 완료",
									fc: [
										0.047,
										0.228,
										0.4
									],
									lh: 12,
									tr: -41,
									j: 0,
									ca: 0
								},
								t: 0
							}
						]
					}
				},
				ind: 4
			}
		]
	},
	{
		id: "13",
		e: 1,
		w: 445,
		h: 129,
		p: "data:image/webp;base64,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",
		u: ""
	},
	{
		id: "18",
		e: 1,
		w: 70,
		h: 70,
		p: "data:image/webp;base64,UklGRrIDAABXRUJQVlA4WAoAAAAQAAAARQAARQAAQUxQSMYAAAABgFXbbt3oQjAEQTAEQSiEMKgZOBDKwGVgCIZgCIIgCOpr8pK+Z0XEBGA71y5qF9TZS8bRqapdWpZDUlW7vCz7WMzlpB138yp5UzW/yhvu5lnzH9l8C/1I4szGj2ruGQCZ/wmgBWAMSAQDbBFqWkMwHjGUGUOzGMf/UjQIiaE9YyglBs4hKDAiaECJIANJ/Q0AKP7oC8Pbip+kvgR/ZvUk9Bdu6kcIW7N4mYTt9PTxSNi9yPUG49Bbv5Q+GIcnXvu4Ym+FsRNWUDggxgIAAPAPAJ0BKkYARgA+bTKVR6QioiGqVAjwgA2JZghwAVQEyzP23ozW2g8wHnH+kD/b77x6AHS4lexmceQpikgmGSEAQAC7QFrgWb8tOcnS+0lYS3L3tE9vuaqz2OT5lC7K8jG2DXsUmeqpfq0xohz74zQIDxM0hHbRNH8JLzbge/cohaYrsnvDbAAA/v5gu5sOgMcesVxaONxBO7FYoJTrEvd8B0RcRISgC6ysl137EplWT9uiOHsa3sLp6cihfhMhL4rSG/xa+HGWjonFy4QjOmuAk2tzsE74+GGKdZ9vX+/j4tGElRkNoJTtH8N8EeGSEZWbsXhbT6fcL9Ja6EPjRHiO/DEzlgtVvXebKnPJlriLGxM/X61/KsfsCEHe9y0zpnZtUYVryaIDnAp+GPaoOfaA6lnVQl3qYYFtR9dwa+iXMYMxWZs9GoWv/Nad+u7EXmPm312JYWmud166B6EwBQ8XvQ2azGAOG78Avb8xgl1CRkKVzaznS+zN5NWRZ2+0Oax2sv3pg3+3IckBRB1o3skaKouvDW4w7H6C8tB8OhOYwsKOMronjjXeoUgamoNuUjG5hMOKTGarSxVX7+2nOhN2XkkIX8f9K63Lq7GbyUj8yinECZvZaBjVdodBVcRO/iCLPzEq5ZTmr0aPnHecDE4vSPithy91H5AC58GpBh+3Bn5NFp5SGXBejWxurJ/wyy2znrUBjzJkcN+ZReoS7g28GT/h3vS8TL/P/Dgg9qa6OWb/40iP1ShOR8C9IWyMrX91bydHelqV4umEk1tQH26cozZduYEv8fsNOMFgK8RolfsrZFhGmvM53LPd9O1yHNE412rOJkTMgILsV7Ew9tc9OlkqP1UI1x84AD+/k5uFTiXo2KIOf7UYLzYVyck9kXbLhHyl2+in3ARaOC1nQWWuGmF4Zl/OCZbrH6v/vOE70QQ+AAAA",
		u: ""
	},
	{
		id: "20",
		e: 1,
		w: 175,
		h: 362,
		p: "data:image/webp;base64,UklGRuAEAABXRUJQVlA4WAoAAAAQAAAArgAAaQEAQUxQSHoCAAANkFzbtiMnV97bKd5OkSKgFQGdAUUENBlUCCICShkUGVRngOZ4M2X1VK7e5P+SP+utJxcRECTJjdvM2rAXRSC3AFV+oJNp7vm9+3O61Pr7/+s/nZU2it5LXXrdX3++2NT16AwoBqLQSq+/1ZQ/T/uuFIpW+uXwVG8eV+LR2w/V9okZFCLSSrnZH52MSlR6vdP/cgJWG3FppflYHf+shaZPw2MfjQT3+FwfV4GnaruzYCA+VnaKjo/zuABEj96VXTlEvd9tsokvSFVFSknJo60K9VUqy6wL5stmLW0IVEWF6qU3w5F6pKjXzL2E5blgucfKq937rGhiDpYxeVdG2dYycyuDTLCr1fXf+YQ5nm5p2LMNtix2p+mV2h147K5WXt5VrsQaeXkTDIZpGrMmGHaVK7XhHwyNTJE7noK3kfn4eu/dIzEbguF6H7tHcNN5mXOPcPYzRUKZoqDMdExZEJi8LBjSXjXeHf64xstHcE0YlPn2SG6iYM9uk3ZjkN8ejV9n2ARNV2hpGXQ6CIwpdNMGe4/o3zLvNgrddMK4MMdT9KZ9PPy9mhbsy5jMqyYkyoLBBMXi6tcjoWBMvv2fiHeHP24j75pWtKGFbRS8N10GeySfpmFgQuG2wARrcFeroN1VzFJoxxMuSjBAxjoCpdgxTpNeTcc4aWFN2qcFNBPU6TQIkLFOCD/euJhRmxpM0tojQCbyQJtmvt4fATLJHuRP0112CMgU+5EWlkOBwpxuOeEtYwbQTHePpwPCMJYFSqbzI6xlSvvtAzKrVKkBZCZ7tpjpDM7Qzb7RmiNAxjrDHmCYPSZ9BAh3GaXyQIv5FunOf+78585/ruYRVlA4IEACAACQHwCdASqvAGoBPm02mEgkI6KhJtuIGIANiWlu4XQuArdaabRYPSLhpxy/xmCG9YvYr1jx2yASik+UNAbPsDK0pgjH1W8FYeXbhHDSLuA4xZwQlZd2az6gf49o4SUW349o4SUW340W11hpDwuRQ9hCOsuElFmoXXiyhwbZNGx98KkotzlcdOj3OoLBKLc+UXvejk5Z3SHhciwjLUQUS5NaiAKHk9McSb4XIsvayMk5km+FyLFP6UgKGFKHBtVQSsHzjl34fQ9Ayw+7REVqo4b+GrJRKLQdZUHWqhqLuA5fLKsMFWI2HoNfCXtMoZI6ul4cG2XSHhcmtRbn1BD6gh9QQ+oIfHAA/vRTYbpIUB5Kjipm4r08m9bR6Io/Ug2Dvb/V+qiU43ULkrN72uNMbsMDSTVWFKccgmD5qnHc//NDncuDEyMJ4i2LorcC5OTVTWXYQr+h5TFW7kI6JHD89I7PP8mj2WtMVTqr5n4yVX6OoqNySFqbJv+wqp+MoHiOZDHdN+UHWKzLCyPm258ANobtoCK43wYRqTisqvKi3ngX+6oYTz4SQ//brpRZ8udh+fQXr3q+yfFUdJQFvBepxrVpzhnFG8EEkmP7Mqu5d3aiMvN/jRJl25v+C7yu71wwC3o04YhIiD1nPUX0Wbs6lMM9A2tJ+CafR6tQQzH9pa4Z8mYbhzNXiv1zsaTX4cUGTVkBSluHM+igfjqzsZm/44iA3r+tEPSnYmSLXvN58Ni5wSyGbBNqPmGPCfv5agAAAAA=",
		u: ""
	}
];
const Balance_Consolidation = {
	nm: nm,
	h: h,
	w: w,
	meta: meta,
	layers: layers,
	v: v,
	fr: fr,
	op: op,
	ip: ip,
	fonts: fonts,
	chars: chars,
	assets: assets
};

export { assets, chars, Balance_Consolidation as default, fonts, fr, h, ip, layers, meta, nm, op, v, w };
